import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { DatePicker as AntdDatePicker } from 'antd'; // Add this import for multi-date picker
import { generateScheduleDates } from '../../../../utils/scheduleUtils';
import QuestionDisplay from '../../../../components/QuestionDisplay';
import CustomAssessmentSectionCreator from 'components/CustomAssessment/CustomAssessmentSectionCreator';
import CustomAssessmentSectionConfigTable from 'components/CustomAssessment/CustomAssessmentSectionConfigTable';
import CustomSectionQuestionsViewer from 'components/CustomAssessment/CustomSectionQuestionsViewer';
import CreateAIInterview from 'modules/AIInterview/CreateAIInterview';
import { v4 as uuidv4 } from 'uuid'
import {
  getEligibilityCriteria,
  setAssessmentCreationData,
  addBulkUploadData,
  removeAssessment,
  fetchAptitudeTopics,
  fetchAptitudeConfig,
  checkAptitudeTopicAvailability,
  createCustomSectionQuestions,
  fetchCustomSections
} from '../../actions'
import { generateRoleBasedQuestions, generateTopicBasedQuestions } from '../../actions'
import { selectRoleBasedQuestions, selectTopicBasedQuestions, selectAptitudeConfig } from '../../selectors'
import { assignRoleBasedAssessment, assignAIInterview } from '../../actions';
import { selectRoleBasedAssessment } from '../../selectors';
import { useNavigate } from 'react-router-dom';
import { initiateRoleBasedGeneration, createBroadcast, getBroadcastPassingYears } from '../../services/assessmentSetGroupAPI';
import { Modal as AntModal } from 'antd';

import {
  selectFormattedDegreeResults,
  selectFormattedAptitudeTopics,
  selectAptitudeTopicsLoading,
  selectAptitudeTopicsError,
} from '../../selectors'
import AddAnotherButton from 'components/AddAnotherButton'
import BulkUploadDrawer from './Drawers/BulkUploadDrawer'
import EnhancedBulkUploadDrawer from './Drawers/EnhancedBulkUploadDrawer'
import ConfirmationIcon from '../../../../components/icons/Confirmation'
import InstructionsDrawer from './Drawers/InstructionsDrawer'
import ConfirmationDialog from 'components/ConfirmationDialog'
import DeleteConfirmation from 'components/icons/deleteconfirmation'
import CustomDateCalendarDrawer from './Drawers/CustomDateCalendarDrawer' // Add this import
import DomainSelection from 'components/DomainSelection/DomainSelection'

import {
  Radio,
  message,
  Button,
  Checkbox,
  Row,
  Col,
  Select,
  Card,
  Typography,
  Calendar,
  Form,
  Input,
  InputNumber,
  Badge,
  Tag,
  Switch,
  Tooltip,
} from 'antd'
import { COLORS } from 'theme'

import DatePicker from 'components/DatePickerStyles/DatePicker'
import { TimeStyles } from 'components/DatePickerStyles/DatePickerStyles'
import moment from 'moment'
import Clock from 'components/icons/Clock'
import Label from 'components/Form/Label'
import {
  LeftOutlined,
  RightOutlined,
  DatabaseOutlined,
  FolderOutlined,
  FileTextOutlined,
  PlusOutlined,
  FolderOpenOutlined,
  FileExcelOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  SettingOutlined,
  EditOutlined,
  EyeOutlined,
  CheckOutlined,
  ReadOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  EditFilled,
  SoundOutlined,
  FormOutlined,
  OrderedListOutlined,
  PictureOutlined,
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons';

// Import the new typography components
import {
  AssessmentContainer,
  Title,
  ButtonGroup,
  SaveButton,
  SavedAssessmentContainer,
  EditButton,
  DeleteButton,
  DescriptionHeader,
  AssessmentLinkInput,
  FormItem,
  AssessmentName,
  Grid,
  AssessmentLinkSection,
  DescriptionText,
  StyledSearchInput,
  StyledSearchSection,
  StyledSelect,
  SelectionColumn,
  SelectionRow,
  StreamRadioGroup,
  DifficultyContainer,
  DifficultyTitle,
  ContinueBtn,
  ClearAllButton,
  SummaryText,
  SelectionCount,
  SelectionCountText,
  FooterSelectionSummary,
  FooterRightSection,
  FooterLeftSection,
  ModalFooter,
  CategoryDescription,
  CategoryTitle,
  CategoryClearButton,
  CategoryCounter,
  CategoryRightSection,
  CategoryTitleRow,
  CategoryLeftSection,
  CategoryHeader,
  MinSelectionMessage,
  TopicItem,
  TopicsGrid,
  MainContent,
  SidebarTab,
  Sidebar,
  ModalBody,
  CloseButton,
  ModalTitle,
  ModalHeader,
  ModalContainer,
  ModalOverlay,
  AptitudeTypeTitle,
  AptitudeTypeCard,
  AptitudeTypeCardsContainer,
  Separator,
  // Add the new typography components
  SectionHeading,
  SubsectionHeading,
  BodyText,
  CaptionText,
  SmallText,
  ConfigurationText,
  ValidationErrorText,
  InfoBadge,
  CountBadge,
  AssessmentConfigContainer,
  ConfigurationItem,
  ConfigurationNote,
  ConfigurationDetails,
  ConfigurationSummary,
  ConfigurationDetailsContent,
  ConfigurationDetailItem,

  MainContainer,
  LeftContent,
  RightSidebar,
  InfoCard,
  CardTitle,
  CardSubtitle,
  SectionButton,
  DetailItem,
  DetailLabel,
  DetailValue,
  SectionContent,


} from '../../Style/assessmentstyles'

import UploadButtons from 'components/Button/UploadButtons'
import styled from 'styled-components'

const { Text } = Typography

const CUSTOM_ASSESSMENT_TEMPLATE_URL = 'https://bmv2bqg5gpcd.compat.objectstorage.ap-mumbai-1.oraclecloud.com/pl-uat-public-docs/templates/custom-assessment-bulk-upload-template.xlsx'

// Floor on the aptitude topic selection — same for institute and corporate.
// admin-node enforces the identical number server-side (MIN_APTITUDE_TOPICS in
// helpers/aptitudeDistribution.js); keep the two in step.
const MIN_APTITUDE_TOPICS = 10

const APTITUDE_TYPE_LABELS = {
  quantitative: 'Quantitative',
  logical_reasoning: 'Logical Reasoning',
  critical_reasoning: 'Critical Reasoning',
}

const SidebarTabWithIndicator = ({
  category,
  label,
  isActive,
  onClick,
  selectedTopics,
}) => {
  const selectedCount = selectedTopics[category]?.length || 0
  const hasSelectedTopics = selectedCount > 0

  return (
    <SidebarTab
      active={isActive}
      hasSelectedTopics={hasSelectedTopics}
      selectedCount={selectedCount}
      onClick={onClick}
    >
      {label}
    </SidebarTab>
  )
}

const TopicSelectionModal = ({
  showModal,
  setShowModal,
  onContinue,
  loading = false,
  minTopicsRequired = 10,
  formattedAptitudeTopics = {},
  initialSelectedTopics = {},
}) => {
  const [activeTab, setActiveTab] = useState('quantitative')
  const [selectedTopics, setSelectedTopics] = useState({})
  const [showMinSelectionMessage, setShowMinSelectionMessage] = useState(false)

  // Create topics data from formattedAptitudeTopics or fallback
  const createTopicsData = () => {
    const hasApiData =
      formattedAptitudeTopics && Object.keys(formattedAptitudeTopics).length > 0

    if (hasApiData) {
      return {
        quantitative: {
          title: 'Quantitative Aptitude',
          topics:
            formattedAptitudeTopics.quantitative?.map(topic => topic.name) ||
            [],
        },
        logical_reasoning: {
          title: 'Logical Reasoning',
          topics:
            formattedAptitudeTopics.logical_reasoning?.map(
              topic => topic.name
            ) || [],
        },
        critical_reasoning: {
          title: 'Critical Reasoning',
          topics:
            formattedAptitudeTopics.critical_reasoning?.map(
              topic => topic.name
            ) || [],
        },
      }
    }

    // Fallback data
    return {
      quantitative: {
        title: 'Quantitative Aptitude',
        topics: [
          'Number System',
          'Time, Speed, and Distance',
          'Time and Work',
          'Profit and Loss',
          'Percentages',
          'Ratio & Proportion',
          'Pipes and Cisterns',
          'Averages',
          'Permutations & Combinations (P&C)',
          'Simple & Compound Interest',
          'Mixtures and Alligations',
          'Probability',
        ],
      },
      logical_reasoning: {
        title: 'Logical Reasoning',
        topics: [
          'Coding-Decoding',
          'Seating Arrangement',
          'Puzzles (Logic Puzzles)',
          'Blood Relations',
          'Number/Letter Series',
          'Direction Sense',
          'Syllogisms',
          'Input-Output',
          'Data Sufficiency',
          'Analogy',
          'Odd One Out',
        ],
      },
      critical_reasoning: {
        title: 'Critical Reasoning',
        topics: [
          'Statement & Assumptions',
          'Conclusions & Inferences',
          'Statement & Arguments',
          'Course of Action',
          'Cause & Effect',
          'Facts, Inferences & Judgements',
          'Paradox Questions',
        ],
      },
    }
  }

  const topicsData = createTopicsData()

  // Initialize with all topics selected by default
  useEffect(() => {
    if (Object.keys(selectedTopics).length === 0) {
      const allSelected = {}
      Object.keys(topicsData).forEach(category => {
        allSelected[category] = [...topicsData[category].topics]
      })
      setSelectedTopics(allSelected)
    }
  }, [])

  const handleTopicToggle = (category, topic) => {
    if (!category || !topic) return

    setSelectedTopics(prev => {
      const isCurrentlySelected = prev[category]?.includes(topic) || false

      if (isCurrentlySelected) {
        setShowMinSelectionMessage(false)
        return {
          ...prev,
          [category]: (prev[category] || []).filter(t => t !== topic),
        }
      } else {
        setShowMinSelectionMessage(false)
        return {
          ...prev,
          [category]: [...(prev[category] || []), topic],
        }
      }
    })
  }

  const handleClearCategory = category => {
    setSelectedTopics(prev => ({
      ...prev,
      [category]: [],
    }))
    setShowMinSelectionMessage(false)
  }

  const getTotalSelectedTopics = () => {
    return Object.values(selectedTopics).reduce(
      (total, topics) => total + (topics?.length || 0),
      0
    )
  }

  const getSelectedSections = () => {
    return Object.values(selectedTopics).filter(
      topics => topics && topics.length > 0
    ).length
  }

  const handleSelectAllTopics = () => {
    const allSelected = {}
    Object.keys(topicsData).forEach(category => {
      allSelected[category] = [...topicsData[category].topics]
    })
    setSelectedTopics(allSelected)
    setShowMinSelectionMessage(false)
  }

  const handleContinueWithTopics = () => {
    const totalSelected = getTotalSelectedTopics()

    if (totalSelected < minTopicsRequired) {
      setShowMinSelectionMessage(true)
      setTimeout(() => {
        setShowMinSelectionMessage(false)
      }, 3000)
      return
    }

    onContinue(selectedTopics)
  }

  if (!showModal) return null

  return (
    <ModalOverlay onClick={() => setShowModal(false)}>
      <ModalContainer onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Select Assessment Topics</ModalTitle>
          <CloseButton onClick={() => setShowModal(false)}>
            <CloseOutlined />
          </CloseButton>
        </ModalHeader>

        <ModalBody>
          <Sidebar>
            <SidebarTabWithIndicator
              category="quantitative"
              label="Quantitative Aptitude"
              isActive={activeTab === 'quantitative'}
              onClick={() => setActiveTab('quantitative')}
              selectedTopics={selectedTopics}
            />
            <SidebarTabWithIndicator
              category="logical_reasoning"
              label="Logical Reasoning"
              isActive={activeTab === 'logical_reasoning'}
              onClick={() => setActiveTab('logical_reasoning')}
              selectedTopics={selectedTopics}
            />
            <SidebarTabWithIndicator
              category="critical_reasoning"
              label="Critical Reasoning"
              isActive={activeTab === 'critical_reasoning'}
              onClick={() => setActiveTab('critical_reasoning')}
              selectedTopics={selectedTopics}
            />
          </Sidebar>

          <MainContent>
            {showMinSelectionMessage && (
              <MinSelectionMessage>
                {/* <span>⚠️</span> */}
                Please select at least {minTopicsRequired} topics to continue.
              </MinSelectionMessage>
            )}

            {topicsData[activeTab] && (
              <>
                <CategoryHeader>
                  <CategoryLeftSection>
                    <CategoryTitle>{topicsData[activeTab].title}</CategoryTitle>
                  </CategoryLeftSection>
                  <CategoryRightSection>
                    <CategoryCounter
                      count={selectedTopics[activeTab]?.length || 0}
                    >
                      {selectedTopics[activeTab]?.length || 0} selected
                    </CategoryCounter>
                    <CategoryClearButton
                      onClick={() => handleClearCategory(activeTab)}
                      disabled={
                        !selectedTopics[activeTab] ||
                        selectedTopics[activeTab].length === 0
                      }
                    >
                      Clear All
                    </CategoryClearButton>
                  </CategoryRightSection>
                </CategoryHeader>

                <TopicsGrid>
                  {(topicsData[activeTab].topics || []).map((topic, index) => {
                    const isSelected =
                      selectedTopics[activeTab]?.includes(topic) || false
                    return (
                      <TopicItem
                        key={index}
                        isSelected={isSelected}
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          handleTopicToggle(activeTab, topic)
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => { }}
                          onClick={e => {
                            e.stopPropagation()
                          }}
                        />
                        <span>{topic}</span>
                      </TopicItem>
                    )
                  })}
                </TopicsGrid>
              </>
            )}

            {!topicsData[activeTab] && (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <Text type="secondary">Loading topics...</Text>
              </div>
            )}
          </MainContent>
        </ModalBody>

        <ModalFooter>
          <FooterLeftSection>
            <SelectionCountText>
              <SelectionCount count={getSelectedSections()}>
                {getSelectedSections()}
              </SelectionCount>
              {' sections/'}
              <SelectionCount count={getTotalSelectedTopics()}>
                {getTotalSelectedTopics()}
              </SelectionCount>
              {' Topics '}
              <strong>selected</strong>
            </SelectionCountText>
          </FooterLeftSection>

          <FooterRightSection>
            <ContinueBtn onClick={handleContinueWithTopics} disabled={loading}>
              {loading ? 'Processing...' : 'Continue'}
            </ContinueBtn>
          </FooterRightSection>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  )
}

// Shared constants for communication section groups
const SECTION_GROUP_MAP = {
  'Reading': ['Paragraph Reading'],
  'Listening': ['Audio Question'],
  'Speaking': ['Video Response'],
  'Writing': ['Question Based Response', 'Email Writing', 'Dictation', 'Sentence Completion', 'Sentence Build'],
};
const ALL_GROUP_KEYS = ['Reading', 'Listening', 'Speaking', 'Writing'];

// Listening-audio accents (mapped to Google TTS voices on the backend).
// 'en-IN' is the default — every pre-existing set uses it, so it reuses the
// existing set pool; any other accent generates a fresh set on assignment.
const LISTENING_ACCENTS = [
  { value: 'en-IN', label: 'Indian English (default)' },
  { value: 'en-US', label: 'US English' },
];

// Normalize old subsection-level enabledSections to group-level
const SUBSECTION_TO_GROUP = {
  'Paragraph Reading': 'Reading',
  'Audio Question': 'Listening',
  'Video Response': 'Speaking',
  'Question Based Response': 'Writing',
  'Email Writing': 'Writing',
  'Dictation': 'Writing',
  'Sentence Completion': 'Writing',
  'Sentence Build': 'Writing',
};
function normalizeEnabledSections(sections) {
  if (!sections || sections.length === 0) return [...ALL_GROUP_KEYS];
  const isOldFormat = sections.some(s => s in SUBSECTION_TO_GROUP);
  if (!isOldFormat) return sections;
  return [...new Set(sections.map(s => SUBSECTION_TO_GROUP[s] || s))];
}

// Expand group-level sections to subsection names for backend
function expandSectionsForBackend(groups) {
  if (!groups || groups.length === 0) return [];
  if (groups.length === ALL_GROUP_KEYS.length && ALL_GROUP_KEYS.every(g => groups.includes(g))) return [];
  return groups.flatMap(g => SECTION_GROUP_MAP[g] || []);
}

const defaultFormState = {
  id: null,
  assessmentType: null,
  name: '',
  startDate: moment().startOf('day'),
  endDate: null,
  startTime: moment(),
  endTime: moment('23:59', 'HH:mm'),
  selectedStreams: [],
  cefrLevel: null,
  accent: 'en-IN',
  enabledSections: ['Reading', 'Listening', 'Speaking', 'Writing'],
  selectedDomain: '',
  qualificationData: [],
  selectedDegrees: [],
  isSaved: false,
  instructions: '',
  allowProctoring: true,
  allowVerification: true,
  assessmentLink: null,
  isCheckboxSelected: false,
  selectedItems: 'ALL',
  selectedStudents: [],
  isBroadcast: false,
  broadcastScope: [],
  broadcastLabelSpecialisations: [],
}

// 45 min => 30 questions, 60 min => 40 questions.
// Difficulty mix: Easy 60/30/10, Medium 30/50/20, Hard 20/50/30.
const questionConfigurations = {
  30: {
    easy: { total: 25, easy: 13, medium: 7, hard: 5 },
    medium: { total: 25, easy: 7, medium: 13, hard: 5 },
    hard: { total: 25, easy: 8, medium: 8, hard: 9 },
  },
  45: {
    easy: { total: 30, easy: 18, medium: 9, hard: 3 },
    medium: { total: 30, easy: 9, medium: 15, hard: 6 },
    hard: { total: 30, easy: 6, medium: 15, hard: 9 },
  },
  60: {
    easy: { total: 40, easy: 24, medium: 12, hard: 4 },
    medium: { total: 40, easy: 12, medium: 20, hard: 8 },
    hard: { total: 40, easy: 8, medium: 20, hard: 12 },
  },
}

const aptitudeQuestionCountByDuration = {
  30: 25,
  45: 30,
  60: 40,
}



const InstituteInfoCard = ({ instituteData, assessmentDetails, formData, onViewCalendar }) => {
  const [expandedSection, setExpandedSection] = useState('assessment');

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  // Helper function to format frequency display
  const formatFrequency = (formData) => {
    if (!formData.frequencyType || !formData.frequencyValue) {
      return 'Not configured';
    }

    switch (formData.frequencyType) {
      case 'DAILY':
        if (formData.frequencyValue === 1) {
          return 'Every Day';
        }
        return `Every ${formData.frequencyValue} Days`;

      case 'WEEKLY':
        const dayMap = {
          'MONDAY': 'Monday',
          'TUESDAY': 'Tuesday',
          'WEDNESDAY': 'Wednesday',
          'THURSDAY': 'Thursday',
          'FRIDAY': 'Friday',
          'SATURDAY': 'Saturday',
          'SUNDAY': 'Sunday'
        };
        return `Every ${dayMap[formData.frequencyValue] || formData.frequencyValue}`;

      case 'MONTHLY':
        const day = formData.frequencyValue;
        const suffix = day === 1 ? 'st' : day === 2 ? 'nd' : day === 3 ? 'rd' : 'th';
        return `On the ${day}${suffix} of every month`;

      case 'CUSTOM':
        if (Array.isArray(formData.frequencyValue)) {
          return `Custom dates (${formData.frequencyValue.length} of ${formData.frequencyValue.length} selected)`;
        }
        return 'Custom dates';

      default:
        return 'Not configured';
    }
  };

  // Helper function to format assignment pattern
  const formatAssignmentPattern = (formData) => {
    if (formData.distributionType === 'scheduled') {
      const validityDays = formData.assessmentValidityDays;
      const validityText = validityDays === 1 ? '1 day' : `${validityDays} days`;
      return `One assessment per candidate with ${validityText} validity`;
    } else {
      return 'One-time assessment for all candidates';
    }
  };

  // Helper function to calculate total rounds/duration
  const calculateTotalRounds = (formData) => {
    if (formData.distributionType === 'scheduled' && formData.startDate && formData.endDate) {
      const start = moment(formData.startDate);
      const end = moment(formData.endDate);
      const totalDays = end.diff(start, 'days') + 1;

      if (formData.frequencyType === 'DAILY') {
        const interval = formData.frequencyValue || 1;
        const assessmentDays = Math.ceil(totalDays / interval);
        return `${assessmentDays} scheduled assessments over ${totalDays} days`;
      } else if (formData.frequencyType === 'WEEKLY') {
        const weeks = Math.ceil(totalDays / 7);
        return `${weeks} weekly assessments`;
      } else if (formData.frequencyType === 'MONTHLY') {
        const months = end.diff(start, 'months') + 1;
        return `${months} monthly assessments`;
      } else if (formData.frequencyType === 'CUSTOM') {
        const customDates = Array.isArray(formData.frequencyValue) ? formData.frequencyValue.length : 0;
        return `${customDates} custom scheduled assessments`;
      }
    }

    return 'One-time assessment';
  };

  // Get the first form's data for display (or active form)
  const displayForm = formData && Object.keys(formData).length > 0
    ? Object.values(formData)[0]
    : null;

  // Check if we should show the View Calendar button
  const shouldShowViewCalendar = displayForm && (
    // Enable if it's a scheduled assessment with dates
    (displayForm.distributionType === 'scheduled' &&
      displayForm.startDate &&
      displayForm.endDate) ||
    // Enable if it's a one-time assessment with dates
    (displayForm.distributionType === 'one-time' &&
      displayForm.startDate &&
      displayForm.endDate) ||
    // Enable if we have any assessment type selected (fallback)
    displayForm.assessmentType
  );
  return (
    <InfoCard>
      <CardTitle>{instituteData?.name || 'Institute'}</CardTitle>
      <CardSubtitle>{instituteData?.location || 'Location not specified'}</CardSubtitle>

      <SectionButton
        className={expandedSection === 'subscription' ? 'expanded' : ''}
        onClick={() => toggleSection('subscription')}
        style={{ borderRadius: '25px' }}
      >
        Subscription Details
        <span>{expandedSection === 'subscription' ? '▼' : '▶'}</span>
      </SectionButton>

      {expandedSection === 'subscription' && (
        <SectionContent>
          <DetailItem>
            <DetailLabel>Plan Type</DetailLabel>
            <DetailValue>Premium</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Valid Until</DetailLabel>
            <DetailValue>31 Dec 2025</DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailLabel>Students Limit</DetailLabel>
            <DetailValue>10,000</DetailValue>
          </DetailItem>
        </SectionContent>
      )}

      <SectionButton
        className={expandedSection === 'assessment' ? 'expanded' : ''}
        onClick={() => toggleSection('assessment')}
        style={{ borderRadius: '25px' }}
      >
        Assessment Details
        <span>{expandedSection === 'assessment' ? '▼' : '▶'}</span>
      </SectionButton>

      {expandedSection === 'assessment' && (
        <SectionContent>
          <DetailItem>
            <DetailLabel>Assessment Type:</DetailLabel>
            <DetailValue>{displayForm?.assessmentType || 'Not selected'}</DetailValue>
          </DetailItem>

          <DetailItem>
            <DetailLabel>Schedule Duration:</DetailLabel>
            <DetailValue>
              {displayForm?.startDate && displayForm?.endDate
                ? `${moment(displayForm.startDate).format('DD MMM YYYY')} to ${moment(displayForm.endDate).format('DD MMM YYYY')}`
                : 'Not configured'
              }
            </DetailValue>
          </DetailItem>

          <DetailItem>
            <DetailLabel>Distribution Type:</DetailLabel>
            <DetailValue>
              {displayForm?.distributionType === 'scheduled' ? 'Scheduled Assessment' : 'One-Time Assessment'}
            </DetailValue>
          </DetailItem>

          {displayForm?.distributionType === 'scheduled' && (
            <>
              <DetailItem>
                <DetailLabel>Assmt. Frequency:</DetailLabel>
                <DetailValue>{formatFrequency(displayForm)}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Assignment Pattern:</DetailLabel>
                <DetailValue>{formatAssignmentPattern(displayForm)}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Total Schedule:</DetailLabel>
                <DetailValue>{calculateTotalRounds(displayForm)}</DetailValue>
              </DetailItem>

              {displayForm?.assessmentValidityDays && (
                <DetailItem>
                  <DetailLabel>Per Assessment Validity:</DetailLabel>
                  <DetailValue>
                    {displayForm.assessmentValidityDays === 1
                      ? '1 Day'
                      : `${displayForm.assessmentValidityDays} Days`
                    }
                  </DetailValue>
                </DetailItem>
              )}

              {/* Add View Calendar button */}
              {shouldShowViewCalendar && (
                <DetailItem style={{ marginTop: '16px' }}>
                  <Button
                    type="default"
                    onClick={() => onViewCalendar && onViewCalendar(displayForm || {})}
                    style={{
                      width: '100%',
                      fontSize: '14px',
                      padding: '10px 16px',
                      borderRadius: '8px',
                      fontWeight: '600',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      color: '#FFFFFF',
                      backgroundColor: shouldShowViewCalendar ? '#444CE7' : '#94a3b8', // Different color when disabled
                      border: 'none',
                      cursor: shouldShowViewCalendar ? 'pointer' : 'not-allowed',
                    }}
                    disabled={!shouldShowViewCalendar}
                  >
                    View Calendar
                  </Button>
                  {!shouldShowViewCalendar && (
                    <Text type="secondary" style={{ fontSize: '12px', marginTop: '4px', display: 'block' }}>
                      Complete assessment configuration to view calendar
                    </Text>
                  )}
                </DetailItem>
              )}
            </>
          )}

          {displayForm?.distributionType === 'one-time' && (
            <>
              <DetailItem>
                <DetailLabel>Start Time:</DetailLabel>
                <DetailValue>
                  {displayForm?.startTime
                    ? moment(displayForm.startTime).format('HH:mm')
                    : 'Not set'
                  }
                </DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>End Time:</DetailLabel>
                <DetailValue>
                  {displayForm?.endTime
                    ? moment(displayForm.endTime).format('HH:mm')
                    : 'Not set'
                  }
                </DetailValue>
              </DetailItem>
            </>
          )}
        </SectionContent>
      )}
    </InfoCard>
  );
};
const formatDate = (date) => {
  if (!date) return null;

  // If it's already a string in YYYY-MM-DD format, return it
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  // If it's a moment object or Date object, format it
  if (moment.isMoment(date)) {
    return date.format('YYYY-MM-DD');
  }

  // Try to convert to moment and format
  const momentDate = moment(date);
  if (momentDate.isValid()) {
    return momentDate.format('YYYY-MM-DD');
  }

  return null;
};


/* ─── Inline Broadcast Scope Picker ─── */
const InlineBroadcastScopePicker = ({ form, formId, degrees, degreesLoading, setAssessmentForms, campusId }) => {
  const scopes = Array.isArray(form.broadcastScope) ? form.broadcastScope : []
  const [addDegreeId, setAddDegreeId] = useState(null)
  const [addStreamId, setAddStreamId] = useState(null)
  const [addSpecIds, setAddSpecIds] = useState([])
  const [addPassingYears, setAddPassingYears] = useState([])
  // Passing years available for the currently-selected degree+stream — fetched
  // from the backend so only years that actually have students are shown.
  const [yearOptions, setYearOptions] = useState([])
  const [yearsLoading, setYearsLoading] = useState(false)

  useEffect(() => {
    setAddPassingYears([])
    setYearOptions([])
    if (!campusId || !addDegreeId || !addStreamId) return
    let cancelled = false
    setYearsLoading(true)
    getBroadcastPassingYears({ campusId, degreeId: addDegreeId, streamId: addStreamId })
      .then(res => { if (!cancelled) setYearOptions(res?.data?.data || []) })
      .catch(() => { if (!cancelled) setYearOptions([]) })
      .finally(() => { if (!cancelled) setYearsLoading(false) })
    return () => { cancelled = true }
  }, [campusId, addDegreeId, addStreamId])

  const updateForm = (patch) => {
    setAssessmentForms(prev => ({
      ...prev,
      forms: { ...prev.forms, [formId]: { ...prev.forms[formId], ...patch } },
    }))
  }

  // Streams and specs are embedded in the degree response — no separate API calls needed
  const deg = degrees.find(d => d.degreeId === addDegreeId)
  const streams = deg?.streams || []
  const str = streams.find(s => s.streamId === addStreamId)
  // Response uses both 'specialisations' and 'specializations' depending on source — accept either
  const specs = (str?.specialisations || str?.specializations || []).map(sp => ({
    specialisationId: sp.specialisationId || sp.id,
    specialisationName: sp.specialisationName || sp.name,
  }))
  const addDegName = deg?.degreeShortForm || deg?.degreeName || ''
  const addStreamName = str?.streamName || ''

  const handleAdd = () => {
    if (!addDegreeId || !addStreamId) { message.warning('Pick a degree and department'); return }
    const key = `${addDegreeId}:${addStreamId}`
    if (scopes.find(s => `${s.targetDegreeId}:${s.targetStreamId}` === key)) {
      message.warning('This scope is already added'); return
    }
    const newScopes = [
      ...scopes,
      {
        targetDegreeId: addDegreeId,
        targetStreamId: addStreamId,
        degreeName: addDegName,
        streamName: addStreamName,
        labelSpecialisationIds: [...addSpecIds],
        targetPassingYears: [...addPassingYears],
      },
    ]
    const perScopeLabels = newScopes.map(s => ({
      targetDegreeId: s.targetDegreeId,
      targetStreamId: s.targetStreamId,
      specialisationIds: s.labelSpecialisationIds || [],
    }))
    updateForm({ broadcastScope: newScopes, broadcastLabelSpecialisations: perScopeLabels })
    setAddDegreeId(null); setAddStreamId(null); setAddSpecIds([]); setAddPassingYears([])
  }

  const handleRemove = (scope) => {
    AntModal.confirm({
      title: 'Remove Scope',
      content: `Remove "${scope.degreeName} - ${scope.streamName}" from this broadcast?`,
      okText: 'Remove', okType: 'danger',
      onOk: () => {
        const remaining = scopes.filter(s => !(s.targetDegreeId === scope.targetDegreeId && s.targetStreamId === scope.targetStreamId))
        const perScopeLabels = remaining.map(s => ({
          targetDegreeId: s.targetDegreeId,
          targetStreamId: s.targetStreamId,
          specialisationIds: s.labelSpecialisationIds || [],
        }))
        updateForm({ broadcastScope: remaining, broadcastLabelSpecialisations: perScopeLabels })
      },
    })
  }

  const selectStyle = {
    width: '100%', height: 38, borderRadius: 8, border: '1px solid #EBECEE', padding: '0 12px',
    fontSize: 13, fontWeight: 500, fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: '#fff', color: '#242E39', outline: 'none', cursor: 'pointer',
    appearance: 'none',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M1 1L5 5L9 1\' stroke=\'%23637487\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E")',
    backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center',
  }

  return (
    <div style={{ marginTop: 20, padding: 20, background: '#FAFAFB', borderRadius: 12, border: '1px solid #EBECEE', maxWidth: 900 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#242E39', marginBottom: 4 }}>Broadcast Scope</div>
      <div style={{ fontSize: 12, color: '#637487', marginBottom: 16 }}>
        Every student in the selected degree(s) + department(s) will see this assessment. Specialisations control email targeting.
      </div>
      {!degreesLoading && degrees.length === 0 && (
        <div style={{ marginBottom: 12, padding: '10px 14px', background: '#FFF7ED', border: '1px solid #FFE0B2', borderRadius: 8, fontSize: 12, color: '#B54708' }}>
          No degrees found for this campus. Make sure an institute is selected and the campus has enrolled students.
        </div>
      )}

      {/* Active scope chips */}
      {scopes.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {scopes.map((s, i) => {
            const scopeSpecIds = s.labelSpecialisationIds || []
            const scopeYears = s.targetPassingYears || []
            const specPart = scopeSpecIds.length > 0 ? ` · ${scopeSpecIds.length} spec${scopeSpecIds.length > 1 ? 's' : ''}` : ''
            const yearPart = scopeYears.length > 0 ? ` · ${scopeYears.join(', ')}` : ''
            return (
              <div key={i} style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                padding: '6px 8px 6px 14px', borderRadius: 8, background: '#fff',
                border: '1px solid #EBECEE', fontSize: 12, fontWeight: 600, color: '#242E39',
                boxShadow: '0 1px 2px rgba(99,116,135,0.05)',
              }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4cb187', display: 'inline-block' }} />
                {s.degreeName} - {s.streamName}{yearPart}{specPart}
                <button onClick={() => handleRemove(s)}
                  style={{ width: 20, height: 20, borderRadius: 4, border: 'none', background: 'transparent', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#8c99a8', padding: 0 }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#FFF0F0'; e.currentTarget.style.color = '#DC3232' }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#8c99a8' }}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 2L8 8M8 2L2 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                </button>
              </div>
            )
          })}
        </div>
      )}

      {/* Add scope */}
      <div style={{ padding: 14, background: '#fff', borderRadius: 10, border: '1px dashed #C7D0E0' }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#3249D7', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 10 }}>+ Add Scope</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#8c99a8', marginBottom: 4 }}>Degree</div>
            <select style={selectStyle} value={addDegreeId || ''} disabled={degreesLoading}
              onChange={e => { setAddDegreeId(e.target.value || null); setAddStreamId(null); setAddSpecIds([]) }}>
              <option value="">{degreesLoading ? 'Loading...' : 'Select degree...'}</option>
              {degrees.map(d => <option key={d.degreeId} value={d.degreeId}>{d.degreeShortForm || d.degreeName}</option>)}
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#8c99a8', marginBottom: 4 }}>Department</div>
            <select style={{ ...selectStyle, opacity: streams.length ? 1 : 0.5 }} value={addStreamId || ''} disabled={!addDegreeId}
              onChange={e => { setAddStreamId(e.target.value || null); setAddSpecIds([]) }}>
              <option value="">{addDegreeId && streams.length === 0 ? 'No departments' : 'Select department...'}</option>
              {streams.map(s => <option key={s.streamId} value={s.streamId}>{s.streamName}</option>)}
            </select>
          </div>
        </div>
        {addDegreeId && addStreamId && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#8c99a8', marginBottom: 6 }}>
              Passing Year <span style={{ fontWeight: 400 }}>— optional (none = all years)</span>
            </div>
            {yearsLoading ? (
              <div style={{ fontSize: 11, color: '#8c99a8', fontStyle: 'italic' }}>Loading passing years…</div>
            ) : yearOptions.length === 0 ? (
              <div style={{ fontSize: 11, color: '#8c99a8', fontStyle: 'italic' }}>No passing-year data for this scope — all years will be included.</div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {yearOptions.map(yr => {
                  const active = addPassingYears.includes(yr)
                  return (
                    <button key={yr} onClick={() => setAddPassingYears(prev => active ? prev.filter(x => x !== yr) : [...prev, yr])}
                      style={{
                        padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 600, cursor: 'pointer',
                        border: active ? '1.5px solid #3249D7' : '1.5px solid #EBECEE',
                        background: active ? '#3249D7' : '#fff', color: active ? '#fff' : '#637487',
                        fontFamily: "'Plus Jakarta Sans', sans-serif", transition: 'all 0.15s ease',
                      }}>{yr}</button>
                  )
                })}
              </div>
            )}
          </div>
        )}
        {specs.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#8c99a8', marginBottom: 6 }}>
              Specialisations <span style={{ fontWeight: 400 }}>— optional (emails sent only to selected)</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {specs.map(sp => {
                const id = sp.specialisationId
                const name = sp.specialisationName
                const active = addSpecIds.includes(id)
                return (
                  <button key={id} onClick={() => setAddSpecIds(prev => active ? prev.filter(x => x !== id) : [...prev, id])}
                    style={{
                      padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 600, cursor: 'pointer',
                      border: active ? '1.5px solid #3249D7' : '1.5px solid #EBECEE',
                      background: active ? '#3249D7' : '#fff', color: active ? '#fff' : '#637487',
                      fontFamily: "'Plus Jakarta Sans', sans-serif", transition: 'all 0.15s ease',
                    }}>{name}</button>
                )
              })}
            </div>
          </div>
        )}
        <button onClick={handleAdd} disabled={!addDegreeId || !addStreamId}
          style={{
            padding: '7px 18px', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer',
            border: 'none', background: addDegreeId && addStreamId ? 'linear-gradient(135deg, #3249D7, #444CE7)' : '#F0F2F4',
            color: addDegreeId && addStreamId ? '#fff' : '#8c99a8',
            fontFamily: "'Plus Jakarta Sans', sans-serif", transition: 'all 0.2s ease',
            opacity: !addDegreeId || !addStreamId ? 0.6 : 1,
            boxShadow: addDegreeId && addStreamId ? '0 2px 8px rgba(50, 73, 215, 0.2)' : 'none',
          }}>+ Add to Scope</button>
      </div>
    </div>
  )
}


const AssessmentSelect = ({
  selectedEntityID,
  fetchAssessments,
  setAssessmentData,
  setIsEditing,
  entityType,
  instituteCampusId,
  distributionType,
  setDistributionType,
  selectedEntityData,
  isOtpInvite = false,
}) => {
  const dispatch = useDispatch()
  const [uploadedStudents, setUploadedStudents] = useState([])
  const [uploadSummaries, setUploadSummaries] = useState([])
  const [preservedCandidatesData, setPreservedCandidatesData] = useState({})
  const [preservedUploadSummaries, setPreservedUploadSummaries] = useState({})
  const { Option } = Select
  const initialId = uuidv4()
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [showViewCalendar, setShowViewCalendar] = useState(false);
  const [viewCalendarData, setViewCalendarData] = useState(null);
  const roleBasedQuestionsState = useSelector(selectRoleBasedQuestions);
  const topicQuestionsState = useSelector(selectTopicBasedQuestions);
  // Aptitude config (section split / active topics / difficulty mix) from backend.
  // Institute is fixed at 30 minutes => 25-question config.
  const aptitudeConfig = useSelector(selectAptitudeConfig);
  const instituteAptitudeCfg = aptitudeConfig?.[25] || null;
  const [showTopicPreview, setShowTopicPreview] = useState(false);
  const [showSectionConfig, setShowSectionConfig] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const roleBasedAssessmentState = useSelector(selectRoleBasedAssessment);
  const userEmail = useSelector(state => state.auth?.userData?.email);
  const [region, setRegion] = useState('India');
  const [jobDescription, setJobDescription] = useState('none');
  const [showCustomRoleInput, setShowCustomRoleInput] = useState({});
  const [customRoleName, setCustomRoleName] = useState({});
  const [customSkillInput, setCustomSkillInput] = useState({});

  const [viewerVisible, setViewerVisible] = useState(false);
  const [selectedSectionForView, setSelectedSectionForView] = useState(null);
  const [isAddSectionModalOpen, setIsAddSectionModalOpen] = useState(false);

  // Broadcast scope cascading dropdown state
  const [broadcastDegrees, setBroadcastDegrees] = useState([])
  const [broadcastStreams, setBroadcastStreams] = useState([])
  const [broadcastSpecs, setBroadcastSpecs] = useState([])
  const [broadcastDegreesLoading, setBroadcastDegreesLoading] = useState(false)

  // Fetch degrees when any form has isBroadcast=true
  const anyBroadcastActive = Object.values(assessmentForms?.forms || {}).some(f => f?.isBroadcast)
  const broadcastCampusId = instituteCampusId || selectedEntityID
  useEffect(() => {
    console.log('[Broadcast] effect fired — anyBroadcastActive:', anyBroadcastActive, 'broadcastCampusId:', broadcastCampusId, 'instituteCampusId:', instituteCampusId, 'selectedEntityID:', selectedEntityID)
    if (!anyBroadcastActive) { console.log('[Broadcast] skip: no form has isBroadcast=true'); return }
    if (!broadcastCampusId) { console.log('[Broadcast] skip: no campus/entity id available'); return }
    console.log('[Broadcast] Fetching degrees for campusID:', broadcastCampusId)
    setBroadcastDegreesLoading(true)
    setBroadcastDegrees([])
    setBroadcastStreams([])
    setBroadcastSpecs([])
    const fetchFn = getEligibilityCriteria({ searchType: 'DEGREE', campusID: broadcastCampusId })
    fetchFn().then(result => {
      console.log('[Broadcast] Degrees fetched:', result?.length || 0, 'sample:', result?.[0])
      setBroadcastDegrees(result || [])
      setBroadcastDegreesLoading(false)
    }).catch(err => {
      console.error('[Broadcast] Degree fetch error:', err)
      setBroadcastDegreesLoading(false)
    })
  }, [anyBroadcastActive, broadcastCampusId, instituteCampusId, selectedEntityID])

  const formattedAptitudeTopics = useSelector(selectFormattedAptitudeTopics)
  const aptitudeTopicsLoading = useSelector(selectAptitudeTopicsLoading)
  const aptitudeTopicsError = useSelector(selectAptitudeTopicsError)
  const [assessmentTypeData, setAssessmentTypeData] = useState({});
  const [assessments, setAssessments] = useState([
    { id: initialId, assessment: null, isSaved: false },
  ])

  const [assessmentForms, setAssessmentForms] = useState({
    forms: {
      [initialId]: { ...defaultFormState, id: initialId },
    },
    activeFormId: initialId,
  })


  const frequencyOptions = {
    DAILY: [
      { value: 1, label: 'Every Day' },
      { value: 2, label: 'Every 2 Days' },
      { value: 15, label: 'Every 15 Days' },
      { value: 30, label: 'Every 30 Days' },
    ],
    WEEKLY: [
      { value: 'MONDAY', label: 'Every Monday' },
      { value: 'TUESDAY', label: 'Every Tuesday' },
      { value: 'WEDNESDAY', label: 'Every Wednesday' },
      { value: 'THURSDAY', label: 'Every Thursday' },
      { value: 'FRIDAY', label: 'Every Friday' },
      { value: 'SATURDAY', label: 'Every Saturday' },
      { value: 'SUNDAY', label: 'Every Sunday' },
    ],
    MONTHLY: Array.from({ length: 28 }, (_, i) => ({
      value: i + 1,
      label: `On the ${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'
        } of the month`,
    })),
    CUSTOM: [],
  };

  // Validity is now a free-form number input (any positive integer of days)



  const getSubtopicNames = category => {
    // First try to use API data, fallback to hardcoded data if API data isn't available
    if (
      formattedAptitudeTopics &&
      Object.keys(formattedAptitudeTopics).length > 0
    ) {
      const topics = formattedAptitudeTopics[category] || []
      return topics.map(topic => topic.name)
    }
    // No topics loaded yet. This used to reference an `aptitudeSubtopics`
    // constant that does not exist in this module — a ReferenceError waiting
    // for the first render before /getAptitudeTopics resolves. The picker
    // renders empty cards until the API answers, which is what the modal's own
    // fallback already assumes.
    return []
  }
  const handleViewCalendar = (formData) => {
    console.log('View Calendar clicked with form data:', formData);

    if (!formData || Object.keys(formData).length === 0) {
      setViewCalendarData({
        startDate: null,
        endDate: null,
        scheduledDates: [],
        frequencyType: null,
        frequencyValue: null,
        isViewOnly: true,
        isEmpty: true
      });
      setShowViewCalendar(true);
      return;
    }

    let scheduledDates = [];
    if (formData.startDate && formData.endDate && formData.frequencyType && formData.frequencyValue) {
      try {
        if (formData.frequencyType === 'CUSTOM') {
          // For custom dates, filter out today's date
          const today = moment().format('YYYY-MM-DD');
          scheduledDates = Array.isArray(formData.frequencyValue)
            ? formData.frequencyValue.filter(date => {
              const dateStr = moment(date).format('YYYY-MM-DD');
              return dateStr !== today;
            })
            : [];
        } else {
          // Generate dates and filter out today
          const allDates = generateScheduleDates(
            formData.startDate,
            formData.endDate,
            formData.frequencyType,
            formData.frequencyValue
          );

          const today = moment().format('YYYY-MM-DD');
          scheduledDates = allDates.filter(date => {
            const dateStr = moment(date).format('YYYY-MM-DD');
            return dateStr !== today;
          });
        }
      } catch (error) {
        console.error('Error generating scheduled dates:', error);
        scheduledDates = [];
      }
    }

    console.log('Generated scheduled dates (excluding today):', scheduledDates);

    setViewCalendarData({
      startDate: formData.startDate || null,
      endDate: formData.endDate || null,
      scheduledDates: scheduledDates,
      frequencyType: formData.frequencyType || null,
      frequencyValue: formData.frequencyValue || null,
      isViewOnly: true,
      isEmpty: false
    });

    setShowViewCalendar(true);
  };


  const handleGenerateTest = () => {
    const formId = assessmentForms.activeFormId;
    const form = assessmentForms.forms[formId];
    const isCustomAssessment = form.assessmentType === 'Custom_Assessment';

    // Always default to "Universal" if industry_domain is empty, null, or only whitespace
    const industryDomain =
      !form.industry_domain || !form.industry_domain.trim()
        ? 'Universal'
        : form.industry_domain;

    const payload = {
      jobRole: form.selectedJobRole,
      skills: form.selectedSkills,
      seniority: form.seniority,
      industry_domain: industryDomain,
      jobDescription: isCustomAssessment
        ? (form.jobDescription && form.jobDescription.trim() ? form.jobDescription : 'noce')
        : form.jobDescription,
      region: isCustomAssessment
        ? 'India'
        : (form.region || 'India'),
      questionConfig: {
        mcqCount: form.questionConfig?.mcqCount ?? 10,
        subjectiveCount: form.questionConfig?.subjectiveCount ?? 2,
        videoCount: form.questionConfig?.videoCount ?? 1,
        codingCount: form.questionConfig?.codingCount ?? 0,
      },
    };

    try {
      dispatch(generateRoleBasedQuestions(payload))
        .then((result) => {
          // Check if result has the expected structure and no error
          const questions = result?.questions;
          if (questions && !questions.error) {
            message.success('Questions generated successfully! You can now preview and save the assessment.');
            setShowPreview(true);
          } else {
            const errorMsg = questions?.error || 'No questions were generated. Please try again.';
            message.error('Failed to generate questions: ' + errorMsg);
          }
        })
        .catch((err) => {
          console.error('Error in handleGenerateTest:', err);
          message.error('Failed to generate questions: ' + (err.message || 'Unknown error'));
        });
    } catch (err) {
      console.error('Catch block in handleGenerateTest:', err);
      message.error('Failed to generate questions');
    }
  };


  const QuestionTypeDescriptions = {
    video: "Video Questions: Scenario-based questions suitable for a 2-minute video response. Candidates are expected to record and submit a video answer.",
    subjective: "Subjective Questions: Open-ended questions that require a written, descriptive answer from the candidate.",
    mcq: "MCQ Questions: Multiple-choice questions with 4 options. The correct answer is indicated below each question.",
    coding: "Coding Questions: Programming problems with test cases. Candidates write code to solve the problem and pass all test cases.",
  };

  const handleSendRoleBasedAssessment = async (formId) => {
    const form = assessmentForms.forms[formId];

    if (!roleBasedQuestionsState.data) {
      message.error('Please generate questions first');
      return;
    }

    try {
      const payload = {
        create: false,
        entityId: selectedEntityID,
        name: form.name,
        instructions: form.instructions || '',
        assessmentType: 'Role_Based',
        startTime: form.startTime.format('HH:mm'),
        endTime: form.endTime.format('HH:mm'),
        startDate: form.startDate.format('YYYY-MM-DD'),
        endDate: form.endDate.format('YYYY-MM-DD'),
        bulkUploadData: form.bulkUploadData || [],
        email: '', // This will be filled by the backend
        entityType: entityType,
        allowProctoring: form.allowProctoring || false,
        allowVerification: form.allowVerification !== false,
        roleName: form.selectedJobRole,
        generatedQuestions: roleBasedQuestionsState.data,
        questionConfig: {
          mcqCount: form.questionConfig?.mcqCount ?? 10,
          subjectiveCount: form.questionConfig?.subjectiveCount ?? 2,
          videoCount: form.questionConfig?.videoCount ?? 1,
          codingCount: form.questionConfig?.codingCount ?? 0,
        },
      };

      message.loading('Assigning role-based assessment...');
      await dispatch(assignRoleBasedAssessment(payload));
      message.success('Role-based assessment assigned successfully!');

      // Mark the form as saved
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            isSaved: true
          }
        }
      }));

      // Update the assessments list
      setAssessments(prev =>
        prev.map(a => (a.id === formId ? { ...a, isSaved: true } : a))
      );

      // Reset the questions state
      dispatch({ type: 'RESET_ROLE_BASED_QUESTIONS' });

    } catch (error) {
      message.error(`Failed to assign role-based assessment: ${error.message || 'Unknown error'}`);
    }
  };

  const assessmentSelectNavigate = useNavigate();


  // Helper function to get selected subtopics based on total questions and weights
  const getSelectedSubtopics = (totalQuestions, difficultyLevel = 'medium') => {
    // Category distribution percentages
    const categoryDistribution = {
      quantitative: 0.4,
      logical_reasoning: 0.35,
      critical_reasoning: 0.25,
    }

    // Calculate questions per category
    const questionsPerCategory = {
      quantitative: Math.round(
        totalQuestions * categoryDistribution.quantitative
      ),
      logical_reasoning: Math.round(
        totalQuestions * categoryDistribution.logical_reasoning
      ),
      critical_reasoning: Math.round(
        totalQuestions * categoryDistribution.critical_reasoning
      ),
    }

    // Adjust if total doesn't match (due to rounding)
    const calculatedTotal = Object.values(questionsPerCategory).reduce(
      (sum, count) => sum + count,
      0
    )
    if (calculatedTotal !== totalQuestions) {
      const diff = totalQuestions - calculatedTotal
      // Adjust the category with the highest question count
      const maxCategory = Object.keys(questionsPerCategory).reduce((a, b) =>
        questionsPerCategory[a] > questionsPerCategory[b] ? a : b
      )
      questionsPerCategory[maxCategory] += diff
    }

    const selectedTopics = []

    // Process each category
    Object.keys(questionsPerCategory).forEach(category => {
      if (!formattedAptitudeTopics || !formattedAptitudeTopics[category]) {
        return
      }

      const categoryTopics = [...formattedAptitudeTopics[category]]
      const neededQuestions = questionsPerCategory[category]

      // Sort topics by weight descending
      categoryTopics.sort((a, b) => b.weight - a.weight)

      // Calculate total weight points for the category
      const totalWeightPoints = categoryTopics.reduce(
        (sum, topic) => sum + topic.weight,
        0
      )
      const questionsPerWeightPoint = neededQuestions / totalWeightPoints

      // First pass: Calculate ideal question count per topic based on weight
      const topicAllocations = categoryTopics.map(topic => {
        const idealQuestions = topic.weight * questionsPerWeightPoint
        return {
          name: topic.name,
          weight: topic.weight,
          idealQuestions,
          // Initial allocation (floor to ensure we don't exceed total)
          allocatedQuestions: Math.floor(idealQuestions),
          // Track remaining fraction for second pass
          remainder: idealQuestions - Math.floor(idealQuestions),
        }
      })

      // Calculate how many questions are allocated and how many remain
      const allocatedQuestions = topicAllocations.reduce(
        (sum, t) => sum + t.allocatedQuestions,
        0
      )
      const remainingQuestions = neededQuestions - allocatedQuestions

      // Second pass: Distribute remaining questions based on highest remainder
      if (remainingQuestions > 0) {
        // Sort by remainder descending
        topicAllocations.sort((a, b) => b.remainder - a.remainder)

        // Allocate remaining questions
        for (let i = 0; i < remainingQuestions; i++) {
          if (i < topicAllocations.length) {
            topicAllocations[i].allocatedQuestions += 1
          }
        }
      }

      // Add topics with allocated questions > 0 to selected topics
      topicAllocations.forEach(topic => {
        if (topic.allocatedQuestions > 0) {
          selectedTopics.push({
            name: topic.name,
            category,
            weight: topic.weight,
            questions: topic.allocatedQuestions,
          })
        }
      })
    })

    // Return just the topic names for backward compatibility
    return selectedTopics.map(topic => topic.name)
  }

  // Institute aptitude: send EVERY subtopic so the backend config table is the
  // single source of truth for which topics appear and how many (folded topics
  // resolve to 0). Avoids the frontend's weight-pruned selection silently
  // dropping a config-active topic.
  const getAllSubtopics = () => {
    if (!formattedAptitudeTopics) return []
    return ['quantitative', 'logical_reasoning', 'critical_reasoning'].flatMap(
      cat => (formattedAptitudeTopics[cat] || []).map(topic => topic.name)
    )
  }

  useEffect(() => {
    dispatch(fetchAptitudeTopics())
    dispatch(fetchAptitudeConfig()) // cached after first load; difficulty toggles reuse it
  }, [dispatch])

  // Add these missing handler functions
  const handleDurationChange = (duration, formId) => {
    setAssessmentForms(prev => {
      const updated = {
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            duration: duration,
          },
        },
      }

      console.debug(
        'Duration updated for formId:',
        formId,
        'new duration:',
        duration
      )
      return updated
    })
  }

  const handleDifficultyLevelChange = (difficultyLevel, formId) => {
    // The topic selection is independent of difficulty — the blueprint keeps
    // the easy/medium/hard budget whichever topics are chosen. Institute forms
    // used to have their sub-topics reset to "every topic" here, which silently
    // discarded a selection whenever the admin changed difficulty afterwards.
    setAssessmentForms(prev => ({
      ...prev,
      forms: {
        ...prev.forms,
        [formId]: {
          ...prev.forms[formId],
          difficultyLevel: difficultyLevel,
        },
      },
    }))

    // The availability answer is difficulty-specific, so it must be re-checked.
    setTopicAvailability(prev => ({ ...prev, [formId]: null }))
  }

  const handleSelectAll = (checked, formId, aptitudeTypes) => {
    // aptitudeTypes is now an array instead of a single type
    const allSubtopics = aptitudeTypes.reduce((acc, type) => {
      // Use getSubtopicNames to get just the names, not the full objects
      const typeSubtopics = getSubtopicNames(type)
      return [...acc, ...typeSubtopics]
    }, [])

    const newSelection = checked ? allSubtopics : []
    handleSubtopicsChange(newSelection, formId)
  }

  const handleSubtopicsChange = (checkedValues, formId) => {
    setAssessmentForms(prev => ({
      ...prev,
      forms: {
        ...prev.forms,
        [formId]: {
          ...prev.forms[formId],
          aptitudeSubtopics: checkedValues,
        },
      },
    }))

    if (validationErrors[formId]?.aptitudeSubtopics) {
      setValidationErrors(prev => ({
        ...prev,
        [formId]: {
          ...prev[formId],
          aptitudeSubtopics: false,
        },
      }))
    }
  }
  const [assessmentOrder, setAssessmentOrder] = useState([initialId])
  const subscribedAssessment = useSelector(
    state => state.SubscribedInstitutes.subscribedAssessment || []
  )

  const selectedData = useSelector(selectFormattedDegreeResults)
  const [showPreview, setShowPreview] = useState(false);

  const [localAssessments, setLocalAssessments] = useState([])
  const [showBulkUploadDrawer, setShowBulkUploadDrawer] = useState(false)
  const [drawerInitialScreen, setDrawerInitialScreen] = useState('main_options')
  const [showInstructionsDrawer, setShowInstructionsDrawer] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [currentEditingIndex, setCurrentEditingIndex] = useState(null)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState(null)
  const [types, setTypes] = useState([])

  const [validationErrors, setValidationErrors] = useState({})
  const [showTopicModal, setShowTopicModal] = useState(false)
  // Pre-flight answer per form: { canGenerate, shortfalls, ... } | null while
  // unknown. Deliberately not in redux — it goes stale as soon as the topics or
  // the difficulty change, so it is cleared at both of those edit points.
  const [topicAvailability, setTopicAvailability] = useState({})
  const [isCheckingAvailability, setIsCheckingAvailability] = useState(false)

  const errorStyle = {
    border: `1px solid ${COLORS.RED_T_50}`,
    boxShadow: `0 0 0 1px ${COLORS.RED_T_50}`,
    transition: 'all 0.3s ease',
  }
  useEffect(() => {
    console.log('AssessmentSelect: Dispatching fetchAptitudeTopics...')
    dispatch(fetchAptitudeTopics())
      .then(result => {
        console.log(
          'AssessmentSelect: fetchAptitudeTopics completed with result:',
          result
        )
      })
      .catch(error => {
        console.error('AssessmentSelect: fetchAptitudeTopics failed:', error)
      })
  }, [dispatch])

  // Add debug logging for the selector data
  useEffect(() => {
    console.log('=== APTITUDE TOPICS DEBUG ===')
    console.log('formattedAptitudeTopics:', formattedAptitudeTopics)
    console.log('aptitudeTopicsLoading:', aptitudeTopicsLoading)
    console.log('aptitudeTopicsError:', aptitudeTopicsError)
    console.log(
      'typeof formattedAptitudeTopics:',
      typeof formattedAptitudeTopics
    )
    console.log(
      'Object.keys(formattedAptitudeTopics):',
      Object.keys(formattedAptitudeTopics)
    )
    console.log('Has quantitative:', !!formattedAptitudeTopics.quantitative)
    console.log(
      'Has logical_reasoning:',
      !!formattedAptitudeTopics.logical_reasoning
    )
    console.log(
      'Has critical_reasoning:',
      !!formattedAptitudeTopics.critical_reasoning
    )
    console.log('=============================')
  }, [formattedAptitudeTopics, aptitudeTopicsLoading, aptitudeTopicsError])

  const validateForm = (form, formId) => {
    console.log('=== validateForm START ===')
    console.log('validateForm called for formId:', formId, 'with form:', form)

    if (!form) {
      console.error('validateForm: form is null/undefined')
      return false
    }

    if (!formId) {
      console.error('validateForm: formId is null/undefined')
      return false
    }

    const errors = {}
    const missing = [] // Collect human-readable field names for notification
    const isInstituteFlow =
      entityType === 'college' || entityType === 'institute'

    // Check for scheduled distribution validation
    if (form.distributionType === 'scheduled') {
      if (!form.startDate) { errors.startDate = true; missing.push('Start Date') }
      if (!form.endDate) { errors.endDate = true; missing.push('End Date') }
      if (!form.frequencyType) { errors.frequencyType = true; missing.push('Frequency Type') }
      if (!form.frequencyValue) { errors.frequencyValue = true; missing.push('Frequency Value') }
      if (!form.assessmentValidityDays || form.assessmentValidityDays < 1 || !Number.isInteger(form.assessmentValidityDays)) {
        errors.assessmentValidityDays = true; missing.push('Assessment Validity (must be a positive integer)')
      }
    }

    // Check if assessment type is selected
    if (!form?.assessmentType) { errors.assessmentType = true; missing.push('Assessment Type') }

    // Check if name is provided
    if (!form?.name?.trim()) { errors.name = true; missing.push('Assessment Name') }

    // Check required dates and times (only for non-scheduled or when distributionType is not set)
    if (form.distributionType !== 'scheduled') {
      if (!form?.startDate) { errors.startDate = true; missing.push('Start Date') }
      if (!form?.startTime) { errors.startTime = true; missing.push('Start Time') }
      if (!form?.isBroadcast) {
        if (!form?.endDate) { errors.endDate = true; missing.push('End Date') }
        if (!form?.endTime) { errors.endTime = true; missing.push('End Time') }
      }
    }

    // Check assessment-specific requirements
    if (
      form?.assessmentType === 'Behavior' &&
      (!form?.selectedStreams || form.selectedStreams.length === 0)
    ) {
      errors.selectedStreams = true; missing.push('Streams')
    }

    if (form?.assessmentType === 'Communication') {
      if (!form?.cefrLevel) { errors.cefrLevel = true; missing.push('CEFR Level') }

      // Speaking evaluation language — required for corporate
      if (entityType === 'corporate' && !form?.responseLanguage) {
        errors.responseLanguage = true; missing.push('Speaking Evaluation Language')
      }

      // Enabled sections — at least one must be selected (corporate only, college always has all)
      if (entityType === 'corporate' && (!form?.enabledSections || form.enabledSections.length === 0)) {
        errors.enabledSections = true; missing.push('At least one assessment section must be enabled')
      }

      // If topic is provided, generated questions are REQUIRED
      if ((form?.selectedDomain || '').trim()) {
        if (!form?.generatedQuestions && !topicQuestionsState?.data) {
          errors.generatedQuestions = true
          missing.push('Generated Questions — click "Generate Questions" before saving')
        }
      }
    }

    if (form?.assessmentType === 'Role_Based') {
      if (!form?.selectedJobRole) { errors.selectedJobRole = true; missing.push('Job Role') }
      if (!form?.selectedSkills || form.selectedSkills.length === 0) { errors.selectedSkills = true; missing.push('Skills') }
      if (!form?.seniority) { errors.seniority = true; missing.push('Seniority Level') }
      if (!form?.jobDescription?.trim()) { errors.jobDescription = true; missing.push('Job Description') }
      if (!form?.industry_domain?.trim()) { errors.industry_domain = true; missing.push('Industry / Domain') }
      if (!form?.region) { errors.region = true; missing.push('Region') }
    }

    if (form?.assessmentType === 'AI_Interview') {
      const ai = form?.aiInterview?.form || {}
      const params = form?.aiInterview?.parameters || []
      if (!ai.jobRole?.trim()) { errors.aiInterviewJobRole = true; missing.push('Job Role') }
      if (!ai.seniority) { errors.aiInterviewSeniority = true; missing.push('Seniority Level') }
      if (params.length < 3) { errors.aiInterviewParameters = true; missing.push('Evaluation Parameters (need 3+)') }
      const weightSum = params.reduce((s, p) => s + Number(p.weight || 0), 0)
      if (params.length > 0 && weightSum !== 100) {
        errors.aiInterviewParameterWeights = true; missing.push(`Parameter weights must sum to 100 (now ${weightSum})`)
      }
    }

    if (form?.assessmentType === 'Custom_Assessment') {
      if (!form?.selectedSectionIds || form.selectedSectionIds.length === 0) {
        errors.selectedSectionIds = true
        missing.push('Assessment Sections')
      }

      if (form?.selectedSectionIds && form.selectedSectionIds.length > 0) {
        // Reconstruct allSections for validation context
        const availableCustomSections = form.availableCustomSections || []
        const customSections = form.customSections || []

        const allSections = [
          ...availableCustomSections.map(section => ({
            section_id: section.section_id,
            section_name: section.name,
            totalQuestions: section.totalQuestions,
            questions: Array(section.totalQuestions).fill({}),
            isExisting: true,
          })),
          ...customSections.map((section, idx) => ({
            section_id: section.section_id || `temp-${idx}`,
            section_name: section.section_name,
            totalQuestions: section.totalQuestions,
            excel: section.excel,
            questions: section.questions || [],
            isExisting: false,
          })),
        ]

        for (const sectionId of form.selectedSectionIds) {
          const section = allSections.find(s => s.section_id === sectionId)
          if (section) {
            const sectionName = section.section_name
            // Look up config by id (names can collide); error keys use id so
            // duplicate-named sections show their own errors independently.
            const config = form.customSectionConfig?.[sectionId]

            // Check if config exists and numQuestions >= 1
            if (
              !config ||
              config.numQuestions === undefined ||
              config.numQuestions === null ||
              config.numQuestions < 1
            ) {
              errors[`customSectionConfig_${sectionId}`] = true
              missing.push(`Number of Questions for "${sectionName}"`)
            }

            // Check if numQuestions exceeds totalQuestions
            if (config && config.numQuestions > section.totalQuestions) {
              errors[`customSectionConfig_${sectionId}_exceedsTotal`] = true
              errors[`customSectionConfig_${sectionId}`] = true
              missing.push(`"${sectionName}" — questions (${config.numQuestions}) exceeds available (${section.totalQuestions})`)
            }

            // Check if totalMarks > 0
            if (
              !config ||
              config.totalMarks === undefined ||
              config.totalMarks === null ||
              config.totalMarks <= 0
            ) {
              errors[`customSectionConfig_${sectionId}_marks`] = true
              missing.push(`Total Marks for "${sectionName}"`)
            }

            // Check if sectionTime > 0
            if (
              !config ||
              config.sectionTime === undefined ||
              config.sectionTime === null ||
              config.sectionTime <= 0
            ) {
              errors[`customSectionConfig_${sectionId}_time`] = true
              missing.push(`Section Time for "${sectionName}"`)
            }
          }
        }
      }
    }

    if (form?.assessmentType === 'Aptitude') {
      // The topic rules are identical for both flows; only duration differs
      // (institute papers are fixed at 45 minutes, corporate picks one).
      if (!form?.aptitudeType || form.aptitudeType.length === 0) {
        errors.aptitudeType = true; missing.push('Aptitude Type')
      }
      if (form?.aptitudeSubtopics && form.aptitudeSubtopics.length < MIN_APTITUDE_TOPICS) {
        errors.minimumTopics = true
        missing.push(`At least ${MIN_APTITUDE_TOPICS} topics must be selected`)
      }
      if (form?.aptitudeType?.length > 0 && (!form?.aptitudeSubtopics || form.aptitudeSubtopics.length === 0)) {
        errors.aptitudeSubtopics = true; missing.push('Aptitude Sub-topics')
      }
      if (!form?.difficultyLevel) { errors.difficultyLevel = true; missing.push('Difficulty Level') }
      if (!isInstituteFlow && form?.aptitudeType?.length > 0 && form?.aptitudeSubtopics?.length > 0) {
        if (!form?.duration) { errors.duration = true; missing.push('Duration') }
      }
      if (form?.allowNegativeMarking === undefined || form?.allowNegativeMarking === null) {
        errors.allowNegativeMarking = true; missing.push('Negative Marking (Yes/No)')
      }
      // A selection the question bank cannot fill is rejected here rather than
      // at assign time, where it would silently trip the legacy fallback.
      if (topicAvailability[formId]?.result?.canGenerate === false) {
        errors.aptitudeSubtopics = true
        missing.push(
          'Topic selection — not enough questions available, adjust the topics or difficulty'
        )
      }
    }

    // Check if assessment link is required for specific types
    if (
      ['Cognitive', 'Tech_MCQ', 'Tech_Coding'].includes(form?.assessmentType)
    ) {
      if (!form?.assessmentLink?.trim()) {
        errors.assessmentLink = true
        missing.push('Assessment Link')
      } else {
        try {
          new URL(form.assessmentLink)
        } catch (e) {
          errors.assessmentLink = true
          missing.push('Assessment Link — please enter a valid URL')
        }
      }
    }

    // Check if students/candidates are uploaded for this specific form
    const hasUploadedStudents =
      uploadSummaries.some(summary => summary.formId === formId) ||
      uploadedStudents.some(student => student.formId === formId) ||
      preservedCandidatesData[formId]?.length > 0

    if (!hasUploadedStudents) {
      errors.selectedStudents = true
      missing.push('Candidates — please upload a candidate list')
    }

    // Show user-friendly notifications for each missing field (errors first)
    if (missing.length > 0) {
      if (missing.length <= 3) {
        missing.forEach((field) => {
          message.error({
            content: `Missing: ${field}`,
            duration: 5,
          })
        })
      } else {
        message.error({
          content: (
            <div style={{ textAlign: 'left' }}>
              <strong>Please fill in the following {missing.length} fields:</strong>
              <ul style={{ margin: '4px 0 0 16px', padding: 0 }}>
                {missing.map((field, i) => (
                  <li key={i} style={{ marginBottom: '2px' }}>{field}</li>
                ))}
              </ul>
            </div>
          ),
          duration: 8,
        })
      }
    }

    // No separate warning needed — generatedQuestions is now included in the missing[] list

    console.log('Validation errors for formId:', formId, errors)

    // Set validation errors with auto-clear
    setValidationErrors(prev => {
      const updated = {
        ...prev,
        [formId]: errors,
      }

      if (Object.keys(errors).length > 0) {
        setTimeout(() => {
          setValidationErrors(prev => ({
            ...prev,
            [formId]: {},
          }))
        }, 8000)
      }

      return updated
    })

    const isValid = Object.keys(errors).length === 0
    console.log('validateForm returning:', isValid, 'for formId:', formId)
    console.log('=== validateForm END ===')
    return isValid
  }

  // Role_Based short-circuits validateForm() in both handleSave and
  // handleInstructionsSave (it only checks role/skills/seniority), so the
  // schedule window was never validated for this type — an empty End Date was
  // posted as null and the backend silently substituted a +30 day deadline that
  // never appeared in the invite email or WhatsApp message.
  //
  // Mirrors the non-scheduled branch of validateForm: broadcasts are open-ended
  // by design and are exempt from the end-of-window fields.
  const validateRoleBasedSchedule = form => {
    const missing = []
    if (!form?.startDate) { missing.push('Start Date') }
    if (!form?.startTime) { missing.push('Start Time') }
    if (!form?.isBroadcast) {
      if (!form?.endDate) { missing.push('End Date') }
      if (!form?.endTime) { missing.push('End Time') }
    }

    if (missing.length > 0) {
      message.error(`Please fill all required fields (${missing.join(', ')})`)
      return false
    }
    return true
  }

  // All validation is now handled by validateForm() above with proper Ant Design notifications.
  // This is kept as a pass-through for backward compatibility with the handleSave flow.
  const validateAssessmentForm = () => true

  const streamOptions = [
    { value: 'engineering', label: 'Engineering' },
    { value: 'science', label: 'Science' },
    { value: 'commerce', label: 'Commerce' },
    { value: 'management', label: 'Management' },
  ]

  const getAssessmentDescription = type => {
    switch (type) {
      case 'Behavior':
        return {
          title:
            'Questions focused on behavioural traits like problem-solving, leadership, and teamwork.',
          subtitle:
            'All questions must be answered, with no option to skip or select',
        }
      case 'Communication':
        return {
          title: 'This assessment includes',
          parameters: [
            {
              label: 'Reading Comprehension',
              params: 'Reading Ability & Comprehension',
            },
            {
              label: 'Video Response',
              params: 'English language verbal ability',
            },
            { label: 'Audio Question', params: 'Listening Ability' },
          ],
        }
      case 'Custom_Assessment':
        return {
          title: 'This assessment includes',
          subtitle:
            'Custom sections that you configure using Excel upload or manual questions.',
        }
      case 'Cognitive':
        return {
          title:
            'Questions focused on cognitive aptitude, evaluating skills such as logical reasoning, numerical ability, and verbal reasoning.',
          subtitle:
            'All questions must be answered, with no option to skip or select.',
        }
      case 'Tech_MCQ':
        return {
          title:
            'Questions focused on cognitive aptitude, evaluating skills such as logical reasoning, numerical ability, and verbal reasoning.',
          subtitle:
            'All questions must be answered, with no option to skip or select.',
        }
      case 'Tech_Coding':
        return {
          title:
            'Questions focused on cognitive aptitude, evaluating skills such as logical reasoning, numerical ability, and verbal reasoning.',
          subtitle:
            'All questions must be answered, with no option to skip or select.',
        }

      case 'Role_Based':
        return {
          title: 'AI-powered assessment based on specific job roles and requirements',
          subtitle: 'Skills evaluation mapped to industry job roles and custom job descriptions',
        }
      case 'AI_Interview':
        return {
          title: 'AI-powered live interview simulation tailored to specific job roles',
          subtitle: 'Adaptive interview with follow-up questions covering technical, behavioral, and situational scenarios',
        }
      default:
        return { title: '', subtitle: '' }
    }
  }

  const renderAssessmentDescription = (description, assessmentType, formId) => {
    const isInstituteFlow =
      entityType === 'college' || entityType === 'institute'
    const isCorporateAptitude =
      !isInstituteFlow && assessmentType === 'Aptitude'

    // Don't render description for corporate aptitude assessments
    if (isCorporateAptitude) {
      return null
    }

    // Don't render "This assessment includes" for corporate Communication assessments
    const isCorporateCommunication = !isInstituteFlow && (assessmentType === 'Communication' || assessmentType === 'Hinglish')
    if (isCorporateCommunication) {
      return null
    }

    if (description.parameters) {
      return (
        <>
          <DescriptionHeader>This assessment includes</DescriptionHeader>
          <DescriptionText>
            {description.parameters.map((param, index) => (
              <div key={index} className="parameter-item">
                <span className="parameter-label">{param.label}</span>{' '}
                <span className="parameter-text">
                  (Parameters: {param.params})
                </span>
                {index < description.parameters.length - 1 && ','}
              </div>
            ))}
          </DescriptionText>
        </>
      )
    }

    return (
      <>
        <DescriptionHeader>This assessment includes</DescriptionHeader>
        <DescriptionText>
          <div className="parameter-item">{description.title}</div>
          <div className="parameter-text">{description.subtitle}</div>
        </DescriptionText>
      </>
    )
  }

  useEffect(() => {
    const getAssessments = async () => {
      if (selectedEntityID) {
        await fetchAssessments(selectedEntityID, entityType)
      }
    }
    getAssessments()
  }, [selectedEntityID, entityType, fetchAssessments])

  useEffect(() => {
    // Every type offered here comes from the entity's own subscription
    // (Feature Access → Subscribed Assessment Types). AI_Interview used to be
    // appended unconditionally, which showed it to entities that had never been
    // given it; it is now gated like every other type.
    // AI_Interview_v2 (Complete AI Interview) is configured only in the v2 wizard.
    const formatted = (subscribedAssessment || []).filter(assessment => assessment !== 'AI_Interview_v2').map(assessment => ({
      id: assessment,
      name: assessment === 'AI_Interview' ? 'AI Interview' : assessment,
      type: assessment,
      description: getAssessmentDescription(assessment),
    }))
    // Hinglish is now accessed via Regional Language toggle inside Communication type
    // Set unconditionally: an entity with no subscriptions must show an empty
    // list, not the previously-selected entity's leftovers.
    setLocalAssessments(formatted)
  }, [subscribedAssessment])

  useEffect(() => {
    const fetchEligibilityCriteria = async () => {
      if (selectedEntityID) {
        if (entityType === 'college' || entityType === 'institute') {
          const activeFormId = assessmentForms.activeFormId
          const currentForm = activeFormId
            ? assessmentForms.forms[activeFormId]
            : null

          try {
            const response = await dispatch(
              getEligibilityCriteria({
                campusID: instituteCampusId,
                searchValue: '',
                searchType: 'ALL',
                searchField: [],
                assessmentType: currentForm?.assessmentType,
                entityType: entityType,
              })
            )

            if (Array.isArray(response)) {
              const typesArray = [...new Set(response.map(item => item.type))]
              const customOrder = [
                'UG',
                'PG',
                'DIPLOMA',
                'P.G.DIPLOMA',
                'P_G_DIPLOMA',
                'PHD',
              ]

              const sortedQualifications = typesArray.sort(
                (a, b) => customOrder.indexOf(a) - customOrder.indexOf(b)
              )
              setTypes(sortedQualifications)

              const formId = assessmentForms.activeFormId

              if (!formId) {
                return
              }

              const updatedQualificationData = response.map(newItem => {
                const existingItem = assessmentForms.forms[
                  formId
                ]?.qualificationData?.find(
                  item => item.degreeId === newItem.degreeId
                )

                if (existingItem) {
                  return {
                    ...newItem,
                    isSelected: existingItem.isSelected,
                    streams:
                      newItem.streams?.map(newStream => {
                        const existingStream = existingItem.streams?.find(
                          stream => stream.streamId === newStream.streamId
                        )

                        if (existingStream) {
                          return {
                            ...newStream,
                            isSelected: existingStream.isSelected,
                            specializations:
                              newStream.specializations?.map(newSpec => {
                                const existingSpec =
                                  existingStream.specializations?.find(
                                    spec => spec.id === newSpec.id
                                  )
                                return {
                                  ...newSpec,
                                  isSelected: existingSpec?.isSelected || false,
                                }
                              }) || [],
                          }
                        }
                        return newStream
                      }) || [],
                  }
                }
                return newItem
              })

              setAssessmentForms(prev => ({
                ...prev,
                forms: {
                  ...prev.forms,
                  [formId]: {
                    ...prev.forms[formId],
                    qualificationData: updatedQualificationData,
                  },
                },
              }))
            }
          } catch (error) {
            console.error('Error fetching eligibility criteria:', error)
          }
        } else if (entityType === 'corporate') {
          const formId = assessmentForms.activeFormId
          if (formId) {
            setAssessmentForms(prev => ({
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  qualificationData: [],
                },
              },
            }))
          }
        }
      }
    }

    fetchEligibilityCriteria()
  }, [selectedEntityID, entityType, assessmentForms.activeFormId])

  useEffect(() => {
    const isInstituteFlow =
      entityType === 'college' || entityType === 'institute'

    if (!isInstituteFlow) return

    // Auto-configure aptitude assessments for institute flow
    let needsUpdate = false
    const updates = {}

    Object.keys(assessmentForms.forms).forEach(formId => {
      const currentForm = assessmentForms.forms[formId]

      // Only auto-configure if:
      // 1. It's an Aptitude assessment
      // 2. It's not saved yet
      // 3. It doesn't already have complete aptitude configuration
      // 4. It doesn't have preserved data (to avoid overriding existing data)
      if (
        currentForm?.assessmentType === 'Aptitude' &&
        !currentForm.isSaved &&
        (!currentForm.aptitudeType ||
          currentForm.aptitudeType.length === 0 ||
          !currentForm.aptitudeSubtopics ||
          currentForm.aptitudeSubtopics.length === 0 ||
          !currentForm.duration) &&
        // ✅ NEW: Don't auto-configure if there's preserved data
        !preservedCandidatesData[formId]?.length &&
        !preservedUploadSummaries[formId]?.length
      ) {
        const allAptitudeTypes = [
          'quantitative',
          'logical_reasoning',
          'critical_reasoning',
        ]
        const difficultyLevel = currentForm.difficultyLevel || 'medium'

        // Get question count based on difficulty/duration
        const questionConfig = questionConfigurations[30]?.[difficultyLevel]
        const totalQuestions = questionConfig?.total || 25

        // Use weight-based selection
        const subtopicsToUse = getAllSubtopics()

        console.debug('Auto-configuring institute aptitude form:', {
          formId,
          difficultyLevel,
          totalQuestions,
          selectedSubtopics: subtopicsToUse.length,
          preservedCandidates: preservedCandidatesData[formId]?.length || 0,
          preservedSummaries: preservedUploadSummaries[formId]?.length || 0,
          currentForm: {
            aptitudeType: currentForm.aptitudeType?.length || 0,
            aptitudeSubtopics: currentForm.aptitudeSubtopics?.length || 0,
            duration: currentForm.duration,
          },
        })

        updates[formId] = {
          ...currentForm,
          aptitudeType: allAptitudeTypes,
          aptitudeSubtopics: subtopicsToUse,
          duration: 30, // Fixed at 30 minutes for institutes
          difficultyLevel: difficultyLevel,
          // ✅ PRESERVE any existing preserved data flags
          candidatesPreserved: currentForm.candidatesPreserved || false,
          lastUpdated: currentForm.lastUpdated || Date.now(),
        }
        needsUpdate = true
      }
    })

    // Only update if there are actual changes
    if (needsUpdate) {
      console.debug('Applying auto-configuration updates:', updates)
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          ...updates,
        },
      }))
    }
  }, [
    entityType,
    assessmentForms.activeFormId,
    // ✅ Add preserved data to dependencies to prevent overriding
    Object.keys(preservedCandidatesData).join(','),
    Object.keys(preservedUploadSummaries).join(','),
    JSON.stringify(
      Object.keys(assessmentForms.forms).map(id => ({
        id,
        assessmentType: assessmentForms.forms[id]?.assessmentType,
        isSaved: assessmentForms.forms[id]?.isSaved,
        hasAptitudeConfig: !!(
          assessmentForms.forms[id]?.aptitudeType?.length &&
          assessmentForms.forms[id]?.aptitudeSubtopics?.length
        ),
        candidatesPreserved: assessmentForms.forms[id]?.candidatesPreserved,
      }))
    ),
  ])

  useEffect(() => {
    const activeId = assessmentForms.activeFormId
    if (activeId && uploadedStudents.length > 0) {
      const formStudents = uploadedStudents.filter(s => s.formId === activeId)
      const existingSummaries = uploadSummaries.filter(
        s => s.formId === activeId
      )

      // If we have students but no summaries, create them
      if (formStudents.length > 0 && existingSummaries.length === 0) {
        console.log(
          'Creating missing upload summaries for students:',
          formStudents
        )

        const groupedStudents = {}

        if (entityType === 'corporate') {
          const key = `corporate-${activeId}`
          groupedStudents[key] = {
            students: formStudents,
            count: formStudents.length,
          }
        } else {
          formStudents.forEach(student => {
            let key
            if (student.degree && student.department) {
              const degreeId =
                student.degree.degreeId ||
                student.degree?.degreeName ||
                'unknown'
              const departmentId =
                student.department.streamId ||
                student.department?.streamName ||
                'unknown'
              const specializationId =
                student.specialization?.specialisationId ||
                student.specialization?.specialisationName ||
                'none'
              key = `${degreeId}-${departmentId}-${specializationId}`
            } else {
              key = `uploaded-${activeId}`
            }

            if (!groupedStudents[key]) {
              groupedStudents[key] = {
                students: [],
                degree: student.degree || {
                  degreeName: 'Various',
                  degreeShortForm: '',
                },
                department: student.department || {
                  streamName: 'Multiple Departments',
                },
                specialization: student.specialization || null,
              }
            }
            groupedStudents[key].students.push(student)
          })
        }

        const newSummaries = Object.values(groupedStudents).map(group => ({
          id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          formId: activeId,
          count: group.students.length,
          ...(entityType === 'college' && {
            degree: group.degree,
            department: group.department,
            specialization: group.specialization,
          }),
        }))

        setUploadSummaries(prev => [
          ...prev.filter(summary => summary.formId !== activeId),
          ...newSummaries,
        ])
      }
    }
  }, [uploadedStudents, assessmentForms.activeFormId, entityType])

  const updateIsSelected = (
    field,
    value,
    formId,
    degreeId,
    departmentId,
    specialisationId
  ) => {
    try {
      const updatedData = [
        ...(assessmentForms.forms[formId]?.qualificationData || []),
      ]
      const degreeIndex = updatedData.findIndex(d => d.degreeId === degreeId)

      if (degreeIndex === -1) return

      switch (field) {
        case 'degree':
          updatedData[degreeIndex].isSelected = value
          updatedData[degreeIndex].streams?.forEach(stream => {
            stream.isSelected = value
            stream.specializations?.forEach(spec => {
              spec.isSelected = value
            })
          })
          break

        case 'stream':
          const streamIndex = updatedData[degreeIndex].streams?.findIndex(
            s => s.streamId === departmentId
          )
          if (streamIndex !== -1) {
            updatedData[degreeIndex].streams[streamIndex].isSelected = value
            updatedData[degreeIndex].streams[
              streamIndex
            ].specializations?.forEach(spec => {
              spec.isSelected = value
            })
            updatedData[degreeIndex].isSelected = updatedData[
              degreeIndex
            ].streams.every(s => s.isSelected)
          }
          break

        case 'spec':
          const sIndex = updatedData[degreeIndex].streams?.findIndex(
            s => s.streamId === departmentId
          )
          if (sIndex !== -1) {
            const specIndex = updatedData[degreeIndex].streams[
              sIndex
            ].specializations?.findIndex(s => s.id === specialisationId)
            if (specIndex !== -1) {
              updatedData[degreeIndex].streams[sIndex].specializations[
                specIndex
              ].isSelected = value
              if (
                updatedData[degreeIndex].streams[sIndex].specializations.some(
                  s => !s.isSelected
                )
              ) {
                updatedData[degreeIndex].streams[sIndex].isSelected = false
              }
              updatedData[degreeIndex].isSelected = updatedData[
                degreeIndex
              ].streams.every(s => s.isSelected)
            }
          }
          break
      }

      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            qualificationData: updatedData,
          },
        },
      }))
    } catch (error) {
      console.error('Error in updateIsSelected:', error)
    }
  }

  const checkedData = (
    value,
    field,
    formId,
    degreeId,
    departmentId,
    specialisationId
  ) => {
    try {
      if (!formId) return

      updateIsSelected(
        field,
        value,
        formId,
        degreeId,
        departmentId,
        specialisationId
      )

      const currentForm = assessmentForms.forms[formId]
      if (!currentForm?.qualificationData) return

      const degree = currentForm.qualificationData.find(
        d => d.degreeId === degreeId
      )
      if (!degree) return

      const stream = degree.streams?.find(s => s.streamId === departmentId)
      if (!stream && field !== 'degree') return

      let updatedDegrees = [...(currentForm.selectedDegrees || [])]
      const existingDegreeIndex = updatedDegrees.findIndex(
        d => d.degreeId === degreeId
      )

      switch (field) {
        case 'degree':
          if (value) {
            if (existingDegreeIndex === -1) {
              updatedDegrees.push({
                ...degree,
                shortForm: degree.shortForm,
                streams: degree.streams?.map(stream => ({
                  ...stream,
                  name: stream.name,
                  specializations: stream.specializations?.map(spec => ({
                    ...spec,
                    name: spec.name,
                    isSelected: true,
                  })),
                })),
              })
            }
          } else {
            updatedDegrees = updatedDegrees.filter(d => d.degreeId !== degreeId)
          }
          break

        case 'stream':
          const stream = degree.streams?.find(s => s.streamId === departmentId)
          if (!stream) return

          if (value) {
            if (existingDegreeIndex === -1) {
              updatedDegrees.push({
                ...degree,
                shortForm: degree.shortForm,
                streams: [
                  {
                    ...stream,
                    name: stream.name,
                    specializations: stream.specializations?.map(spec => ({
                      ...spec,
                      name: spec.name,
                      isSelected: true,
                    })),
                  },
                ],
              })
            } else {
              const existingStream = updatedDegrees[
                existingDegreeIndex
              ].streams?.find(s => s.streamId === departmentId)
              if (!existingStream) {
                updatedDegrees[existingDegreeIndex].streams.push({
                  ...stream,
                  name: stream.name,
                  specializations: stream.specializations?.map(spec => ({
                    ...spec,
                    name: spec.name,
                    isSelected: true,
                  })),
                })
              }
            }
          } else {
            if (existingDegreeIndex !== -1) {
              updatedDegrees[existingDegreeIndex].streams = updatedDegrees[
                existingDegreeIndex
              ].streams.filter(s => s.streamId !== departmentId)

              if (updatedDegrees[existingDegreeIndex].streams.length === 0) {
                updatedDegrees = updatedDegrees.filter(
                  d => d.degreeId !== degreeId
                )
              }
            }
          }
          break

        case 'spec':
          const spec = stream.specializations?.find(
            s => s.id === specialisationId
          )

          if (!spec) return

          if (value) {
            if (existingDegreeIndex === -1) {
              updatedDegrees.push({
                ...degree,
                shortForm: degree.shortForm,
                streams: [
                  {
                    ...stream,
                    name: stream.name,
                    specializations: [
                      {
                        ...spec,
                        name: spec.name,
                        isSelected: true,
                      },
                    ],
                  },
                ],
              })
            } else {
              const existingStream = updatedDegrees[
                existingDegreeIndex
              ].streams?.find(s => s.streamId === departmentId)

              if (!existingStream) {
                updatedDegrees[existingDegreeIndex].streams = [
                  ...(updatedDegrees[existingDegreeIndex].streams || []),
                  {
                    ...stream,
                    name: stream.name,
                    specializations: [
                      {
                        ...spec,
                        name: spec.name,
                        isSelected: true,
                      },
                    ],
                  },
                ]
              } else {
                if (
                  !existingStream.specializations?.find(
                    s => s.id === specialisationId
                  )
                ) {
                  existingStream.specializations = [
                    ...(existingStream.specializations || []),
                    {
                      ...spec,
                      name: spec.name,
                      isSelected: true,
                    },
                  ]
                }
              }
            }
          } else {
            if (existingDegreeIndex !== -1) {
              const streamIndex = updatedDegrees[
                existingDegreeIndex
              ].streams?.findIndex(s => s.streamId === departmentId)
              if (streamIndex !== -1) {
                updatedDegrees[existingDegreeIndex].streams[
                  streamIndex
                ].specializations = updatedDegrees[existingDegreeIndex].streams[
                  streamIndex
                ].specializations?.filter(s => s.id !== specialisationId)

                if (
                  updatedDegrees[existingDegreeIndex].streams[streamIndex]
                    .specializations?.length === 0
                ) {
                  updatedDegrees[existingDegreeIndex].streams.splice(
                    streamIndex,
                    1
                  )
                }
                if (updatedDegrees[existingDegreeIndex].streams.length === 0) {
                  updatedDegrees = updatedDegrees.filter(
                    d => d.degreeId !== degreeId
                  )
                }
              }
            }
          }
          break
      }

      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            selectedDegrees: updatedDegrees,
          },
        },
      }))
    } catch (error) {
      console.error('Error in checkedData:', error)
    }
  }

  const handleStreamsChange = (value, formId) => {
    try {
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...(prev.forms[formId] || defaultFormState),
            selectedStreams: value,
          },
        },
      }))
    } catch (error) {
      console.error('Error in handleStreamsChange:', error)
    }
  }

  useEffect(() => {
    const formId = assessmentForms.activeFormId;
    const form = assessmentForms.forms[formId];
    if (
      form?.assessmentType === 'Custom_Assessment' &&
      (!form.industry_domain || !form.industry_domain.trim())
    ) {
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            industry_domain: 'Universal'
          }
        }
      }));
    }
  }, [assessmentForms.activeFormId, assessmentForms.forms]);

  const handleAssessmentChange = async (value, formId) => {
    console.log('=== handleAssessmentChange START ===')
    console.log('Assessment type changed to:', value, 'for formId:', formId)

    const currentForm = assessmentForms.forms[formId]
    const currentQualificationData = currentForm?.qualificationData || []
    const currentSelectedStudents = currentForm?.selectedStudents || []

    setAssessmentTypeData(value);

    // ✅ CRITICAL FIX: Create a clean form object based on assessment type
    let newFormData = {
      ...currentForm,
      assessmentType: value,
      qualificationData: currentQualificationData,
      selectedStudents: currentSelectedStudents,
      isCheckboxSelected: currentSelectedStudents.length > 0,
    }

    // ✅ CRITICAL FIX: Only add fields that belong to the specific assessment type
    if (value === 'Behavior') {
      newFormData.selectedStreams = currentForm?.selectedStreams || []
      // Remove all other assessment-specific fields
      delete newFormData.cefrLevel
      delete newFormData.aptitudeType
      delete newFormData.aptitudeSubtopics
      delete newFormData.duration
      delete newFormData.difficultyLevel
      delete newFormData.allowNegativeMarking
      delete newFormData.assessmentLink
      console.log(
        'Behavior assessment - keeping selectedStreams, removing aptitude fields'
      )
    } else if (value === 'Communication' || value === 'Hinglish') {
      newFormData.cefrLevel = currentForm?.cefrLevel || 'B1'
      newFormData.enabledSections = normalizeEnabledSections(currentForm?.enabledSections)
      newFormData.useDomainSelection = currentForm?.useDomainSelection || false
      newFormData.selectedDomain = currentForm?.selectedDomain || ''
      newFormData.selectedDomains = currentForm?.selectedDomains || []
      newFormData.responseLanguage = currentForm?.responseLanguage || 'English'
      // Remove other assessment-specific fields
      delete newFormData.selectedStreams
      delete newFormData.aptitudeType
      delete newFormData.aptitudeSubtopics
      delete newFormData.duration
      delete newFormData.difficultyLevel
      delete newFormData.allowNegativeMarking
      delete newFormData.assessmentLink
    } else if (value === 'Aptitude') {
      newFormData.aptitudeType = currentForm?.aptitudeType || []
      newFormData.aptitudeSubtopics = currentForm?.aptitudeSubtopics || []
      newFormData.allowNegativeMarking =
        currentForm?.allowNegativeMarking ?? false
      newFormData.duration =
        currentForm?.duration || (entityType === 'college' ? 45 : 60)
      newFormData.difficultyLevel = currentForm?.difficultyLevel || 'medium'
      // Remove other assessment-specific fields
      delete newFormData.selectedStreams
      delete newFormData.cefrLevel
      delete newFormData.assessmentLink
      console.log(
        'Aptitude assessment - keeping aptitude fields, removing others'
      )
    }
    else if (value === 'Custom_Assessment') {
      newFormData.industry_domain = currentForm?.industry_domain?.trim()
        ? currentForm.industry_domain
        : 'Universal';

      // Fetch available sections when Custom Assessment is selected
      const fetchSections = async () => {
        try {
          const result = await dispatch(fetchCustomSections(selectedEntityID));
          if (result.success) {
            // Store available sections in form state
            setAssessmentForms(prev => ({
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  availableCustomSections: result.sections || [],
                  customSections: prev.forms[formId]?.customSections || [],
                  customSectionConfig: prev.forms[formId]?.customSectionConfig || {},
                  selectedSectionIds: prev.forms[formId]?.selectedSectionIds || []
                }
              }
            }));
          }
        } catch (error) {
          console.error('Failed to fetch custom sections:', error);
        }
      };

      fetchSections();

      // Initialize custom assessment fields if they don't exist
      newFormData.customSections = currentForm?.customSections || [];
      newFormData.customSectionConfig = currentForm?.customSectionConfig || {};
      newFormData.availableCustomSections = currentForm?.availableCustomSections || [];
      newFormData.selectedSectionIds = currentForm?.selectedSectionIds || [];

      // Remove other assessment-specific fields
      delete newFormData.cefrLevel;
      delete newFormData.selectedStreams;
      delete newFormData.aptitudeType;
      delete newFormData.aptitudeSubtopics;
      delete newFormData.duration;
      delete newFormData.difficultyLevel;
      delete newFormData.allowNegativeMarking;
      delete newFormData.assessmentLink;
    } else if (value === 'AI_Interview') {
      newFormData.aiInterviewJobRole = currentForm?.aiInterviewJobRole || ''
      newFormData.aiInterviewSeniority = currentForm?.aiInterviewSeniority || 'Mid'
      newFormData.aiInterviewSkills = currentForm?.aiInterviewSkills || []
      newFormData.aiInterviewIndustryDomain = currentForm?.aiInterviewIndustryDomain || ''
      newFormData.aiInterviewJobDescription = currentForm?.aiInterviewJobDescription || ''
      newFormData.aiInterviewDuration = currentForm?.aiInterviewDuration || 60
      newFormData.aiInterviewEnableFollowUp = currentForm?.aiInterviewEnableFollowUp ?? true
      newFormData.aiInterviewQuestionTypes = currentForm?.aiInterviewQuestionTypes || ['Technical', 'Behavioral']
      newFormData.aiInterviewMode = currentForm?.aiInterviewMode || 'full_interview'
      // Remove other assessment-specific fields
      delete newFormData.selectedStreams
      delete newFormData.cefrLevel
      delete newFormData.aptitudeType
      delete newFormData.aptitudeSubtopics
      delete newFormData.duration
      delete newFormData.difficultyLevel
      delete newFormData.allowNegativeMarking
      delete newFormData.assessmentLink
      console.log('AI_Interview assessment - setting interview config fields')
    } else if (['Cognitive', 'Tech_MCQ', 'Tech_Coding'].includes(value)) {
      newFormData.assessmentLink = currentForm?.assessmentLink || null
      // Remove all other assessment-specific fields
      delete newFormData.selectedStreams
      delete newFormData.cefrLevel
      delete newFormData.aptitudeType
      delete newFormData.aptitudeSubtopics
      delete newFormData.duration
      delete newFormData.difficultyLevel
      delete newFormData.allowNegativeMarking
      console.log(
        'Link-based assessment - keeping assessmentLink, removing aptitude fields'
      )
    } else {
      // For any other assessment type, remove all specific fields
      delete newFormData.selectedStreams
      delete newFormData.cefrLevel
      delete newFormData.aptitudeType
      delete newFormData.aptitudeSubtopics
      delete newFormData.duration
      delete newFormData.difficultyLevel
      delete newFormData.allowNegativeMarking
      delete newFormData.assessmentLink
      console.log('Other assessment type - removing all specific fields')
    }

    setAssessmentForms(prev => ({
      ...prev,
      activeFormId: formId,
      forms: {
        ...prev.forms,
        [formId]: newFormData,
      },
    }))

    // Rest of the function for eligibility criteria fetching
    if (selectedEntityID && entityType === 'college') {
      try {
        console.log('Fetching eligibility criteria for:', value)
        const response = await dispatch(
          getEligibilityCriteria({
            campusID: instituteCampusId,
            searchValue: '',
            searchType: 'ALL',
            searchField: [],
            assessmentType: value,
          })
        )

        if (Array.isArray(response)) {
          const updatedQualificationData = response.map(newItem => {
            const existingItem = currentQualificationData.find(
              item => item.degreeId === newItem.degreeId
            )
            if (existingItem) {
              return {
                ...newItem,
                isSelected: existingItem.isSelected,
                streams:
                  newItem.streams?.map(newStream => {
                    const existingStream = existingItem.streams?.find(
                      stream => stream.streamId === newStream.streamId
                    )
                    if (existingStream) {
                      return {
                        ...newStream,
                        isSelected: existingStream.isSelected,
                        specializations:
                          newStream.specializations?.map(newSpec => {
                            const existingSpec =
                              existingStream.specializations?.find(
                                spec => spec.id === newSpec.id
                              )
                            return {
                              ...newSpec,
                              isSelected: existingSpec?.isSelected || false,
                            }
                          }) || [],
                      }
                    }
                    return newStream
                  }) || [],
              }
            }
            return newItem
          })

          const typesArray = [...new Set(response.map(item => item.type))]
          const customOrder = [
            'UG',
            'PG',
            'DIPLOMA',
            'P.G.DIPLOMA',
            'P_G_DIPLOMA',
            'PHD',
          ]
          const sortedQualifications = typesArray.sort(
            (a, b) => customOrder.indexOf(a) - customOrder.indexOf(b)
          )
          setTypes(sortedQualifications)

          setAssessmentForms(prev => ({
            ...prev,
            forms: {
              ...prev.forms,
              [formId]: {
                ...prev.forms[formId],
                qualificationData: updatedQualificationData,
              },
            },
          }))

          console.log('Eligibility criteria updated successfully')
        }
      } catch (error) {
        console.error('Error fetching eligibility criteria:', error)
      }
    }

    console.log('=== handleAssessmentChange END ===')
  }

  // A selection is only answerable against a specific difficulty and length, so
  // the cached answer is keyed by all three. Any edit changes the key and
  // triggers a fresh check.
  const buildAvailabilityKey = (form, duration) =>
    [
      duration,
      form.difficultyLevel || 'medium',
      [...(form.aptitudeSubtopics || [])].sort().join(','),
    ].join('|')

  const aptitudeDurationFor = form =>
    entityType === 'college' || entityType === 'institute'
      ? 45
      : form.duration || 60

  // Pre-flight the topic selection against the live question bank. Without it a
  // too-narrow selection is only discovered at assign time, where the selector
  // silently falls back to a paper built from topics the admin did not choose.
  useEffect(() => {
    const formId = assessmentForms.activeFormId
    const form = assessmentForms.forms[formId]
    if (!form || form.assessmentType !== 'Aptitude') return undefined

    const subtopics = form.aptitudeSubtopics || []
    const aptitudeTypes = form.aptitudeType || []
    if (aptitudeTypes.length === 0 || subtopics.length < MIN_APTITUDE_TOPICS) {
      return undefined
    }

    const duration = aptitudeDurationFor(form)
    const config = questionConfigurations[duration]?.[form.difficultyLevel || 'medium']
    if (!config) return undefined

    const key = buildAvailabilityKey(form, duration)
    if (topicAvailability[formId]?.key === key) return undefined

    let isStale = false
    setIsCheckingAvailability(true)
    dispatch(
      checkAptitudeTopicAvailability({
        aptitudeTypes,
        subtopics,
        difficultySettings: {
          easy: config.easy,
          medium: config.medium,
          hard: config.hard,
        },
      })
    )
      .then(result => {
        if (isStale) return
        // Store even a null result under the key: a pre-flight that could not
        // run must not retry on every render.
        setTopicAvailability(prev => ({ ...prev, [formId]: { key, result } }))
      })
      .finally(() => {
        if (!isStale) setIsCheckingAvailability(false)
      })

    return () => {
      isStale = true
    }
  }, [
    dispatch,
    entityType,
    assessmentForms.activeFormId,
    assessmentForms.forms,
    topicAvailability,
  ])

  const renderTopicAvailability = formId => {
    const availability = topicAvailability[formId]?.result

    if (isCheckingAvailability && !availability) {
      return <BodyText>Checking question availability…</BodyText>
    }
    if (!availability || availability.canGenerate !== false) return null

    const shortfalls = availability.shortfalls || []

    return (
      <div style={{ maxWidth: '520px', marginBottom: '16px' }}>
        <ValidationErrorText>
          Not enough questions for this selection
        </ValidationErrorText>
        {availability.message && <BodyText>{availability.message}</BodyText>}
        {shortfalls.slice(0, 5).map(shortfall => (
          <BodyText key={`${shortfall.topic || 'all'}-${shortfall.difficulty}`}>
            {shortfall.topic
              ? `${shortfall.topic} (${shortfall.difficulty})`
              : `${shortfall.difficulty} questions`}
            : {shortfall.available} available, {shortfall.required} needed
          </BodyText>
        ))}
        {shortfalls.length > 5 && (
          <BodyText>…and {shortfalls.length - 5} more</BodyText>
        )}
        <BodyText>
          Add more topics, lower the difficulty, or generate questions in
          Question Manager.
        </BodyText>
      </div>
    )
  }

  const renderAptitudeTopics = formId => {
    const currentForm = assessmentForms.forms[formId]
    const isInstituteFlow =
      entityType === 'college' || entityType === 'institute'

    console.log('renderAptitudeTopics called with:', {
      formId,
      isInstituteFlow,
      formattedAptitudeTopics,
      hasData: Object.keys(formattedAptitudeTopics).length > 0,
    })

    // Topic selection is shared by both flows — an institute admin picks
    // sections and sub-topics exactly the way a corporate one does. Only the
    // surrounding configuration differs (institute papers are fixed at 45
    // minutes / 30 questions, corporate chooses a duration).
    const currentAptitudeTypes = currentForm?.aptitudeType || []
    const currentSubtopics = currentForm?.aptitudeSubtopics || []
    const currentDifficultyLevel = currentForm?.difficultyLevel || 'medium'

    const aptitudeTypeCards = [
      {
        key: 'quantitative',
        title: 'Quantitative',
        description: 'Mathematical and numerical reasoning skills',
        topics: formattedAptitudeTopics?.quantitative || [],
      },
      {
        key: 'logical_reasoning',
        title: 'Logical Reasoning',
        description: 'Pattern recognition and logical thinking',
        topics: formattedAptitudeTopics?.logical_reasoning || [],
      },
      {
        key: 'critical_reasoning',
        title: 'Critical Reasoning',
        description: 'Analytical and critical thinking abilities',
        topics: formattedAptitudeTopics?.critical_reasoning || [],
      },
    ]

    const handleCardClick = () => {
      // Open modal directly when any card is clicked
      setShowTopicModal(true)
    }

    const getSelectedTopicsForType = typeKey => {
      const typeTopics = getSubtopicNames(typeKey)
      return currentSubtopics.filter(topic => typeTopics.includes(topic))
    }

    const handleTopicSelectionComplete = selectedTopicsFromModal => {
      // Convert selected topics back to flat array
      const allSelectedTopics = []
      const selectedTypes = []

      Object.keys(selectedTopicsFromModal).forEach(category => {
        if (
          selectedTopicsFromModal[category] &&
          selectedTopicsFromModal[category].length > 0
        ) {
          selectedTypes.push(category)
          allSelectedTopics.push(...selectedTopicsFromModal[category])
        }
      })

      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [formId]: {
            ...prev.forms[formId],
            aptitudeType: selectedTypes,
            aptitudeSubtopics: allSelectedTopics,
          },
        },
      }))

      setShowTopicModal(false)
      setTopicAvailability(prev => ({ ...prev, [formId]: null }))

      // Clear validation errors
      if (validationErrors[formId]?.aptitudeType) {
        setValidationErrors(prev => ({
          ...prev,
          [formId]: {
            ...prev[formId],
            aptitudeType: false,
            aptitudeSubtopics: false,
          },
        }))
      }
    }

    const renderTopicPicker = () => (
      <>
        <Label>Select Aptitude sections</Label>
        <br />

        <div style={{ maxWidth: '520px' }}>
          <AptitudeTypeCardsContainer>
            {aptitudeTypeCards.map(card => {
              const isSelected = currentAptitudeTypes.includes(card.key)
              const selectedTopicsCount = getSelectedTopicsForType(card.key).length

              return (
                <AptitudeTypeCard
                  key={card.key}
                  isSelected={isSelected}
                  topicCount={selectedTopicsCount}
                  onClick={handleCardClick}
                >
                  <AptitudeTypeTitle isSelected={isSelected}>
                    {card.title}
                  </AptitudeTypeTitle>
                </AptitudeTypeCard>
              )
            })}
          </AptitudeTypeCardsContainer>
        </div>

        {validationErrors[formId]?.aptitudeType && (
          <ValidationErrorText>
            Please select at least one aptitude type
          </ValidationErrorText>
        )}

        {currentSubtopics.length > 0 && (
          <div style={{ maxWidth: '520px' }}>
            <div
              style={{
                backgroundColor:
                  currentSubtopics.length >= MIN_APTITUDE_TOPICS
                    ? '#f8fafc'
                    : '#fff1f2',
                border: '1px solid #A9A9A9',
                borderRadius: '8px',
                marginBottom: '16px',
              }}
            >
              <SubsectionHeading>
                {currentSubtopics.length} Topics selected
                {currentSubtopics.length < MIN_APTITUDE_TOPICS &&
                  ` (minimum ${MIN_APTITUDE_TOPICS} required)`}
              </SubsectionHeading>
              <BodyText>
                Categories:{' '}
                {currentAptitudeTypes
                  .map(type => APTITUDE_TYPE_LABELS[type] || type)
                  .join(', ')}
              </BodyText>
            </div>
          </div>
        )}

        {currentSubtopics.length > 0 &&
          currentSubtopics.length < MIN_APTITUDE_TOPICS && (
            <ValidationErrorText>
              Please select at least {MIN_APTITUDE_TOPICS} topics to create a
              balanced assessment
            </ValidationErrorText>
          )}

        {/* Scheduled aptitude assessments feed the student's progression: the
            topic scores from every run are averaged into one competency
            picture. Papers built from different topic sets are not directly
            comparable, and the selection is fixed for the life of the
            schedule, so the admin is told before they commit to it. */}
        {currentForm?.distributionType === 'scheduled' &&
          currentSubtopics.length > 0 && (
            <div style={{ maxWidth: '520px', marginBottom: '16px' }}>
              <BodyText>
                This topic selection applies to every run of the schedule,
                including the diagnosis assessments. Scores measured on
                different topic sets are not directly comparable with past
                attempts.
              </BodyText>
            </div>
          )}

        {renderTopicAvailability(formId)}
      </>
    )

    const renderTopicModal = () => (
      <TopicSelectionModal
        showModal={showTopicModal}
        setShowModal={setShowTopicModal}
        onContinue={handleTopicSelectionComplete}
        formattedAptitudeTopics={formattedAptitudeTopics}
        initialSelectedTopics={{
          quantitative: getSelectedTopicsForType('quantitative'),
          logical_reasoning: getSelectedTopicsForType('logical_reasoning'),
          critical_reasoning: getSelectedTopicsForType('critical_reasoning'),
        }}
        minTopicsRequired={MIN_APTITUDE_TOPICS}
      />
    )

    // Check if this is institute/college entity type to determine flow
    if (isInstituteFlow) {

      const totalQuestions =
        questionConfigurations[30]?.[currentDifficultyLevel]?.total || 25
      const topicDistribution = getTopicDistribution(30, currentDifficultyLevel)
      return (
        <div style={{ marginTop: '16px' }}>
          {/* Difficulty Level Selection for Institutes - moved to top */}
          <div style={{ marginBottom: '20px' }}>
            <Label>Select Difficulty Level *</Label>
            <StreamRadioGroup
              error={validationErrors[formId]?.difficultyLevel}
              value={currentDifficultyLevel}
              onChange={e => {
                handleDifficultyLevelChange(e.target.value, formId)
                if (validationErrors[formId]?.difficultyLevel) {
                  setValidationErrors(prev => ({
                    ...prev,
                    [formId]: {
                      ...prev[formId],
                      difficultyLevel: false,
                    },
                  }))
                }
              }}
            >
              <Radio value="easy">Easy</Radio>
              <Radio value="medium">Medium</Radio>
              <Radio value="hard">Hard</Radio>
            </StreamRadioGroup>
          </div>

          {renderTopicPicker()}

          {currentDifficultyLevel && (
            <AssessmentConfigContainer>
              <SectionHeading>Assessment Configuration</SectionHeading>

              <ConfigurationItem>
                <SubsectionHeading>Selected Aptitude Types:</SubsectionHeading>
                <BodyText>
                  {currentAptitudeTypes.length > 0
                    ? currentAptitudeTypes
                      .map(type => APTITUDE_TYPE_LABELS[type] || type)
                      .join(', ')
                    : 'None selected yet'}
                </BodyText>
              </ConfigurationItem>

              <ConfigurationItem>
                <SubsectionHeading>Selected Subtopics:</SubsectionHeading>
                <BodyText>{currentSubtopics.length} topics selected</BodyText>
              </ConfigurationItem>

              <ConfigurationItem>
                <SubsectionHeading>Duration:</SubsectionHeading>
                <BodyText>30 Minutes (Fixed for Institute)</BodyText>
              </ConfigurationItem>

              <ConfigurationItem>
                <SubsectionHeading>Section Distribution:</SubsectionHeading>
                <BodyText>
                  {(() => {
                    if (!instituteAptitudeCfg) return ''
                    const s = instituteAptitudeCfg.sections || {}
                    const t = instituteAptitudeCfg.totalQuestions || 0
                    const pct = n => (t ? Math.round((n / t) * 100) : 0)
                    const q = s['Quantitative'] || 0
                    const l = s['Logical Reasoning'] || 0
                    const c = s['Critical Reasoning'] || 0
                    return `Quantitative: ${q} (${pct(q)}%) | Logical Reasoning: ${l} (${pct(l)}%) | Critical Reasoning: ${c} (${pct(c)}%)`
                  })()}
                </BodyText>
              </ConfigurationItem>

              <ConfigurationNote>
                Note: Questions are drawn only from the topics selected above.
                Duration is fixed at 30 minutes for institute assessments.
              </ConfigurationNote>

              <ConfigurationDetails>
                <ConfigurationSummary>
                  Assessment Configuration Details
                </ConfigurationSummary>

                <ConfigurationDetailsContent>
                  <ConfigurationDetailItem>
                    <strong>Total Questions:</strong>{' '}
                    {(() => {
                      const d =
                        instituteAptitudeCfg?.difficulty?.[currentDifficultyLevel]
                      return d
                        ? `${d.total} Questions (${d.easy} Easy, ${d.medium} Medium, ${d.hard} Hard)`
                        : ''
                    })()}
                  </ConfigurationDetailItem>

                  <ConfigurationDetailItem>
                    <strong>Selected Topics:</strong>{' '}
                    {`${currentSubtopics.length} topics`}
                  </ConfigurationDetailItem>

                  <ConfigurationDetailItem>
                    <strong>Category Distribution:</strong>
                    {(() => {
                      if (!instituteAptitudeCfg) return ''
                      const s = instituteAptitudeCfg.sections || {}
                      return ` Quantitative: ${s['Quantitative'] || 0}, Logical: ${s['Logical Reasoning'] || 0}, Critical: ${s['Critical Reasoning'] || 0}`
                    })()}
                  </ConfigurationDetailItem>
                </ConfigurationDetailsContent>
              </ConfigurationDetails>
            </AssessmentConfigContainer>
          )}

          {renderTopicModal()}
        </div>
      )
    } else {
      // Corporate flow: same topic picker, plus a duration choice.
      const currentDuration = currentForm?.duration || 60


      // Get question configuration for display
      const getQuestionDisplay = (duration, difficultyLevel) => {
        if (
          questionConfigurations[duration] &&
          questionConfigurations[duration][difficultyLevel]
        ) {
          const config = questionConfigurations[duration][difficultyLevel]
          return `${config.total} Questions (${config.easy} Easy, ${config.medium} Medium, ${config.hard} Hard)`
        }
        return ''
      }

      return (
        <div style={{ marginTop: '16px' }}>
          {renderTopicPicker()}

          {/* Assessment Configuration appears once the topic floor is met */}
          {currentSubtopics.length >= MIN_APTITUDE_TOPICS && (
            <>
              <DifficultyContainer>
                <DifficultyTitle>Assessment Configuration</DifficultyTitle>

                {/* Duration Selection */}
                <div style={{ marginBottom: '20px' }}>
                  <Label>Select Duration *</Label>
                  <StreamRadioGroup
                    error={validationErrors[formId]?.duration}
                    value={currentDuration}
                    onChange={e => {
                      handleDurationChange(parseInt(e.target.value), formId)
                      if (validationErrors[formId]?.duration) {
                        setValidationErrors(prev => ({
                          ...prev,
                          [formId]: {
                            ...prev[formId],
                            duration: false,
                          },
                        }))
                      }
                    }}
                  >
                    <Radio value={60}>60 Minutes</Radio>
                    <Radio value={45}>45 Minutes</Radio>
                    <Radio value={30}>30 Minutes</Radio>
                  </StreamRadioGroup>
                </div>

                {/* Difficulty Level Selection */}
                <div style={{ marginBottom: '20px' }}>
                  <Label>Select Difficulty Level *</Label>
                  <StreamRadioGroup
                    error={validationErrors[formId]?.difficultyLevel}
                    value={currentDifficultyLevel}
                    onChange={e => {
                      handleDifficultyLevelChange(e.target.value, formId)
                      if (validationErrors[formId]?.difficultyLevel) {
                        setValidationErrors(prev => ({
                          ...prev,
                          [formId]: {
                            ...prev[formId],
                            difficultyLevel: false,
                          },
                        }))
                      }
                    }}
                  >
                    <Radio value="easy">Easy</Radio>
                    <Radio value="medium">Medium</Radio>
                    <Radio value="hard">Hard</Radio>
                  </StreamRadioGroup>
                </div>

                {currentDuration && currentDifficultyLevel && (
                  <div
                    style={{
                      padding: '16px',
                      backgroundColor: '#f8fafc',
                      borderRadius: '8px',
                      border: '1px solid #A9A9A9',
                      marginTop: '16px',
                    }}
                  >
                    <SectionHeading>
                      Assessment Configuration Summary
                    </SectionHeading>

                    <ConfigurationText>
                      <strong>Total Questions:</strong>{' '}
                      {getQuestionDisplay(
                        currentDuration,
                        currentDifficultyLevel
                      )}
                    </ConfigurationText>

                    <ConfigurationText>
                      <strong>Duration:</strong> {currentDuration} minutes
                    </ConfigurationText>

                    <ConfigurationText>
                      <strong>Difficulty Distribution:</strong>
                      {(() => {
                        const config =
                          questionConfigurations[currentDuration]?.[
                          currentDifficultyLevel
                          ]
                        return config
                          ? ` ${config.easy} Easy, ${config.medium} Medium, ${config.hard} Hard`
                          : ''
                      })()}
                    </ConfigurationText>

                    <ConfigurationText>
                      <strong>Category Distribution:</strong>
                      {(() => {
                        // Prefer the live backend config (topic-level difficulty
                        // bands: 14/13/13 @ 40Q, 10/10/10 @ 30Q, and the
                        // document-defined 10/9/6 split @ 25Q. Falls back to
                        // the local duration config only if the API has not loaded.
                        const lengthKey =
                          aptitudeQuestionCountByDuration[currentDuration]
                        const sections = aptitudeConfig?.[lengthKey]?.sections
                        if (sections) {
                          return ` Quantitative: ${sections['Quantitative'] || 0}, Logical: ${sections['Logical Reasoning'] || 0}, Critical: ${sections['Critical Reasoning'] || 0}`
                        }
                        const config =
                          questionConfigurations[currentDuration]?.[
                          currentDifficultyLevel
                          ]
                        if (config) {
                          const quantitative = Math.round(config.total * 0.4)
                          const logical = Math.round(config.total * 0.35)
                          const critical = config.total - quantitative - logical
                          return ` Quantitative: ${quantitative}, Logical: ${logical}, Critical: ${critical}`
                        }
                        return ''
                      })()}
                    </ConfigurationText>
                  </div>
                )}
              </DifficultyContainer>
            </>
          )}

          {renderTopicModal()}
        </div>
      )
    }
  }
  console.log('roleBasedQuestionsState:', roleBasedQuestionsState);
  const renderAssessmentOptions = (assessment, formId) => {
    // ✅ ADD THESE LINES HERE - Get form-specific custom assessment data
    const activeForm = assessmentForms.forms[formId]; // Use formId parameter, not activeFormId
    const customSections = activeForm?.customSections || [];
    const customSectionConfig = activeForm?.customSectionConfig || {};
    const availableCustomSections = activeForm?.availableCustomSections || [];
    const selectedSectionIds = activeForm?.selectedSectionIds || [];

    switch (assessment) {
      case 'Behavior':
        return (
          <div style={{ marginTop: '16px' }}>
            <Label>Select for</Label>
            <br />
            <StreamRadioGroup
              error={validationErrors[formId]?.selectedStreams}
              value={assessmentForms.forms[formId]?.selectedStreams[0] || ''}
              onChange={e => {
                handleStreamsChange([e.target.value], formId)
                if (validationErrors[formId]?.selectedStreams) {
                  setValidationErrors(prev => ({
                    ...prev,
                    [formId]: {
                      ...prev[formId],
                      selectedStreams: false,
                    },
                  }))
                }
              }}
            >
              {streamOptions.map(option => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </StreamRadioGroup>
          </div>
        )

      case 'Communication':
        return (
          <div style={{ marginTop: '16px' }}>
            {/* CEFR Level Selection */}
            <div style={{ marginBottom: '16px' }}>
              <Label>Select CEFR Level</Label>
              <br />
              <StreamRadioGroup
                error={validationErrors[formId]?.cefrLevel}
                value={assessmentForms.forms[formId]?.cefrLevel || ''}
                onChange={e => {
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        cefrLevel: e.target.value,
                      },
                    },
                  }))
                  if (validationErrors[formId]?.cefrLevel) {
                    setValidationErrors(prev => ({
                      ...prev,
                      [formId]: {
                        ...prev[formId],
                        cefrLevel: false,
                      },
                    }))
                  }
                }}
              >
                {['A1', 'A2', 'B1', 'B2', 'C1', 'C2'].map(level => (
                  <Radio key={level} value={level}>
                    {level}
                  </Radio>
                ))}
              </StreamRadioGroup>
            </div>

            {/* Listening Audio Accent */}
            <div style={{ marginBottom: '16px' }}>
              <Label>Listening Audio Accent</Label>
              <Select
                style={{ width: '100%' }}
                value={assessmentForms.forms[formId]?.accent || 'en-IN'}
                onChange={value => {
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        accent: value,
                        // Previewed questions carry narration audio in the old
                        // accent — force a re-generate after switching.
                        generatedQuestions: undefined,
                      },
                    },
                  }))
                }}
              >
                {LISTENING_ACCENTS.map(a => (
                  <Option key={a.value} value={a.value}>{a.label}</Option>
                ))}
              </Select>
              <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '4px' }}>
                Accent of the narrated audio in the Listening section. Non-default accents generate a fresh question set on assignment.
              </div>
            </div>

            {/* Speaking Evaluation Language - Corporate only */}
            {entityType === 'corporate' && (
            <div style={{ marginBottom: '16px' }}>
              <Label>Speaking Evaluation Language</Label>
              <Select
                style={{ width: '100%' }}
                value={assessmentForms.forms[formId]?.responseLanguage || 'English'}
                onChange={value => {
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        responseLanguage: value,
                        isRegionalLanguage: value !== 'English',
                        generatedQuestions: undefined,
                      },
                    },
                  }))
                }}
              >
                {[
                  'English', 'Hindi', 'Hinglish', 'Tamil', 'Telugu', 'Kannada',
                  'Malayalam', 'Bengali', 'Marathi', 'Gujarati',
                  'Punjabi', 'Odia', 'Assamese', 'Urdu'
                ].map(lang => (
                  <Option key={lang} value={lang}>{lang}</Option>
                ))}
              </Select>
            </div>
            )}

            {/* Topic */}
            <div style={{ marginBottom: '16px' }}>
              <Label>Topic <span style={{ color: '#9CA3AF', fontWeight: 400 }}>(optional)</span></Label>
              <Input
                placeholder="e.g. Customer Care, BFSI"
                value={assessmentForms.forms[formId]?.selectedDomain || ''}
                onChange={e => {
                  const value = e.target.value;
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        selectedDomain: value,
                        selectedDomains: value ? value.split(',').map(s => s.trim()).filter(Boolean) : [],
                        generatedQuestions: undefined,
                      },
                    },
                  }))
                  // Clear generatedQuestions validation error when topic changes
                  if (validationErrors[formId]?.generatedQuestions) {
                    setValidationErrors(prev => ({
                      ...prev,
                      [formId]: { ...prev[formId], generatedQuestions: false },
                    }));
                  }
                }}
                style={{
                  borderRadius: '8px',
                  ...(validationErrors[formId]?.generatedQuestions ? { borderColor: '#ff4d4f' } : {}),
                }}
              />
              <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '4px' }}>
                Comma separated if multiple
              </div>
            </div>

            {/* Section Configuration - Collapsible Dropdown (Corporate only) */}
            {entityType === 'corporate' && (() => {
              const currentSections = normalizeEnabledSections(assessmentForms.forms[formId]?.enabledSections);
              const enabledCount = currentSections.length;
              const allEnabled = enabledCount === ALL_GROUP_KEYS.length && ALL_GROUP_KEYS.every(g => currentSections.includes(g));

              const SECTIONS = [
                {
                  key: 'Reading',
                  color: '#10B981',
                  bgColor: '#ECFDF5',
                  icon: <ReadOutlined style={{ fontSize: 14, color: '#10B981' }} />,
                  desc: 'Paragraph Reading',
                },
                {
                  key: 'Listening',
                  color: '#3B82F6',
                  bgColor: '#EFF6FF',
                  icon: <SoundOutlined style={{ fontSize: 14, color: '#3B82F6' }} />,
                  desc: 'Audio Questions',
                },
                {
                  key: 'Speaking',
                  color: '#8B5CF6',
                  bgColor: '#F5F3FF',
                  icon: <VideoCameraOutlined style={{ fontSize: 14, color: '#8B5CF6' }} />,
                  desc: 'Video Response, Image Based',
                },
                {
                  key: 'Writing',
                  color: '#F59E0B',
                  bgColor: '#FFFBEB',
                  icon: <EditFilled style={{ fontSize: 14, color: '#F59E0B' }} />,
                  desc: 'Email Writing, Dictation, Sentence Completion, Sentence Build',
                },
              ];

              const toggleSection = (key) => {
                setAssessmentForms(prev => {
                  const prevSections = prev.forms[formId]?.enabledSections || [];
                  const newSections = prevSections.includes(key)
                    ? prevSections.filter(s => s !== key)
                    : [...prevSections, key];
                  if (newSections.length === 0) {
                    message.warning('At least one section must be selected');
                    return prev;
                  }
                  return {
                    ...prev,
                    forms: { ...prev.forms, [formId]: { ...prev.forms[formId], enabledSections: newSections } },
                  };
                });
              };

              const toggleAll = () => {
                setAssessmentForms(prev => {
                  const prevSections = prev.forms[formId]?.enabledSections || [];
                  const allOn = ALL_GROUP_KEYS.length === prevSections.length && ALL_GROUP_KEYS.every(k => prevSections.includes(k));
                  const newSections = allOn ? ['Speaking'] : [...ALL_GROUP_KEYS];
                  return {
                    ...prev,
                    forms: { ...prev.forms, [formId]: { ...prev.forms[formId], enabledSections: newSections } },
                  };
                });
              };

              return (
                <div style={{ marginBottom: '20px' }}>
                  {/* Clickable dropdown trigger */}
                  <div
                    onClick={() => setShowSectionConfig(prev => !prev)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '10px 14px',
                      border: validationErrors[formId]?.enabledSections ? '1px solid #ff4d4f' : '1px solid #E5E7EB',
                      borderRadius: showSectionConfig ? '8px 8px 0 0' : '8px',
                      cursor: 'pointer',
                      background: validationErrors[formId]?.enabledSections ? '#fff1f0' : '#fff',
                      transition: 'all 0.2s',
                      userSelect: 'none',
                    }}
                    onMouseEnter={e => { if (!validationErrors[formId]?.enabledSections) { e.currentTarget.style.borderColor = '#444CE7'; e.currentTarget.style.background = '#FAFAFE' } }}
                    onMouseLeave={e => { if (!validationErrors[formId]?.enabledSections) { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.background = '#fff' } }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <SettingOutlined style={{ fontSize: 15, color: '#6B7280' }} />
                      <span style={{ fontSize: '13px', fontWeight: 600, color: '#1F2937' }}>Configure Sections</span>
                      <span style={{
                        fontSize: '11px',
                        fontWeight: 600,
                        color: allEnabled ? '#10B981' : '#F59E0B',
                        background: allEnabled ? '#ECFDF5' : '#FFFBEB',
                        padding: '2px 8px',
                        borderRadius: '10px',
                        lineHeight: '16px',
                      }}>
                        {allEnabled ? 'All sections' : `${enabledCount}/${ALL_GROUP_KEYS.length} active`}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {!allEnabled && !showSectionConfig && (
                        <span style={{ fontSize: '11px', color: '#9CA3AF' }}>
                          {currentSections.join(', ')}
                        </span>
                      )}
                      {showSectionConfig
                        ? <UpOutlined style={{ fontSize: 11, color: '#9CA3AF' }} />
                        : <DownOutlined style={{ fontSize: 11, color: '#9CA3AF' }} />
                      }
                    </div>
                  </div>

                  {/* Expandable panel */}
                  {showSectionConfig && (
                    <div style={{
                      border: '1px solid #E5E7EB',
                      borderTop: 'none',
                      borderRadius: '0 0 8px 8px',
                      overflow: 'hidden',
                      background: '#FAFAFA',
                    }}>
                      {/* Select All bar */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '6px 14px',
                        background: '#F9FAFB',
                        borderBottom: '1px solid #F3F4F6',
                      }}>
                        <span style={{ fontSize: '11px', color: '#6B7280' }}>
                          Choose which sections students will see in this assessment
                        </span>
                        <Button
                          type="link"
                          size="small"
                          onClick={(e) => { e.stopPropagation(); toggleAll(); }}
                          style={{ fontSize: '12px', padding: 0, height: 'auto', color: '#444CE7' }}
                        >
                          {allEnabled ? 'Deselect All' : 'Select All'}
                        </Button>
                      </div>

                      {/* Section toggles */}
                      <div style={{ padding: '6px' }}>
                        {SECTIONS.map(({ key, color, bgColor, icon, desc }, idx) => {
                          const isEnabled = currentSections.includes(key);
                          return (
                            <div
                              key={key}
                              onClick={() => toggleSection(key)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 10px',
                                border: '1px solid #E5E7EB',
                                borderRadius: '6px',
                                marginBottom: idx < SECTIONS.length - 1 ? '6px' : 0,
                                background: isEnabled ? bgColor : '#FAFAFA',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                              }}
                              onMouseEnter={e => { e.currentTarget.style.borderColor = color }}
                              onMouseLeave={e => { e.currentTarget.style.borderColor = '#E5E7EB' }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{
                                  width: 24, height: 24, borderRadius: '6px',
                                  background: isEnabled ? `${color}20` : '#F3F4F6',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                  {icon}
                                </div>
                                <div>
                                  <span style={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: isEnabled ? '#1F2937' : '#9CA3AF',
                                    transition: 'color 0.15s',
                                  }}>
                                    {key}
                                  </span>
                                  <span style={{ fontSize: '10px', color: '#B0B5BE', marginLeft: '8px' }}>{desc}</span>
                                </div>
                              </div>
                              <Switch
                                size="small"
                                checked={isEnabled}
                                onChange={() => {}}
                                style={{ pointerEvents: 'none' }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Generate Questions - only required when topic is provided */}
            {(assessmentForms.forms[formId]?.selectedDomain || '').trim() && (
              <>
                <div style={{
                  marginTop: '8px',
                  padding: '12px',
                  borderRadius: '8px',
                  border: validationErrors[formId]?.generatedQuestions
                    ? '2px solid #ff4d4f'
                    : (assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data)
                      ? '1px solid #52c41a'
                      : '1px solid #e2e8f0',
                  background: validationErrors[formId]?.generatedQuestions
                    ? '#fff2f0'
                    : (assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data)
                      ? '#f6ffed'
                      : '#fafafa',
                }}>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        const form = assessmentForms.forms[formId];
                        if (!form?.cefrLevel) {
                          message.warning('Please select a CEFR Level before generating questions.');
                          return;
                        }
                        dispatch(generateTopicBasedQuestions({
                          cefrLevel: form?.cefrLevel || 'B1',
                          domain: form?.selectedDomain || (form?.selectedDomains || []).join(', ') || '',
                          enabledSections: expandSectionsForBackend(form?.enabledSections || ALL_GROUP_KEYS),
                          accent: form?.accent || 'en-IN',
                        }))
                          .then((result) => {
                            if (result?.error) {
                              message.error(result.error);
                              return;
                            }
                            message.success('Questions generated successfully!');
                            setShowTopicPreview(true);
                            const questionsData = result || topicQuestionsState?.data;
                            if (questionsData) {
                              setAssessmentForms(prev => ({
                                ...prev,
                                forms: {
                                  ...prev.forms,
                                  [formId]: {
                                    ...prev.forms[formId],
                                    generatedQuestions: questionsData,
                                  },
                                },
                              }));
                              // Clear validation error for generatedQuestions
                              if (validationErrors[formId]?.generatedQuestions) {
                                setValidationErrors(prev => ({
                                  ...prev,
                                  [formId]: { ...prev[formId], generatedQuestions: false },
                                }));
                              }
                            }
                          })
                          .catch((err) => {
                            message.error('Failed to generate questions: ' + (err.message || 'Unknown error'));
                          });
                      }}
                      disabled={topicQuestionsState.loading}
                      loading={topicQuestionsState.loading}
                      style={{ backgroundColor: '#444CE7' }}
                    >
                      {topicQuestionsState.loading ? 'Generating...' : 'Generate Questions'}
                    </Button>
                    {(assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data) && (
                      <Button
                        type="default"
                        onClick={() => setShowTopicPreview(prev => !prev)}
                      >
                        {showTopicPreview ? 'Hide Preview' : 'Preview Questions'}
                      </Button>
                    )}
                    {(assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data) && (
                      <span style={{ color: '#52c41a', fontSize: '13px', fontWeight: 500 }}>Questions ready</span>
                    )}
                  </div>
                  {!assessmentForms.forms[formId]?.generatedQuestions && !topicQuestionsState.data && (
                    <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '6px', fontWeight: 500 }}>
                      You have entered a topic — please generate questions before saving.
                    </div>
                  )}
                </div>

                {/* Questions Preview */}
                {showTopicPreview && (assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data) && (
                  <div style={{
                    marginTop: '16px',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    padding: '16px',
                    background: '#f8fafc',
                    maxHeight: '500px',
                    overflowY: 'auto',
                  }}>
                    <h4 style={{ marginBottom: '12px', color: '#1e293b' }}>Generated Questions</h4>
                    {((assessmentForms.forms[formId]?.generatedQuestions || topicQuestionsState.data)?.assessment || []).map((section, sIdx) => (
                      <div key={sIdx} style={{
                        marginBottom: '16px',
                        padding: '12px',
                        background: '#fff',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                      }}>
                        <h5 style={{ color: '#3b82f6', marginBottom: '8px' }}>
                          {section.type}
                        </h5>
                        {(section.type === 'Paragraph Reading' || section.type === 'Audio Question') && (
                          <div>
                            <p style={{ fontSize: '13px', color: '#475569', marginBottom: '8px', whiteSpace: 'pre-wrap' }}>
                              {section.paragraph}
                            </p>
                            {section.questions?.map((q, qIdx) => (
                              <div key={qIdx} style={{ marginBottom: '8px', paddingLeft: '12px' }}>
                                <p style={{ fontSize: '13px', fontWeight: 500 }}>Q{qIdx + 1}: {q.question}</p>
                                <div style={{ paddingLeft: '12px' }}>
                                  {q.options?.map((opt, oIdx) => (
                                    <p key={oIdx} style={{
                                      fontSize: '12px',
                                      color: opt === q.answer ? '#16a34a' : '#64748b',
                                      fontWeight: opt === q.answer ? 600 : 400,
                                    }}>
                                      {String.fromCharCode(65 + oIdx)}. {opt} {opt === q.answer ? '✓' : ''}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {section.type === 'Video Response' && (
                          <div>
                            {section.questions?.map((q, qIdx) => (
                              <p key={qIdx} style={{ fontSize: '13px', color: '#475569' }}>
                                Scenario: {q.question}
                              </p>
                            ))}
                          </div>
                        )}
                        {section.type === 'Question Based Response' && (
                          <div>
                            <p style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>{section.question}</p>
                            {section.image_url ? (
                              <img
                                src={section.image_url}
                                alt="Question image"
                                style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '6px', objectFit: 'contain' }}
                                onError={(e) => { e.target.style.display = 'none'; }}
                              />
                            ) : section.image_object_key ? (
                              <p style={{ fontSize: '12px', color: '#94a3b8' }}>Image: {section.image_object_key}</p>
                            ) : null}
                          </div>
                        )}
                        {section.type === 'Email Writing' && (
                          <div>
                            <p style={{ fontSize: '13px', color: '#475569' }}>{section.question}</p>
                          </div>
                        )}
                        {section.type === 'Dictation' && (
                          <div>
                            {section.sentences?.map((s, i) => (
                              <p key={i} style={{ fontSize: '13px', color: '#475569' }}>{i + 1}. {s}</p>
                            ))}
                          </div>
                        )}
                        {section.type === 'Sentence Completion' && (
                          <div>
                            {section.questions?.map((q, qIdx) => (
                              <div key={qIdx} style={{ marginBottom: '8px', paddingLeft: '12px' }}>
                                <p style={{ fontSize: '13px', fontWeight: 500 }}>Q{qIdx + 1}: {q.sentence}</p>
                                <div style={{ paddingLeft: '12px' }}>
                                  {q.options?.map((opt, oIdx) => (
                                    <p key={oIdx} style={{
                                      fontSize: '12px',
                                      color: opt === q.answer ? '#16a34a' : '#64748b',
                                      fontWeight: opt === q.answer ? 600 : 400,
                                    }}>
                                      {String.fromCharCode(65 + oIdx)}. {opt} {opt === q.answer ? '✓' : ''}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {section.type === 'Sentence Build' && (
                          <div>
                            {section.questions?.map((q, qIdx) => (
                              <p key={qIdx} style={{ fontSize: '13px', color: '#475569' }}>
                                {qIdx + 1}. {q.sentence || q.paragraph}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        )
      case 'Custom_Assessment':
        // Combine available sections from backend with newly created sections
        const allSections = [
          ...availableCustomSections.map(section => ({
            section_id: section.section_id,
            section_name: section.name,
            totalQuestions: section.totalQuestions,
            questions: Array(section.totalQuestions).fill({}),
            isExisting: true
          })),
          ...customSections.map((section, idx) => ({
            section_id: section.section_id || `temp-${idx}`,
            section_name: section.section_name,
            totalQuestions: section.totalQuestions,
            excel: section.excel,
            questions: section.questions || [],
            isExisting: false
          }))
        ];

        return (
          <SectionContent>
            <SectionHeading>Custom Assessment Sections</SectionHeading>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 16,
              padding: '10px 14px',
              background: '#F5F8FF',
              borderRadius: 8,
              border: '1px solid #D6E4FF',
            }}>
              <FileExcelOutlined style={{ color: '#444CE7', fontSize: 16 }} />
              <span style={{ fontSize: 13, color: '#475467' }}>
                Need the bulk upload format?
              </span>
              <a
                href={CUSTOM_ASSESSMENT_TEMPLATE_URL}
                download="custom-assessment-bulk-upload-template.xlsx"
                style={{
                  color: '#444CE7',
                  fontWeight: 500,
                  fontSize: 13,
                  textDecoration: 'none',
                  marginLeft: 'auto',
                }}
              >
                Download Template
              </a>
            </div>

            {/* ✅ MOVE THIS OUTSIDE - Show "Add Section" button always, regardless of sections */}
            <div style={{
              marginBottom: 24,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <DatabaseOutlined style={{ fontSize: 16, color: '#1890ff' }} />
                <span style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#262626'
                }}>
                  Available Sections
                </span>
                {allSections.length > 0 && (
                  <span style={{
                    fontSize: 12,
                    color: '#8c8c8c',
                    marginLeft: 4
                  }}>
                    ({allSections.length})
                  </span>
                )}
              </div>

              {selectedSectionIds.length > 0 && (
                <span style={{
                  fontSize: 12,
                  color: '#1890ff',
                  fontWeight: 500
                }}>
                  {selectedSectionIds.length} selected
                </span>
              )}
            </div>

            {allSections.length > 0 ? (
              <>
                <div style={{
                  marginBottom: 16,
                  padding: 12,
                  background: '#f0f5ff',
                  border: '1px solid #d6e4ff',
                  borderRadius: 6,
                  fontSize: 13,
                  color: '#1890ff'
                }}>
                  <InfoCircleOutlined style={{ marginRight: 6 }} />
                  Click on sections to select/deselect them for your assessment
                </div>

                <Row gutter={[16, 16]}>
                  {allSections.map((section) => {
                    const isSelected = selectedSectionIds.includes(section.section_id);
                    return (
                      <Col xs={24} sm={12} md={8} lg={6} key={section.section_id}>
                        <Card
                          hoverable
                          onClick={() => handleSectionSelect(section.section_id, section)}
                          style={{
                            minHeight: 120,
                            borderRadius: 8,
                            border: isSelected ? '2px solid #1890ff' : '1px solid #d9d9d9',
                            background: isSelected ? '#f0f5ff' : '#fff',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            position: 'relative'
                          }}
                          bodyStyle={{ padding: 16 }}
                        >
                          {isSelected && (
                            <div style={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                              width: 24,
                              height: 24,
                              borderRadius: '50%',
                              background: '#1890ff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <CheckOutlined style={{ color: '#fff', fontSize: 14 }} />
                            </div>
                          )}

                          <div style={{ marginBottom: 8 }}>
                            <FileTextOutlined style={{ fontSize: 20, color: '#1890ff', marginRight: 8 }} />
                            <span style={{ fontWeight: 600, fontSize: 14 }}>
                              {section.section_name}
                            </span>
                          </div>

                          <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 12 }}>
                            {section.totalQuestions} question{section.totalQuestions !== 1 ? 's' : ''}
                          </div>

                          <Button
                            type="link"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={(e) => handleViewQuestions(e, section)}
                            style={{ padding: 0, height: 'auto' }}
                          >
                            View Questions
                          </Button>
                        </Card>
                      </Col>
                    );
                  })}

                  {/* Add Section Card */}
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <Card
                      hoverable
                      onClick={handleOpenAddSectionModal}
                      style={{
                        minHeight: 120,
                        borderRadius: 8,
                        border: '2px dashed #d9d9d9',
                        background: '#fafafa',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      bodyStyle={{
                        padding: 16,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <div style={{
                        textAlign: 'center',
                        color: '#8c8c8c',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 8
                      }}>
                        <PlusOutlined style={{ fontSize: 24 }} />
                        <div style={{ fontSize: 14, fontWeight: 500 }}>Add Section</div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              // ✅ NEW: Empty state with Add Section button
              <div style={{
                padding: 40,
                textAlign: 'center',
                background: '#fafafa',
                borderRadius: 8,
                border: '1px dashed #d9d9d9'
              }}>
                <FolderOpenOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
                <div style={{ fontSize: 16, fontWeight: 500, color: '#262626', marginBottom: 8 }}>
                  No Sections Created Yet
                </div>
                <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 24 }}>
                  Create your first section to start building your custom assessment
                </div>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleOpenAddSectionModal}
                  size="large"
                >
                  Create First Section
                </Button>
              </div>
            )}

            {/* Configuration section - only show when sections are selected */}
            {selectedSectionIds.length > 0 && (
              <div style={{ marginTop: 24 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  marginBottom: 16,
                  paddingBottom: 12,
                  borderBottom: '1px solid #e8e8e8'
                }}>
                  <SettingOutlined style={{ fontSize: 16, color: '#1890ff' }} />
                  <span style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#262626'
                  }}>
                    Configure Selected Sections
                  </span>
                </div>
                <CustomAssessmentSectionConfigTable
                  sections={allSections.filter(s => selectedSectionIds.includes(s.section_id))}
                  value={customSectionConfig}
                  validationErrors={validationErrors[formId]}
                  onChange={(newConfig) => {
                    setAssessmentForms(prev => ({
                      ...prev,
                      forms: {
                        ...prev.forms,
                        [formId]: {  // ← Change activeFormId to formId
                          ...prev.forms[formId],  // ← Change activeFormId to formId
                          customSectionConfig: newConfig
                        }
                      }
                    }));
                  }}
                />
              </div>
            )}

            {/* Modals */}
            {/* Modals */}
            {selectedSectionForView && (
              <CustomSectionQuestionsViewer
                visible={viewerVisible}
                onClose={handleCloseViewer}
                sectionId={selectedSectionForView.section_id}
                sectionName={selectedSectionForView.section_name}
                onQuestionsUpdated={(newTotal) => {
                  setAssessmentForms(prev => {
                    const currentForm = prev.forms[formId];
                    // Update available sections
                    const newAvailable = (currentForm.availableCustomSections || []).map(s =>
                      s.section_id === selectedSectionForView.section_id
                        ? { ...s, totalQuestions: newTotal }
                        : s
                    );
                    // Update custom sections (created in this session)
                    const newCustom = (currentForm.customSections || []).map(s =>
                      (s.section_id === selectedSectionForView.section_id || s.tempId === selectedSectionForView.section_id)
                        ? { ...s, totalQuestions: newTotal }
                        : s
                    );

                    return {
                      ...prev,
                      forms: {
                        ...prev.forms,
                        [formId]: {
                          ...currentForm,
                          availableCustomSections: newAvailable,
                          customSections: newCustom
                        }
                      }
                    };
                  });
                }}
              />
            )}

            <CustomAssessmentSectionCreator
              sections={customSections}
              onSectionAdd={handleSectionAdd}
              isModalVisible={isAddSectionModalOpen}
              onCloseModal={() => setIsAddSectionModalOpen(false)}
            />
          </SectionContent>
        );
      case 'Aptitude':
        return renderAptitudeTopics(formId)

      case 'Role_Based': {
        const form = assessmentForms.forms[formId];
        const regionOptions = [
          { value: 'India', label: 'India' },
          { value: 'USA', label: 'United States' },
          { value: 'Europe', label: 'Europe' },
          { value: 'Asia-Pacific', label: 'Asia-Pacific' },
          { value: 'Global', label: 'Global/International' },
          { value: 'Canada', label: 'Canada' },
          { value: 'Australia', label: 'Australia' },
          { value: 'Middle East', label: 'Middle East' },
          { value: 'Latin America', label: 'Latin America' },
        ];

        // ✅ USE STATE FROM COMPONENT LEVEL, NOT DECLARED HERE
        const currentShowCustomRoleInput = showCustomRoleInput[formId] || false;
        const currentCustomRoleName = customRoleName[formId] || '';
        const currentCustomSkillInput = customSkillInput[formId] || '';

        // Default skills for each job role
        const jobRoleSkills = {
          machine_learning: [
            'Python', 'TensorFlow', 'PyTorch', 'Scikit-learn', 'Deep Learning',
            'NLP', 'Computer Vision', 'Statistics'
          ],
          data_scientist: [
            'Python', 'R', 'SQL', 'Machine Learning', 'Data Visualization', 'Statistics'
          ],
          frontend_dev: [
            'HTML', 'CSS', 'JavaScript', 'React', 'Redux', 'TypeScript'
          ],
          backend_dev: [
            'Node.js', 'Express', 'MongoDB', 'SQL', 'API Design', 'Authentication'
          ],
          fullstack_dev: [
            'JavaScript', 'React', 'Node.js', 'Express', 'MongoDB', 'SQL'
          ],
          devops: [
            'Linux', 'AWS', 'Docker', 'Kubernetes', 'CI/CD', 'Terraform'
          ],
          nav_calculation_analyst: [
            'Fund Accounting', 'NAV Calculation', 'Reconciliation',
            'Corporate Actions', 'Bloomberg/Reuters', 'Excel (Advanced)',
            'SQL', 'SimCorp/Multifonds'
          ],
          equity_trade_settlement_associate: [
            'Trade Lifecycle', 'T+1/T+2 Settlement Rules', 'Clearing & Settlement (DTCC/Euroclear)',
            'Omgeo CTM', 'SWIFT Messaging (MT54x)', 'Excel (Advanced)',
            'SQL', 'Risk & Control', 'Regulatory Compliance (SEBI/FINRA/MiFID II)'
          ],
          compliance_officer: [
            'Regulatory Knowledge', 'AML/KYC Procedures', 'Risk Assessment',
            'Compliance Monitoring Tools (Actimize, NICE, SAS)', 'Excel',
            'SQL', 'Audit & Control', 'Investigative Analysis'
          ],
          aml_compliance_gfc: [
            'AML Investigation', 'Global Financial Crimes Compliance', 'Banking Secrecy Act (BSA)',
            'Suspicious Activity Reports (SAR)', 'Microsoft Excel', 'Data Analytics',
            'Analytical & Problem-Solving', 'Attention to Detail', 'Report Writing',
            'Risk Assessment', 'Financial Crimes Typologies'
          ]
        };

        const selectedJobRole = assessmentForms.forms[formId]?.selectedJobRole;
        const selectedSkills = assessmentForms.forms[formId]?.selectedSkills || [];
        const customSkills = assessmentForms.forms[formId]?.customSkills || [];
        const isCustomRole = assessmentForms.forms[formId]?.isCustomRole || false;

        const allSkills = isCustomRole
          ? [...customSkills]
          : [
            ...(jobRoleSkills[selectedJobRole] || []),
            ...customSkills
          ];

        const handleSkillToggle = (skill) => {
          setAssessmentForms(prev => {
            const prevSkills = prev.forms[formId]?.selectedSkills || [];
            const isSelected = prevSkills.includes(skill);
            return {
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  selectedSkills: isSelected
                    ? prevSkills.filter(s => s !== skill)
                    : [...prevSkills, skill]
                }
              }
            };
          });
        };

        const handleAddSkill = () => {
          if (currentCustomSkillInput && currentCustomSkillInput.trim()) {
            const trimmedSkill = currentCustomSkillInput.trim();

            if (allSkills.includes(trimmedSkill)) {
              message.warning('This skill already exists');
              return;
            }

            setAssessmentForms(prev => ({
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  customSkills: [
                    ...(prev.forms[formId]?.customSkills || []),
                    trimmedSkill
                  ],
                  selectedSkills: [
                    ...(prev.forms[formId]?.selectedSkills || []),
                    trimmedSkill
                  ]
                }
              }
            }));

            // ✅ UPDATE COMPONENT-LEVEL STATE
            setCustomSkillInput(prev => ({
              ...prev,
              [formId]: ''
            }));
            message.success('Skill added successfully');
          }
        };

        const handleCreateCustomRole = () => {
          if (currentCustomRoleName && currentCustomRoleName.trim()) {
            setAssessmentForms(prev => ({
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  selectedJobRole: currentCustomRoleName.trim(),
                  isCustomRole: true,
                  customSkills: [],
                  selectedSkills: []
                }
              }
            }));

            message.success('Custom role created! Now add skills for this role.');
            // ✅ UPDATE COMPONENT-LEVEL STATE
            setShowCustomRoleInput(prev => ({
              ...prev,
              [formId]: false
            }));
            setCustomRoleName(prev => ({
              ...prev,
              [formId]: ''
            }));
          } else {
            message.error('Please enter a role name');
          }
        };

        const handleCancelCustomRole = () => {
          // ✅ UPDATE COMPONENT-LEVEL STATE
          setShowCustomRoleInput(prev => ({
            ...prev,
            [formId]: false
          }));
          setCustomRoleName(prev => ({
            ...prev,
            [formId]: ''
          }));
        };

        const seniority = assessmentForms.forms[formId]?.seniority || '';
        const handleSeniorityChange = (value) => {
          setAssessmentForms(prev => ({
            ...prev,
            forms: {
              ...prev.forms,
              [formId]: {
                ...prev.forms[formId],
                seniority: value
              }
            }
          }));
        };

        return (
          <div style={{ marginTop: '24px' }}>
            <FormItem>
              <Label>Search Job Role *</Label>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', position: 'relative' }}>
                {!currentShowCustomRoleInput && !isCustomRole && (
                  <>
                    <Select
                      showSearch
                      placeholder="Search for a job role (e.g., Machine Learning Engineer)"
                      style={{ width: '100%', marginBottom: '16px' }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onChange={(value) => {
                        setAssessmentForms(prev => ({
                          ...prev,
                          forms: {
                            ...prev.forms,
                            [formId]: {
                              ...prev.forms[formId],
                              selectedJobRole: value,
                              isCustomRole: false,
                              selectedSkills: [],
                              customSkills: []
                            }
                          }
                        }));
                      }}
                      value={selectedJobRole}
                      disabled={currentShowCustomRoleInput}
                    >
                      <Option value="machine_learning">Machine Learning Engineer</Option>
                      <Option value="data_scientist">Data Scientist</Option>
                      <Option value="frontend_dev">Frontend Developer</Option>
                      <Option value="backend_dev">Backend Developer</Option>
                      <Option value="fullstack_dev">Full Stack Developer</Option>
                      <Option value="devops">DevOps Engineer</Option>
                      <Option value="nav_calculation_analyst">NAV Calculation Analyst</Option>
                      <Option value="equity_trade_settlement_associate">Equity Trade Settlement Associate</Option>
                      <Option value="compliance_officer">Compliance Officer</Option>
                      <Option value="aml_compliance_gfc">AML Compliance</Option>
                    </Select>

                    <Button
                      type="default"
                      onClick={() => setShowCustomRoleInput(prev => ({
                        ...prev,
                        [formId]: true
                      }))}
                      style={{
                        minWidth: '120px',
                        height: '32px',
                        borderRadius: '8px',
                        border: '1px solid #444CE7',
                        color: '#444CE7',
                        fontWeight: '600'
                      }}
                    >
                      + Add Role
                    </Button>
                  </>
                )}

                {currentShowCustomRoleInput && !isCustomRole && (
                  <div style={{ width: '100%', display: 'flex', gap: '12px', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                      <Input
                        placeholder="Enter custom role name (e.g., AI Research Scientist)"
                        value={currentCustomRoleName}
                        onChange={(e) => setCustomRoleName(prev => ({
                          ...prev,
                          [formId]: e.target.value
                        }))}
                        onPressEnter={handleCreateCustomRole}
                        style={{
                          flex: 1,
                          borderRadius: '8px',
                          border: '1px solid #D0D5DD'
                        }}
                        autoFocus
                      />
                      <Button
                        type="primary"
                        onClick={handleCreateCustomRole}
                        style={{
                          minWidth: '100px',
                          borderRadius: '8px',
                          backgroundColor: '#444CE7'
                        }}
                      >
                        Create Role
                      </Button>
                      <Button
                        onClick={handleCancelCustomRole}
                        style={{
                          minWidth: '80px',
                          borderRadius: '8px'
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      After creating the role, you can add specific skills for this position
                    </Text>
                  </div>
                )}

                {isCustomRole && selectedJobRole && (
                  <div style={{ width: '100%', display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{
                      flex: 1,
                      padding: '8px 16px',
                      backgroundColor: '#F3F4F6',
                      borderRadius: '8px',
                      border: '1px solid #D0D5DD',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <span style={{ fontWeight: '600', color: '#1F2937' }}>
                        {selectedJobRole}
                      </span>
                      <span style={{
                        fontSize: '12px',
                        color: '#6B7280',
                        backgroundColor: '#E0E7FF',
                        padding: '2px 8px',
                        borderRadius: '12px'
                      }}>
                        Custom Role
                      </span>
                    </div>
                    <Button
                      type="default"
                      onClick={() => {
                        setAssessmentForms(prev => ({
                          ...prev,
                          forms: {
                            ...prev.forms,
                            [formId]: {
                              ...prev.forms[formId],
                              selectedJobRole: null,
                              isCustomRole: false,
                              selectedSkills: [],
                              customSkills: []
                            }
                          }
                        }));
                      }}
                      style={{
                        minWidth: '100px',
                        borderRadius: '8px',
                        border: '1px solid #DC2626',
                        color: '#DC2626'
                      }}
                    >
                      Change Role
                    </Button>
                  </div>
                )}
              </div>
            </FormItem>

            <FormItem>
              <Label>Region/Geography *</Label>
              <Select
                placeholder="Select region"
                value={form?.region || 'India'}
                getPopupContainer={(trigger) => trigger.parentNode}
                style={{
                  width: '340px',
                  ...(validationErrors[formId]?.region ? errorStyle : {})
                }}
                onChange={value =>
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        region: value,
                      },
                    },
                  }))
                }
              >
                {regionOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem style={{ marginTop: '24px' }}>
              <Label>
                Industry/Domain&nbsp;
                <span style={{ color: '#64748b', fontWeight: 400, fontSize: 13 }}>
                  (Default: Universal)
                </span>
              </Label>
              <StyledSearchInput
                placeholder="Enter industry/domain"
                value={form.industry_domain || ''}
                onChange={e =>
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        industry_domain: e.target.value,
                      },
                    },
                  }))
                }
                style={validationErrors[formId]?.industry_domain ? errorStyle : {}}
              />
              {validationErrors[formId]?.industry_domain && (
                <ValidationErrorText>
                  {validationErrors[formId]?.industry_domain}
                </ValidationErrorText>
              )}
            </FormItem>
            {selectedJobRole && (
              <FormItem style={{ marginTop: '16px' }}>
                <Label>Key Focus Areas *</Label>

                {isCustomRole && (
                  <div style={{
                    marginBottom: '16px',
                    padding: '12px',
                    backgroundColor: '#F9FAFB',
                    borderRadius: '8px',
                    border: '1px solid #E5E7EB'
                  }}>
                    <div style={{ display: 'flex', gap: '12px', marginBottom: '8px' }}>
                      <Input
                        placeholder="Enter skill name (e.g., Python, Leadership, AWS)"
                        value={currentCustomSkillInput}
                        onChange={(e) => setCustomSkillInput(prev => ({
                          ...prev,
                          [formId]: e.target.value
                        }))}
                        onPressEnter={handleAddSkill}
                        style={{
                          flex: 1,
                          borderRadius: '8px'
                        }}
                      />
                      <Button
                        type="primary"
                        onClick={handleAddSkill}
                        disabled={!currentCustomSkillInput.trim()}
                        style={{
                          minWidth: '100px',
                          borderRadius: '8px',
                          backgroundColor: '#444CE7'
                        }}
                      >
                        Add Skill
                      </Button>
                    </div>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      Add all the skills required for this role. You need to select at least one skill.
                    </Text>
                  </div>
                )}

                <div style={{
                  padding: '16px',
                  background: '#F8FAFC',
                  borderRadius: '8px',
                  border: '1px solid #E2E8F0',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px',
                  minHeight: '80px'
                }}>
                  {allSkills.length === 0 && isCustomRole ? (
                    <div style={{
                      width: '100%',
                      textAlign: 'center',
                      padding: '20px',
                      color: '#6B7280'
                    }}>
                      No skills added yet. Use the input above to add skills for this role.
                    </div>
                  ) : (
                    allSkills.map(skill => {
                      const isSelected = selectedSkills.includes(skill);
                      const isCustomSkill = customSkills.includes(skill);

                      return (
                        <div
                          key={skill}
                          style={{
                            padding: '6px 12px',
                            background: isSelected ? '#C7D2FE' : '#EEF2FF',
                            borderRadius: '16px',
                            fontSize: '14px',
                            color: isSelected ? '#1E40AF' : '#444CE7',
                            border: isSelected ? '2px solid #6366F1' : '1px solid #E0E7FF',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            position: 'relative'
                          }}
                          onClick={() => handleSkillToggle(skill)}
                        >
                          <span style={{
                            fontWeight: 'bold',
                            color: isSelected ? '#1E40AF' : '#6366F1',
                            fontSize: '16px'
                          }}>
                            +
                          </span>
                          <span>{skill}</span>
                          {isSelected && (
                            <span style={{ marginLeft: 4, color: '#1E40AF', fontWeight: 'bold' }}>✔</span>
                          )}
                          {isCustomSkill && (
                            <span style={{
                              fontSize: '10px',
                              color: '#6B7280',
                              backgroundColor: '#F3F4F6',
                              padding: '1px 4px',
                              borderRadius: '6px',
                              marginLeft: '4px'
                            }}>
                              Custom
                            </span>
                          )}
                        </div>
                      );
                    })
                  )}

                  {!isCustomRole && (
                    <div style={{ marginTop: '8px', width: '100%' }}>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Input
                          placeholder="Add custom skill for this role"
                          value={currentCustomSkillInput}
                          onChange={(e) => setCustomSkillInput(prev => ({
                            ...prev,
                            [formId]: e.target.value
                          }))}
                          onPressEnter={handleAddSkill}
                          style={{
                            maxWidth: '300px',
                            borderRadius: '8px',
                            height: '32px'
                          }}
                        />
                        <Button
                          type="dashed"
                          onClick={handleAddSkill}
                          disabled={!currentCustomSkillInput.trim()}
                          style={{
                            borderRadius: '16px',
                            padding: '6px 12px',
                            fontSize: '14px',
                            color: '#444CE7',
                            border: '1px dashed #6366F1',
                            background: '#fff',
                            height: '32px'
                          }}
                        >
                          + Add Custom Skill
                        </Button>
                      </div>
                    </div>
                  )}
                </div>

                {selectedSkills.length === 0 && (
                  <Text type="danger" style={{ fontSize: '12px', marginTop: '8px', display: 'block' }}>
                    Please select at least one skill
                  </Text>
                )}
              </FormItem>
            )}

            {selectedJobRole && (
              <FormItem style={{ marginTop: '24px' }}>
                <Label>Seniority *</Label>
                <Radio.Group
                  value={seniority}
                  onChange={e => handleSeniorityChange(e.target.value)}
                  style={{ display: 'flex', gap: '24px' }}
                >
                  <Radio value="fresher">Fresher</Radio>
                  <Radio value="intermediate">Intermediate</Radio>
                  <Radio value="senior">Senior</Radio>
                </Radio.Group>
              </FormItem>
            )}

            <FormItem style={{ marginTop: '24px' }}>
              <Label>Job Description (optional)</Label>
              <div style={{
                border: '1px solid #E2E8F0',
                borderRadius: '8px',
                padding: '4px'
              }}>
                <textarea
                  placeholder="Paste the job description here..."
                  style={{
                    width: '100%',
                    minHeight: '200px',
                    padding: '12px',
                    border: 'none',
                    borderRadius: '8px',
                    resize: 'vertical',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    fontFamily: 'inherit'
                  }}
                  value={
                    // Default to "noce" if empty and assessmentType is Custom_Assessment
                    assessmentForms.forms[formId]?.assessmentType === 'Custom_Assessment'
                      ? (assessmentForms.forms[formId]?.jobDescription ?? 'none')
                      : (assessmentForms.forms[formId]?.jobDescription || '')
                  }
                  onChange={(e) => {
                    setAssessmentForms(prev => ({
                      ...prev,
                      forms: {
                        ...prev.forms,
                        [formId]: {
                          ...prev.forms[formId],
                          jobDescription: e.target.value
                        }
                      }
                    }));
                  }}
                />
              </div>
            </FormItem>


            <FormItem style={{ marginTop: '24px' }}>
              <Label>Duration (minutes)</Label>
              <input
                type="number"
                min={15}
                max={60}
                step={5}
                value={assessmentForms.forms[formId]?.durationMinutes ?? 30}
                onChange={(e) => {
                  const val = Math.max(15, Math.min(60, parseInt(e.target.value) || 15));
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [formId]: {
                        ...prev.forms[formId],
                        durationMinutes: val
                      }
                    }
                  }));
                }}
                style={{ width: '160px', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
              />
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>Between 15 and 60 minutes</div>
            </FormItem>

            <FormItem style={{ marginTop: '24px' }}>
              <Label>Question Configuration</Label>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '12px',
                padding: '16px',
                border: '1px solid #E2E8F0',
                borderRadius: '8px',
                background: '#f8fafc'
              }}>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>MCQ Questions</div>
                  <input
                    type="number"
                    min={0}
                    max={20}
                    value={assessmentForms.forms[formId]?.questionConfig?.mcqCount ?? 10}
                    onChange={(e) => {
                      const val = Math.max(0, Math.min(20, parseInt(e.target.value) || 0));
                      setAssessmentForms(prev => ({
                        ...prev,
                        forms: {
                          ...prev.forms,
                          [formId]: {
                            ...prev.forms[formId],
                            questionConfig: {
                              ...(prev.forms[formId]?.questionConfig || {}),
                              mcqCount: val
                            }
                          }
                        }
                      }));
                    }}
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>Subjective Questions</div>
                  <input
                    type="number"
                    min={0}
                    max={10}
                    value={assessmentForms.forms[formId]?.questionConfig?.subjectiveCount ?? 2}
                    onChange={(e) => {
                      const val = Math.max(0, Math.min(10, parseInt(e.target.value) || 0));
                      setAssessmentForms(prev => ({
                        ...prev,
                        forms: {
                          ...prev.forms,
                          [formId]: {
                            ...prev.forms[formId],
                            questionConfig: {
                              ...(prev.forms[formId]?.questionConfig || {}),
                              subjectiveCount: val
                            }
                          }
                        }
                      }));
                    }}
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>Video Questions</div>
                  <input
                    type="number"
                    min={0}
                    max={3}
                    value={assessmentForms.forms[formId]?.questionConfig?.videoCount ?? 1}
                    onChange={(e) => {
                      const val = Math.max(0, Math.min(3, parseInt(e.target.value) || 0));
                      setAssessmentForms(prev => ({
                        ...prev,
                        forms: {
                          ...prev.forms,
                          [formId]: {
                            ...prev.forms[formId],
                            questionConfig: {
                              ...(prev.forms[formId]?.questionConfig || {}),
                              videoCount: val
                            }
                          }
                        }
                      }));
                    }}
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
                  />
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>Coding Questions</div>
                  <input
                    type="number"
                    min={0}
                    max={5}
                    value={assessmentForms.forms[formId]?.questionConfig?.codingCount ?? 0}
                    onChange={(e) => {
                      const val = Math.max(0, Math.min(5, parseInt(e.target.value) || 0));
                      setAssessmentForms(prev => ({
                        ...prev,
                        forms: {
                          ...prev.forms,
                          [formId]: {
                            ...prev.forms[formId],
                            questionConfig: {
                              ...(prev.forms[formId]?.questionConfig || {}),
                              codingCount: val
                            }
                          }
                        }
                      }));
                    }}
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
                  />
                </div>
              </div>
            </FormItem>

            {!uploadedStudents.some(s => s.formId === formId) && (
              <FormItem style={{ marginTop: '16px' }}>
                <span style={{ fontSize: 12, color: '#637487' }}>
                  Upload students to enable saving
                </span>
              </FormItem>
            )}
          </div>
        );
      }

      case 'AI_Interview': {
        return (
          <CreateAIInterview
            formId={formId}
            assessmentForms={assessmentForms}
            setAssessmentForms={setAssessmentForms}
          />
        );
      }

      case 'Cognitive':
      case 'Tech_MCQ':
      case 'Tech_Coding':
        return (
          <AssessmentLinkSection>
            <Label>Assessment Link</Label>
            <AssessmentLinkInput
              placeholder="Enter Assessment Link"
              value={assessmentForms.forms[formId]?.assessmentLink || ''}
              className={
                validationErrors[formId]?.assessmentLink ? 'error' : ''
              }
              onChange={e => {
                if (validationErrors[formId]?.assessmentLink) {
                  setValidationErrors(prev => ({
                    ...prev,
                    [formId]: {
                      ...prev[formId],
                      assessmentLink: false,
                    },
                  }))
                }

                setAssessmentForms(prev => ({
                  ...prev,
                  forms: {
                    ...prev.forms,
                    [formId]: {
                      ...prev.forms[formId],
                      assessmentLink: e.target.value,
                    },
                  },
                }))
              }}
            />
          </AssessmentLinkSection>
        )

      default:
        return null
    }
  }

  const renderNegativeMarkingOption = formId => {
    // Only show for corporate and aptitude assessments
    const currentForm = assessmentForms.forms[formId]
    if (!currentForm) return null;

    // ❌ REMOVE THIS - it's causing infinite re-renders
    // if (entityType !== 'corporate' && currentForm?.assessmentType !== 'Aptitude') {
    //   setAssessmentForms(prev => ({
    //     ...prev,
    //     forms: {
    //       ...prev.forms,
    //       [formId]: {
    //         ...prev.forms[formId],
    //         allowNegativeMarking: true,
    //       },
    //     },
    //   }))
    // }

    const shouldShowNegativeMarking =
      (entityType === 'corporate' || entityType === 'college' || entityType === 'institute') && currentForm?.assessmentType === 'Aptitude'

    if (!shouldShowNegativeMarking) {
      return null
    }

    // Ensure we have a proper boolean value, defaulting to false for corporate
    const currentValue = currentForm?.allowNegativeMarking
    const radioValue = currentValue === true ? 'true' : 'false'

    return (
      <div style={{ marginTop: '16px', marginBottom: '16px' }}>
        <Label>Negative Marking System</Label>
        <br />
        <StreamRadioGroup
          error={validationErrors[formId]?.allowNegativeMarking}
          value={radioValue} // Use the converted string value
          onChange={e => {
            const value = e.target.value === 'true'
            setAssessmentForms(prev => ({
              ...prev,
              forms: {
                ...prev.forms,
                [formId]: {
                  ...prev.forms[formId],
                  allowNegativeMarking: value,
                },
              },
            }))
            if (validationErrors[formId]?.allowNegativeMarking) {
              setValidationErrors(prev => ({
                ...prev,
                [formId]: {
                  ...prev[formId],
                  allowNegativeMarking: false,
                },
              }))
            }
          }}
        >
          <Radio value="true">Yes</Radio>
          <Radio value="false">No</Radio>
        </StreamRadioGroup>
      </div>
    )
  }
  const addNewAssessment = () => {
    const newId = uuidv4()
    setAssessments(prev => [
      ...prev,
      { id: newId, assessment: null, isSaved: false },
    ])

    setAssessmentOrder(prev => [...prev, newId])

    setUploadedStudents(prev =>
      prev.filter(student => student.formId !== newId)
    )

    setUploadSummaries(prev => prev.filter(summary => summary.formId !== newId))

    setAssessmentForms(prev => ({
      ...prev,
      activeFormId: newId,
      forms: {
        ...prev.forms,
        [newId]: {
          ...defaultFormState,
          id: newId,
          allowNegativeMarking: false, // Default to No
        },
      },
    }))
  }
  useEffect(() => {
    const initialId = assessments[0]?.id
    if (initialId && !assessmentOrder.includes(initialId)) {
      setAssessmentOrder([initialId])
    }
  }, [])
  const formatDate = (date) => {
    if (!date) return null;

    // If it's already a moment object
    if (moment.isMoment(date)) {
      return date.format('YYYY-MM-DD');
    }

    // If it's a string or Date object
    return moment(date).format('YYYY-MM-DD');
  };
  const formatAssessmentData = (formsState) => {
    console.log('formatAssessmentData called', formsState);

    if (!formsState?.forms) return [];

    return Object.values(formsState.forms)
      .filter(form => form.isSaved)
      .map(form => {
        const isInstituteFlow = entityType === 'college' || entityType === 'institute';

        // Define isSchedulable based on assessment type
        const isSchedulable = ['Communication', 'Aptitude'].includes(form.assessmentType);

        const formatTime = time =>
          time && typeof time.format === 'function'
            ? time.format('HH:mm')
            : time;

        const processedBulkUploadData = (form.bulkUploadData || []).map(student => ({
          ...student,
          primary_email: student.email || student.primaryEmail,
          email: student.email || student.primaryEmail,
        }));

        const assessmentConfig = {
          id: form.id,
          assessmentType: form.assessmentType,
          name: form.name,
          instructions: form.instructions || '',
          allowProctoring: form.allowProctoring,
          allowVerification: form.allowVerification,
          bulkUploadData: processedBulkUploadData,
          entityId: selectedEntityID,
          entityType: entityType,
          email: '',
        };

        // ✅ COMMUNICATION ASSESSMENT - Unified (includes former Hinglish)
        if (form.assessmentType === 'Communication' || form.assessmentType === 'Hinglish') {
          assessmentConfig.assessmentType = 'Communication'; // Always send as Communication
          assessmentConfig.cefrLevel = form.cefrLevel;
          assessmentConfig.accent = form.accent || 'en-IN';
          assessmentConfig.enabledSections = expandSectionsForBackend(form.enabledSections);
          // Institute-side Communication must always be English; only corporate may pick a regional language.
          assessmentConfig.responseLanguage = entityType === 'corporate'
            ? (form.responseLanguage || 'English')
            : 'English';
          const topics = (form.selectedDomains || []).join(', ') || form.selectedDomain || '';
          assessmentConfig.assessmentDomain = topics || '';

          // If topic provided, attach generated questions (pre-generated from UI or will be generated on backend)
          if (topics.trim()) {
            const questions = form.generatedQuestions || topicQuestionsState?.data || null;
            if (questions) {
              assessmentConfig.generatedQuestions = questions;
            }
            // If no questions pre-generated, backend will generate on-the-fly
          }
          console.log('Communication assessment - domain:', assessmentConfig.assessmentDomain, 'lang:', assessmentConfig.responseLanguage);
        }
        // ✅ ROLE-BASED ASSESSMENT - COMPLETE IMPLEMENTATION
        else if (form.assessmentType === 'Role_Based') {
          // CRITICAL: Ensure all role-based fields are captured
          assessmentConfig.roleName = form.roleName || form.selectedJobRole || '';
          assessmentConfig.skills = form.selectedSkills || form.skills || [];

          // Map seniority correctly
          if (form.seniority === 'entry') {
            assessmentConfig.seniority = 'fresher';
          } else if (form.seniority === 'mid') {
            assessmentConfig.seniority = 'intermediate';
          } else if (form.seniority === 'senior') {
            assessmentConfig.seniority = 'senior';
          } else {
            assessmentConfig.seniority = form.seniority || 'fresher';
          }

          assessmentConfig.jobDescription = form.jobDescription || '';
          assessmentConfig.industry_domain = form.industry_domain || '';
          assessmentConfig.region = form.region || 'India';

          // Preserve generated questions
          if (form.generatedQuestions) {
            assessmentConfig.generatedQuestions = form.generatedQuestions;
          } else if (roleBasedQuestionsState?.data?.questions) {
            assessmentConfig.generatedQuestions = roleBasedQuestionsState.data.questions;
          }

          console.log('Role-Based assessment config:', {
            roleName: assessmentConfig.roleName,
            skills: assessmentConfig.skills,
            seniority: assessmentConfig.seniority,
            jobDescription: assessmentConfig.jobDescription,
            industry_domain: assessmentConfig.industry_domain,
            hasQuestions: !!assessmentConfig.generatedQuestions
          });
        }
        // ✅ BEHAVIOR ASSESSMENT
        else if (form.assessmentType === 'Behavior') {
          const streamsArr = Array.isArray(form.selectedStreams)
            ? form.selectedStreams
            : form.selectedStreams
              ? [form.selectedStreams]
              : [];
          assessmentConfig.selectedStreams = streamsArr;
          const stream = String(streamsArr[0] || '').toLowerCase();
          if (stream === 'engineering' || stream === 'science') {
            assessmentConfig.assessmentDomain = 'Engineering';
          } else if (stream === 'management' || stream === 'commerce') {
            assessmentConfig.assessmentDomain = 'Management';
          }
        }
        // In formatAssessmentData, around line 4540-4544, add:
        else if (form.assessmentType === 'Custom_Assessment') {
          // ✅ Pass BOTH newly created sections AND available sections
          assessmentConfig.customSections = form.customSections || [];
          assessmentConfig.customSectionConfig = form.customSectionConfig || {};
          assessmentConfig.availableCustomSections = form.availableCustomSections || []; // ✅ ADD THIS
          assessmentConfig.selectedSectionIds = form.selectedSectionIds || []; // ✅ ADD THIS TOO

        }
        // ✅ AI INTERVIEW ASSESSMENT (two-rubric model)
        else if (form.assessmentType === 'AI_Interview') {
          const ai = form.aiInterview || {}
          const f = ai.form || {}
          assessmentConfig.interviewConfig = {
            jobRole: f.jobRole || '',
            seniority: f.seniority || 'Mid',
            industryDomain: f.industryDomain || null,
            region: f.region || 'India',
            jobDescription: f.jobDescription || null,
            interviewDuration: Number(f.interviewDuration) || 1500,
            maxQuestions: Math.min(15, Math.max(8, Math.round(Number(f.maxQuestions) || 8))),
            resumePolicy: f.resumePolicy || 'optional',
            conversationRubric: ai.conversationRubric || [],
            evaluationParameters: ai.parameters || [],
            scoringGuidance: f.scoringGuidance || null,
            questionGuidance: f.questionGuidance || null,
            voiceId: f.voiceId || null,
            // Priority/sample questions UI was removed from the create form, so
            // this is always []. Kept on the payload for backend compatibility
            // (student-node still accepts a verbatim-first questions array).
            sampleQuestions: (f.sampleQuestions || '')
              .split('\n')
              .map((s) => s.trim())
              .filter(Boolean),
            stageConfig: {
              language: f.language || 'English',
              responderLanguage: f.responderLanguage || 'English',
              probingStyle: f.probingStyle || 'neutral',
              difficultyCurve: f.difficultyCurve || 'flat',
              // admin-node delivers an on-call interview by phone: a call slot
              // per candidate inside the window, and no emailed link
              deliveryMode: f.deliveryMode === 'call' ? 'call' : 'web',
            },
          };
        }
        // ✅ LINK-BASED ASSESSMENTS
        else if (['Cognitive', 'Tech_MCQ', 'Tech_Coding'].includes(form.assessmentType)) {
          assessmentConfig.assessmentLink = form.assessmentLink || null;
        } else if (form.assessmentType === 'Aptitude') {
          const getDifficultySettings = (duration, difficultyLevel) => {
            if (
              questionConfigurations[duration] &&
              questionConfigurations[duration][difficultyLevel]
            ) {
              const config = questionConfigurations[duration][difficultyLevel];
              return {
                total: config.total,
                easy: config.easy,
                medium: config.medium,
                hard: config.hard,
              };
            }
            return { total: 30, easy: 15, medium: 10, hard: 5 };
          };

          const getCategoryDistribution = totalQuestions => {
            const quantitative = Math.round(totalQuestions * 0.4);
            const logical = Math.round(totalQuestions * 0.35);
            const critical = totalQuestions - quantitative - logical;

            return {
              quantitative,
              logical_reasoning: logical,
              critical_reasoning: critical,
            };
          };

          let finalAptitudeType = form.aptitudeType || [];
          let finalAptitudeSubtopics = form.aptitudeSubtopics || [];
          let finalDuration = form.duration || (isInstituteFlow ? 30 : 60);
          let finalDifficultyLevel = form.difficultyLevel || 'medium';

          if (isInstituteFlow) {
            if (!finalAptitudeType.length) {
              finalAptitudeType = [
                'quantitative',
                'logical_reasoning',
                'critical_reasoning',
              ];
            }
            if (!finalAptitudeSubtopics.length) {
              const questionConfig =
                questionConfigurations[30]?.[finalDifficultyLevel];
              const totalQuestions = questionConfig?.total || 25;
              finalAptitudeSubtopics = getAllSubtopics();
            }
            finalDuration = 30;

            const topicDistribution = getTopicDistribution(
              finalDuration,
              finalDifficultyLevel
            );
            assessmentConfig.topicDistribution = topicDistribution;
          }

          const difficultySettings = getDifficultySettings(
            finalDuration,
            finalDifficultyLevel
          );
          const categoryDistribution = getCategoryDistribution(
            difficultySettings.total
          );

          assessmentConfig.aptitudeType = finalAptitudeType;
          assessmentConfig.aptitudeSubtopics = finalAptitudeSubtopics;
          assessmentConfig.duration = finalDuration;
          assessmentConfig.difficultyLevel = finalDifficultyLevel;
          assessmentConfig.allowNegativeMarking = form.allowNegativeMarking || false;
          assessmentConfig.difficultySettings = difficultySettings;
          assessmentConfig.categoryDistribution = categoryDistribution;

          if (isInstituteFlow) {
            assessmentConfig.subtopicWeights =
              Object.keys(formattedAptitudeTopics).length > 0
                ? formattedAptitudeTopics
                : null;
          }
        }

        // ✅ FIXED: Handle scheduled vs one-time distribution
        if (isSchedulable && form.distributionType === 'scheduled') {
          // Handle different frequency types
          let frequencyValue;

          if (form.frequencyType === 'CUSTOM') {
            // ✅ FIX: For custom dates, format and filter properly
            const today = moment().format('YYYY-MM-DD');
            const filteredDates = Array.isArray(form.frequencyValue)
              ? form.frequencyValue
                .map(date => moment(date).format('YYYY-MM-DD')) // Convert to string format
                .filter(dateStr => dateStr !== today) // Filter out today
              : [];

            // ✅ FIX: Send as array directly (not wrapped in object)
            frequencyValue = filteredDates;

            console.log('Custom frequency - formatted dates:', {
              originalDates: form.frequencyValue,
              todayDate: today,
              filteredDates: filteredDates,
              finalFrequencyValue: frequencyValue,
            });
          } else {
            // ✅ FIX: For other frequency types, store the raw value directly
            frequencyValue = form.frequencyValue;

            console.log('Non-custom frequency value:', {
              frequencyType: form.frequencyType,
              originalValue: form.frequencyValue,
              processedValue: frequencyValue,
            });
          }

          // ✅ FIX: Ensure start date is never today for scheduled assessments
          let scheduleStartDate = formatDate(form.startDate);
          const today = moment().format('YYYY-MM-DD');
          const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD');

          // If start date is today or earlier, move it to tomorrow
          if (!scheduleStartDate || moment(scheduleStartDate).isSameOrBefore(moment(), 'day')) {
            scheduleStartDate = tomorrow;
            console.log('Adjusted start date to tomorrow for scheduled assessment:', scheduleStartDate);
          }

          console.log('Formatting scheduled assessment:', {
            formId: form.id,
            frequencyType: form.frequencyType,
            originalFrequencyValue: form.frequencyValue,
            processedFrequencyValue: frequencyValue,
            originalStartDate: formatDate(form.startDate),
            adjustedStartDate: scheduleStartDate,
          });

          return {
            ...assessmentConfig,
            distributionType: 'scheduled',
            scheduleStartDate: scheduleStartDate,
            scheduleEndDate: formatDate(form.endDate),
            frequencyType: form.frequencyType,
            frequencyValue: frequencyValue, // ✅ This will be an array of date strings for CUSTOM, or primitive value for others
            assessmentValidityDays: form.assessmentValidityDays,
          };
        } else {
          // One-time assessment
          return {
            ...assessmentConfig,
            distributionType: 'one-time',
            startDate: formatDate(form.startDate),
            endDate: formatDate(form.endDate),
            startTime: formatTime(form.startTime),
            endTime: formatTime(form.endTime),
          };
        }
      });
  };



  const getTopicDistribution = (duration, difficultyLevel) => {
    const totalQuestions =
      questionConfigurations[duration]?.[difficultyLevel]?.total || 30

    // Default category distribution percentages
    const defaultDistribution = {
      quantitative: 0.4,
      logical_reasoning: 0.35,
      critical_reasoning: 0.25,
    }

    // Step 1: Determine which categories are actually selected by the user
    const selectedAptitudeTypes =
      assessmentForms.forms[assessmentForms.activeFormId]?.aptitudeType || []
    const availableCategories = {}

    Object.keys(defaultDistribution).forEach(category => {
      // Category is available if it's in the selected types AND has topics
      const isSelected =
        selectedAptitudeTypes.includes(category) &&
        formattedAptitudeTopics &&
        formattedAptitudeTopics[category]?.length > 0

      availableCategories[category] = isSelected
    })

    // Step 2: Calculate total percentage from available categories
    let totalAvailablePercentage = 0
    Object.keys(defaultDistribution).forEach(category => {
      if (availableCategories[category]) {
        totalAvailablePercentage += defaultDistribution[category]
      }
    })

    // Step 3: Redistribute percentages proportionally
    const adjustedDistribution = {}
    Object.keys(defaultDistribution).forEach(category => {
      if (availableCategories[category]) {
        // Scale up each category's percentage proportionally
        adjustedDistribution[category] =
          defaultDistribution[category] / totalAvailablePercentage
      } else {
        adjustedDistribution[category] = 0
      }
    })

    // Step 4: Calculate questions per category with adjusted distribution
    const questionsPerCategory = {}
    Object.keys(adjustedDistribution).forEach(category => {
      if (adjustedDistribution[category] > 0) {
        questionsPerCategory[category] = Math.round(
          totalQuestions * adjustedDistribution[category]
        )
      } else {
        questionsPerCategory[category] = 0
      }
    })

    // Adjust if total doesn't match (due to rounding)
    const calculatedTotal = Object.values(questionsPerCategory).reduce(
      (sum, count) => sum + count,
      0
    )
    if (calculatedTotal !== totalQuestions) {
      const diff = totalQuestions - calculatedTotal
      const categories = Object.keys(questionsPerCategory).filter(
        c => questionsPerCategory[c] > 0
      )
      if (categories.length > 0) {
        const maxCategory = categories.reduce((a, b) =>
          questionsPerCategory[a] > questionsPerCategory[b] ? a : b
        )
        questionsPerCategory[maxCategory] += diff
      }
    }

    // Process each category to get detailed distribution
    const distribution = {}

    Object.keys(questionsPerCategory).forEach(category => {
      if (
        questionsPerCategory[category] <= 0 ||
        !formattedAptitudeTopics ||
        !formattedAptitudeTopics[category]
      ) {
        distribution[category] = []
        return
      }

      // Rest of the distribution logic remains the same...
      const categoryTopics = [...formattedAptitudeTopics[category]]
      const neededQuestions = questionsPerCategory[category]

      // Sort topics by weight descending
      categoryTopics.sort((a, b) => b.weight - a.weight)

      // Calculate total weight points for the category
      const totalWeightPoints = categoryTopics.reduce(
        (sum, topic) => sum + topic.weight,
        0
      )
      const questionsPerWeightPoint = neededQuestions / totalWeightPoints

      // Calculate question allocation per topic
      const topicAllocations = categoryTopics.map(topic => {
        const idealQuestions = topic.weight * questionsPerWeightPoint
        return {
          name: topic.name,
          weight: topic.weight,
          questions: Math.floor(idealQuestions),
          remainder: idealQuestions - Math.floor(idealQuestions),
        }
      })

      // Distribute remaining questions
      const allocatedQuestions = topicAllocations.reduce(
        (sum, t) => sum + t.questions,
        0
      )
      const remainingQuestions = neededQuestions - allocatedQuestions

      if (remainingQuestions > 0) {
        topicAllocations.sort((a, b) => b.remainder - a.remainder)
        for (let i = 0; i < remainingQuestions; i++) {
          if (i < topicAllocations.length) {
            topicAllocations[i].questions += 1
          }
        }
      }

      // Only include topics with questions > 0
      distribution[category] = topicAllocations
        .filter(topic => topic.questions > 0)
        .map(topic => ({
          name: topic.name,
          weight: topic.weight,
          questions: topic.questions,
        }))
    })

    return distribution
  }
  const handleSave = formId => {
    console.debug('handleSave called for formId:', formId)
    try {
      const currentForm = assessmentForms.forms[formId]
      if (!currentForm) {
        console.debug('handleSave: currentForm not found for formId:', formId)
        return
      }

      // Validate scheduled assessment dates
      if (currentForm.distributionType === 'scheduled') {
        const allDates = generateScheduleDates(
          currentForm.startDate || currentForm.scheduleStartDate,
          currentForm.endDate || currentForm.scheduleEndDate,
          currentForm.frequencyType,
          currentForm.frequencyValue
        );
        if (allDates.length === 0) {
          message.warning('No valid dates found for the given schedule start and end dates.');
          return;
        }
      }

      const isInstituteFlow =
        entityType === 'college' || entityType === 'institute'

      // Institute aptitude: fill in only what the admin did NOT choose. The
      // topic picker is authoritative — overwriting its selection with every
      // topic (the pre-2026-08 behaviour) is what made the institute flow
      // "auto-configured". Untouched forms still default to every section and
      // every topic, so an admin who never opens the picker gets the same
      // paper as before.
      let formToValidate = currentForm
      if (currentForm.assessmentType === 'Aptitude' && isInstituteFlow) {
        const allAptitudeTypes = [
          'quantitative',
          'logical_reasoning',
          'critical_reasoning',
        ]

        const chosenTypes = currentForm.aptitudeType?.length
          ? currentForm.aptitudeType
          : allAptitudeTypes
        const chosenSubtopics = currentForm.aptitudeSubtopics?.length
          ? currentForm.aptitudeSubtopics
          : getAllSubtopics()

        console.debug('Institute aptitude selection at save:', {
          difficultyLevel: currentForm.difficultyLevel,
          sections: chosenTypes.length,
          selectedSubtopics: chosenSubtopics.length,
          usedPickerSelection: Boolean(currentForm.aptitudeSubtopics?.length),
        })

        formToValidate = {
          ...currentForm,
          aptitudeType: chosenTypes,
          aptitudeSubtopics: chosenSubtopics,
          duration: 30,
          difficultyLevel: currentForm.difficultyLevel,
        }
        console.log('Saving form:', formId, 'frequencyType:', formToValidate.frequencyType, 'frequencyValue:', formToValidate.frequencyValue);
        setAssessmentForms(prev => ({
          ...prev,
          forms: {
            ...prev.forms,
            [formId]: formToValidate,
          },
        }))
      }

      // --- Always default region and industry_domain here ---
      formToValidate = {
        ...formToValidate,
        region: !formToValidate.region || !formToValidate.region.trim() ? 'India' : formToValidate.region,
        industry_domain: !formToValidate.industry_domain || !formToValidate.industry_domain.trim() ? 'Universal' : formToValidate.industry_domain,
      }
      // ------------------------------------------------------

      console.debug('Form before validation:', {
        id: formToValidate.id,
        assessmentType: formToValidate.assessmentType,
        aptitudeType: formToValidate.aptitudeType,
        aptitudeSubtopics: formToValidate.aptitudeSubtopics?.length,
        duration: formToValidate.duration,
        difficultyLevel: formToValidate.difficultyLevel,
        isInstituteFlow,
        region: formToValidate.region,
        industry_domain: formToValidate.industry_domain,
      })

      const assessmentType = formToValidate?.assessmentType

      if (assessmentType === 'Communication' || assessmentType === 'Hinglish' || assessmentType === 'Aptitude') {
        setCurrentEditingIndex(formId)
        setShowInstructionsDrawer(true)
        setIsEditMode(true)
        console.debug(
          'Switching to communication instructions drawer for formId:',
          formId
        )
        return
      } else if (assessmentType === 'Role_Based') {
        if (!formToValidate.selectedJobRole || !formToValidate.selectedSkills?.length || !formToValidate.seniority) {
          message.error('Please fill all required fields (role, skills, seniority)');
          return;
        }
        if (!validateRoleBasedSchedule(formToValidate)) {
          return;
        }
        // Broadcast mode: skip student requirement, validate scope instead
        if (formToValidate.isBroadcast) {
          const scopes = Array.isArray(formToValidate.broadcastScope) ? formToValidate.broadcastScope : (formToValidate.broadcastScope ? [formToValidate.broadcastScope] : [])
          if (scopes.length === 0 || !scopes[0]?.targetDegreeId || !scopes[0]?.targetStreamId) {
            message.error('Please add at least one Broadcast Scope (degree + department) below the broadcast radio button');
            return;
          }
        } else {
          const formStudents = uploadedStudents.filter(s => s.formId === formId);
          if (formStudents.length === 0) {
            message.error('Please upload students first');
            return;
          }
        }
        // Persist defaults to form state so handleInstructionsSave has them
        setAssessmentForms(prev => ({
          ...prev,
          forms: {
            ...prev.forms,
            [formId]: {
              ...prev.forms[formId],
              region: !prev.forms[formId].region || !prev.forms[formId].region?.trim?.() ? 'India' : prev.forms[formId].region,
              industry_domain: !prev.forms[formId].industry_domain || !prev.forms[formId].industry_domain?.trim?.() ? 'Universal' : prev.forms[formId].industry_domain,
            },
          },
        }))
        setCurrentEditingIndex(formId)
        setShowInstructionsDrawer(true)
        setIsEditMode(true)
        return;
      } else if (assessmentType === 'Custom_Assessment') {
        setCurrentEditingIndex(formId)
        setShowInstructionsDrawer(true)
        setIsEditMode(true)
        return;
      }

      // AI_Interview: no special pre-save requirements beyond validation
      if (assessmentType === 'AI_Interview') {
        console.debug('AI_Interview assessment, proceeding with save');
      }

      const isValid = validateForm(formToValidate, formId)
      if (!isValid) {
        console.debug('Form validation failed for formId:', formId)
        return
      }

      const assessmentValidation = validateAssessmentForm(
        formToValidate,
        assessmentType
      )
      if (!assessmentValidation) {
        console.debug('Assessment validation failed for formId:', formId)
        return
      }

      const defaultStartDate = moment().startOf('day')
      const defaultStartTime = moment('00:00', 'HH:mm')

      const formWithDefaults = {
        ...formToValidate,
        startDate: formToValidate.startDate || defaultStartDate,
        startTime: formToValidate.startTime || defaultStartTime,
      }

      console.debug('Form with defaults:', {
        id: formWithDefaults.id,
        assessmentType: formWithDefaults.assessmentType,
        aptitudeType: formWithDefaults.aptitudeType,
        aptitudeSubtopics: formWithDefaults.aptitudeSubtopics?.length,
        duration: formWithDefaults.duration,
        difficultyLevel: formWithDefaults.difficultyLevel,
      })

      const formStudents = uploadedStudents
        .filter(student => student.formId === formId)
        .map(student => ({
          ...student,
          qualification: {
            degree: student.degree || {},
            department: student.department || {},
            specialization: student.specialization || {},
          },
        }))

      if (formStudents.length > 0) {
        dispatch(addBulkUploadData(formId, formStudents))
      }

      // ✅ CRITICAL FIX: Extract the state update and data formatting logic
      const updatedForms = {
        ...assessmentForms,
        forms: {
          ...assessmentForms.forms,
          [formId]: {
            ...formWithDefaults,
            isSaved: true,
            bulkUploadData: formStudents,
          },
        },
      }

      // ✅ CRITICAL FIX: Format data OUTSIDE of setState
      const formattedData = formatAssessmentData(updatedForms)
      console.debug('Formatted data after save:', formattedData)

      // ✅ CRITICAL FIX: Update states synchronously
      setAssessmentForms(updatedForms)
      setAssessmentData(formattedData)
      dispatch(setAssessmentCreationData(formattedData))

      setAssessments(prev =>
        prev.map(a => (a.id === formId ? { ...a, isSaved: true } : a))
      )

      // ✅ CRITICAL FIX: Call setIsEditing(false) AFTER all other state updates
      console.debug(
        'About to call setIsEditing(false) for entityType:',
        entityType
      )
      setIsEditing(false)

      // ✅ CRITICAL FIX: Add a small delay to ensure parent component receives the change
      setTimeout(() => {
        console.debug(
          'Delayed log - setIsEditing(false) should have been called for entityType:',
          entityType
        )
      }, 100)

      const allSaved = assessments.every(assessment =>
        assessment.id === formId ? true : assessment.isSaved
      )

      if (allSaved) {
        addNewAssessment()
      }

      console.debug(
        'handleSave completed for formId:',
        formId,
        'entityType:',
        entityType
      )
    } catch (error) {
      console.error('Error in handleSave:', error)
      alert('Error saving assessment. Check console for details.')
    }
  }

  const handleInstructionsSave = (instructions, allowProctoring, allowVerification) => {
    if (currentEditingIndex !== null) {
      try {
        const rawForm = assessmentForms.forms[currentEditingIndex]
        // Apply defaults before validation (same as handleSave does)
        const currentForm = {
          ...rawForm,
          region: !rawForm.region || !rawForm.region?.trim?.() ? 'India' : rawForm.region,
          industry_domain: !rawForm.industry_domain || !rawForm.industry_domain?.trim?.() ? 'Universal' : rawForm.industry_domain,
        }

        // For Role_Based, skip full validation since handleSave already validated core fields
        // before opening the drawer. Only validate that we still have the essentials.
        if (currentForm.assessmentType === 'Role_Based') {
          if (!currentForm.selectedJobRole || !currentForm.selectedSkills?.length || !currentForm.seniority) {
            message.error('Please fill all required fields (role, skills, seniority)');
            return;
          }
          // Re-checked here, not just in handleSave: the drawer is also reachable
          // in edit mode, and the schedule can be cleared after the first save.
          if (!validateRoleBasedSchedule(currentForm)) {
            return;
          }
        } else {
          const isValid = validateForm(currentForm, currentEditingIndex)
          if (!isValid) {
            return
          }
        }

        // Role_Based: trigger multi-set generation flow with confirmation dialog
        if (currentForm.assessmentType === 'Role_Based') {
          // Update form state with proctoring & instructions first
          setAssessmentForms(prev => ({
            ...prev,
            forms: {
              ...prev.forms,
              [currentEditingIndex]: {
                ...prev.forms[currentEditingIndex],
                instructions,
                allowProctoring,
                allowVerification,
              },
            },
          }))

          setShowInstructionsDrawer(false)
          setCurrentEditingIndex(null)
          setIsEditMode(false)

          // Trigger multi-set generation with updated allowProctoring
          const formId = currentEditingIndex
          const form = { ...currentForm, allowProctoring, allowVerification, instructions }
          const formStudents = uploadedStudents.filter(s => s.formId === formId)

          // BROADCAST MODE
          if (form.isBroadcast) {
            const scopesArr = Array.isArray(form.broadcastScope) ? form.broadcastScope : (form.broadcastScope ? [form.broadcastScope] : [])
            if (scopesArr.length === 0 || !scopesArr[0]?.targetDegreeId || !scopesArr[0]?.targetStreamId) {
              message.error('Please add at least one Broadcast Scope (degree + department)');
              return;
            }
            const scopeSummary = scopesArr.map(s => `${s.degreeName || s.targetDegreeId} - ${s.streamName || s.targetStreamId}`).join(', ')

            AntModal.confirm({
              title: 'Create Broadcast Assessment',
              content: (
                <div>
                  <p>This will create a <strong>broadcast</strong> assessment covering: <strong>{scopeSummary}</strong>.</p>
                  <p>A pool of ~10 question sets will be generated. Every current and future student in these scopes will see this assessment.</p>
                  <p style={{ color: '#637487', fontSize: 13 }}>Generation takes a few minutes. You will receive an email when sets are ready for review.</p>
                </div>
              ),
              okText: 'Create Broadcast',
              cancelText: 'Cancel',
              onOk: async () => {
                try {
                  const industryDomain = !form.industry_domain || !form.industry_domain.trim() ? 'Universal' : form.industry_domain;
                  const payload = {
                    entityType: entityType,
                    entityId: selectedEntityID,
                    name: form.name || `${form.selectedJobRole} ${form.seniority} Assessment`,
                    startDate: form.startDate?.format?.('YYYY-MM-DD') || form.startDate,
                    startTime: form.startTime?.format?.('HH:mm') || form.startTime,
                    endDate: form.endDate?.format?.('YYYY-MM-DD') || form.endDate,
                    endTime: form.endTime?.format?.('HH:mm') || form.endTime,
                    allowProctoring,
                    allowVerification,
                    broadcastScope: Array.isArray(form.broadcastScope) ? form.broadcastScope : (form.broadcastScope ? [form.broadcastScope] : []),
                    broadcastLabelSpecialisations: form.broadcastLabelSpecialisations || [],
                    roleName: form.selectedJobRole,
                    skills: form.selectedSkills,
                    seniority: form.seniority,
                    jobDescription: form.jobDescription || '',
                    industryDomain,
                    region: form.region || 'India',
                    duration: form.durationMinutes || 30,
                    questionConfig: {
                      mcqCount: form.questionConfig?.mcqCount ?? 10,
                      subjectiveCount: form.questionConfig?.subjectiveCount ?? 2,
                      videoCount: form.questionConfig?.videoCount ?? 1,
                      codingCount: form.questionConfig?.codingCount ?? 0,
                    },
                    bulkUploadData: formStudents,
                    createdBy: userEmail,
                  };

                  message.loading({ content: 'Creating broadcast...', key: 'gen' });
                  const res = await createBroadcast(payload);
                  const groupId = res.data?.data?.groupId;
                  message.success({ content: 'Broadcast created! Sets are being generated.', key: 'gen', duration: 5 });

                  if (groupId) {
                    assessmentSelectNavigate(`/assessment/review/${groupId}`);
                  }
                } catch (err) {
                  console.error('Error creating broadcast:', err);
                  message.error({ content: err.response?.data?.message || 'Failed to create broadcast', key: 'gen' });
                }
              },
            });
            return;
          }

          // STANDARD ROLE_BASED FLOW (non-broadcast)
          const totalStudents = formStudents.length
          const maxPerSet = Math.max(5, Math.ceil(totalStudents * 0.10))
          const totalSets = Math.ceil(totalStudents / maxPerSet)

          AntModal.confirm({
            title: 'Generate Assessment Sets',
            content: (
              <div>
                <p>This will generate <strong>{totalSets} unique assessment set{totalSets > 1 ? 's' : ''}</strong> for <strong>{totalStudents} student{totalStudents > 1 ? 's' : ''}</strong> (max {maxPerSet} students per set).</p>
                <p style={{ color: '#637487', fontSize: 13 }}>Generation takes a few minutes. You will receive an email when sets are ready for review.</p>
              </div>
            ),
            okText: 'Generate',
            cancelText: 'Cancel',
            onOk: async () => {
              try {
                const industryDomain = !form.industry_domain || !form.industry_domain.trim()
                  ? 'Universal'
                  : form.industry_domain;

                const payload = {
                  entityType: entityType,
                  entityId: selectedEntityID,
                  bulkUploadData: formStudents,
                  roleName: form.selectedJobRole,
                  skills: form.selectedSkills,
                  seniority: form.seniority,
                  jobDescription: form.jobDescription || '',
                  industryDomain: industryDomain,
                  region: form.region || 'India',
                  duration: form.durationMinutes || 30,
                  questionConfig: {
                    mcqCount: form.questionConfig?.mcqCount ?? 10,
                    subjectiveCount: form.questionConfig?.subjectiveCount ?? 2,
                    videoCount: form.questionConfig?.videoCount ?? 1,
                    codingCount: form.questionConfig?.codingCount ?? 0,
                  },
                  name: form.name || `${form.selectedJobRole} ${form.seniority} Assessment`,
                  startDate: form.startDate?.format?.('YYYY-MM-DD') || form.startDate,
                  startTime: form.startTime?.format?.('HH:mm') || form.startTime,
                  endDate: form.endDate?.format?.('YYYY-MM-DD') || form.endDate,
                  endTime: form.endTime?.format?.('HH:mm') || form.endTime,
                  allowProctoring: allowProctoring,
                  allowVerification: allowVerification,
                  instructions: instructions,
                  createdBy: userEmail,
                  // Corporate-only: candidates verify by email OTP (no portal login).
                  isOtpInvite: entityType === 'corporate' ? !!isOtpInvite : false,
                };

                message.loading({ content: 'Initiating generation...', key: 'gen' });
                const res = await initiateRoleBasedGeneration(payload);
                const groupId = res.data?.data?.groupId;
                message.success({ content: `Generating ${totalSets} sets. You'll get an email when ready.`, key: 'gen', duration: 5 });

                if (groupId) {
                  assessmentSelectNavigate(`/assessment/review/${groupId}`);
                }
              } catch (err) {
                console.error('Error initiating multi-set generation:', err);
                message.error({ content: err.response?.data?.message || 'Failed to initiate generation', key: 'gen' });
              }
            },
          });
          return;
        }

        const defaultStartDate = moment().startOf('day')
        const defaultStartTime = moment('00:00', 'HH:mm')

        const formWithDefaults = {
          ...currentForm,
          startDate: currentForm.startDate || defaultStartDate,
          startTime: currentForm.startTime || defaultStartTime,
        }

        const formStudents = uploadedStudents
          .filter(student => student.formId === currentEditingIndex)
          .map(student => ({
            ...student,
            qualification: {
              degree: student.degree || student.qualification?.degree || {},
              department:
                student.department || student.qualification?.department || {},
              specialization:
                student.specialization ||
                student.qualification?.specialization ||
                {},
            },
          }))

        if (formStudents.length > 0) {
          dispatch(addBulkUploadData(currentEditingIndex, formStudents))
        }

        // ✅ CRITICAL FIX: Same pattern as handleSave
        const updatedForms = {
          ...assessmentForms,
          forms: {
            ...assessmentForms.forms,
            [currentEditingIndex]: {
              ...formWithDefaults,
              instructions,
              isSaved: true,
              allowProctoring: allowProctoring,
              allowVerification: allowVerification,
              bulkUploadData: formStudents,
            },
          },
        }

        const formattedData = formatAssessmentData(updatedForms)

        // ✅ CRITICAL FIX: Update states synchronously
        setAssessmentForms(updatedForms)
        setAssessmentData(formattedData)
        dispatch(setAssessmentCreationData(formattedData))

        setAssessments(prev =>
          prev.map(a =>
            a.id === currentEditingIndex ? { ...a, isSaved: true } : a
          )
        )

        // ✅ CRITICAL FIX: Call setIsEditing(false) AFTER all other state updates
        console.debug(
          'Communication assessment - about to call setIsEditing(false) for entityType:',
          entityType
        )
        setIsEditing(false)

        // ✅ CRITICAL FIX: Add a small delay to ensure parent component receives the change
        setTimeout(() => {
          console.debug(
            'Communication assessment - Delayed log - setIsEditing(false) should have been called for entityType:',
            entityType
          )
        }, 100)

        const allSaved = assessments.every(assessment =>
          assessment.id === currentEditingIndex ? true : assessment.isSaved
        )

        if (allSaved) {
          addNewAssessment()
        }
      } catch (error) {
        console.error('Error saving instructions:', error)
      } finally {
        setShowInstructionsDrawer(false)
        setCurrentEditingIndex(null)
        setIsEditMode(false)
      }
    }
  }

  const handleConfirmDelete = deleteId => {
    if (deleteId) {
      try {
        setAssessments(prev => prev.filter(a => a.id !== deleteId))
        setAssessmentOrder(prev => prev.filter(id => id !== deleteId))

        setAssessmentForms(prev => {
          const updatedForms = {
            ...prev,
            forms: Object.fromEntries(
              Object.entries(prev.forms).filter(([id]) => id !== deleteId)
            ),
          }

          const formattedData = formatAssessmentData(updatedForms)

          setAssessmentData(formattedData)

          dispatch(setAssessmentCreationData(formattedData))

          return updatedForms
        })

        setUploadedStudents(prev =>
          prev.filter(student => student.formId !== deleteId)
        )

        setUploadSummaries([])

        dispatch(removeAssessment(deleteId))
      } catch (error) {
        console.error('Error deleting assessment:', error)
      }
    }
    setIsDeleteDialogOpen(false)
  }

  const handleEdit = formId => {
    try {
      const currentForm = assessmentForms.forms[formId]
      const assessmentType = currentForm?.assessmentType

      const formStudentsFromRedux = currentForm?.bulkUploadData || []
      const formStudentsFromLocal = uploadedStudents.filter(
        student => student.formId === formId
      )

      const formStudents =
        formStudentsFromRedux.length > 0
          ? formStudentsFromRedux
          : formStudentsFromLocal // ✅ FIXED: Restore candidates with proper structure for editing
      const enhancedStudents = formStudents.map(student => ({
        ...student,
        formId: formId,
        qualification: {
          degree: student.degree || student.qualification?.degree || {},
          department:
            student.department || student.qualification?.department || {},
          specialization:
            student.specialization ||
            student.qualification?.specialization ||
            {},
        },
        // ✅ FIXED: Ensure objects are properly formatted for the drawer
        degreeObj:
          student.degree && typeof student.degree === 'object'
            ? student.degree
            : student.degreeObj,
        departmentObj:
          student.department && typeof student.department === 'object'
            ? student.department
            : student.departmentObj,
        specializationObj:
          student.specialization && typeof student.specialization === 'object'
            ? student.specialization
            : student.specializationObj,
      }))

      setUploadedStudents(prev => {
        const filteredPrev = prev.filter(student => student.formId !== formId)
        return [...filteredPrev, ...enhancedStudents]
      })

      // ✅ Restore preserved candidates including Excel and manual entries
      const preservedCandidates = preservedCandidatesData[formId] || []
      if (preservedCandidates.length > 0) {
        console.log(
          'Restoring preserved candidates for edit:',
          preservedCandidates
        )
        // Preserved candidates will be loaded by the drawer useEffect
      }

      // ✅ Restore preserved upload summaries
      const preservedSummaries = preservedUploadSummaries[formId] || []
      if (preservedSummaries.length > 0) {
        setUploadSummaries(prev => [
          ...prev.filter(summary => summary.formId !== formId),
          ...preservedSummaries,
        ])
      } else if (enhancedStudents.length > 0) {
        // Generate summaries from enhanced students if no preserved summaries exist
        const groupedStudents = {}

        enhancedStudents.forEach(student => {
          const degree = student.degree || student.qualification?.degree
          const department =
            student.department || student.qualification?.department
          const specialization =
            student.specialization || student.qualification?.specialization

          if (!degree || !department) {
            return
          }

          const key = `${degree.degreeId}-${department.streamId}-${specialization?.specialisationId || 'none'
            }`

          if (!groupedStudents[key]) {
            groupedStudents[key] = {
              students: [],
              degree,
              department,
              specialization,
            }
          }

          groupedStudents[key].students.push(student)
        })

        const newSummaries = Object.values(groupedStudents).map(group => ({
          id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          formId: formId,
          count: group.students.length,
          degree: group.degree,
          department: group.department,
          specialization: group.specialization,
        }))

        setUploadSummaries(prev => [
          ...prev.filter(summary => summary.formId !== formId),
          ...newSummaries,
        ])

        // Save the generated summaries
        setPreservedUploadSummaries(prev => ({
          ...prev,
          [formId]: newSummaries,
        }))
      }

      setAssessmentForms(prev => ({
        ...prev,
        activeFormId: formId,
        forms: {
          ...prev.forms,
          [formId]: {
            ...currentForm,
            isSaved: false,
          },
        },
      }))

      setAssessments(prev =>
        prev.map(a => (a.id === formId ? { ...a, isSaved: false } : a))
      )

      setIsEditing(true)

      if (assessmentType === 'Communication' || assessmentType === 'Aptitude' || assessmentType === 'Hinglish') {
        setCurrentEditingIndex(formId)
        setShowInstructionsDrawer(true)
        setIsEditMode(true)
      }
    } catch (error) {
      console.error('Error in handleEdit:', error)
    }
  }

  const handleDrawerClose = () => {
    setShowInstructionsDrawer(false)
    setCurrentEditingIndex(null)
    setIsEditMode(false)
  }

  const handleBulkUploadClose = () => {
    // Preserve upload summaries for the current form
    const activeId = assessmentForms.activeFormId
    if (activeId) {
      const currentFormSummaries = uploadSummaries.filter(
        summary => summary.formId === activeId
      )
      setPreservedUploadSummaries(prev => ({
        ...prev,
        [activeId]: currentFormSummaries,
      }))
    }

    setShowBulkUploadDrawer(false)
  }

  const customValidator = (_, formId) => {
    if (
      assessmentForms.forms[formId]?.isCheckboxSelected &&
      (!assessmentForms.forms[formId]?.qualificationData ||
        (assessmentForms.forms[formId]?.qualificationData || []).length === 0)
    ) {
      return Promise.reject('Please select at least one degree')
    }
    return Promise.resolve()
  }


  const handleOpenAddSectionModal = () => {
    setIsAddSectionModalOpen(true);
  };

  const handleSectionAdd = async newSection => {
    const activeFormId = assessmentForms.activeFormId;
    const activeForm = assessmentForms.forms[activeFormId];

    try {
      const result = await dispatch(
        createCustomSectionQuestions(
          selectedEntityID,
          selectedEntityData?.name || '',
          [newSection]
        )
      );

      if (result && result.sections && result.sections.length > 0) {
        const apiSection = result.sections[0].section;

        const enrichedSection = {
          ...newSection,
          section_id: apiSection.id,
          totalQuestions: apiSection.totalQuestions,
          questions: newSection.questions || []
        };

        // ✅ Update form state instead of component state
        setAssessmentForms(prev => ({
          ...prev,
          forms: {
            ...prev.forms,
            [activeFormId]: {
              ...prev.forms[activeFormId],
              customSections: [...(activeForm.customSections || []), enrichedSection]
            }
          }
        }));

        message.success(`Section "${apiSection.name}" created with ${apiSection.totalQuestions} questions`);
      }
    } catch (error) {
      console.error('❌ Failed to create section:', error);
      message.error('Failed to create section. Please try again.');
    }
  };

  const handleSectionSelect = (sectionId, section) => {
    console.log('🎯 Section selected/deselected:', { sectionId, sectionName: section.section_name });
    const activeFormId = assessmentForms.activeFormId;
    const activeForm = assessmentForms.forms[activeFormId];
    const currentSelectedIds = activeForm.selectedSectionIds || [];
    const currentConfig = activeForm.customSectionConfig || {};

    const isSelected = currentSelectedIds.includes(sectionId);

    if (isSelected) {
      // Deselect: remove from selectedSectionIds and config (keyed by id, not name)
      const nextSelected = currentSelectedIds.filter(id => id !== sectionId);
      const nextConfig = { ...currentConfig };
      delete nextConfig[sectionId];

      // ✅ Update form state
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [activeFormId]: {
            ...prev.forms[activeFormId],
            selectedSectionIds: nextSelected,
            customSectionConfig: nextConfig
          }
        }
      }));
    } else {
      // Select: add to selectedSectionIds and initialize config (keyed by id, not name)
      const nextSelected = [...currentSelectedIds, sectionId];
      const nextConfig = {
        ...currentConfig,
        [sectionId]: {
          section_name: section.section_name,
          numQuestions: section.totalQuestions || 0,
          totalMarks: 0,
          sectionTime: 30,
          marksPerQuestion: 0
        }
      };

      // ✅ Update form state
      setAssessmentForms(prev => ({
        ...prev,
        forms: {
          ...prev.forms,
          [activeFormId]: {
            ...prev.forms[activeFormId],
            selectedSectionIds: nextSelected,
            customSectionConfig: nextConfig
          }
        }
      }));
    }
  };
  const handleViewQuestions = (e, section) => {
    e.stopPropagation(); // Prevent card selection when clicking edit
    setSelectedSectionForView(section);
    setViewerVisible(true);
  };

  const handleCloseViewer = () => {
    setViewerVisible(false);
    setSelectedSectionForView(null);
  };
  return (
    <MainContainer>
      <LeftContent>
        <AssessmentContainer>
          {assessmentOrder.map((formId, index) => {
            const form = assessmentForms.forms[formId]

            return (
              <div key={formId}>
                {/* <Title>Assessment {index + 1}</Title> */}
                {!form?.isSaved ? (
                  <>
                    <SelectionRow>
                      <Label>Select Assessment {index + 1}</Label>
                      <SelectionColumn>
                        <StyledSelect
                          placeholder="Select Assessment"
                          showSearch={true}
                          OptionData={localAssessments}
                          onChange={value => handleAssessmentChange(value, formId)}
                          valueParam="id"
                          nameParam="name"
                          value={form?.assessmentType}
                          style={
                            validationErrors[formId]?.assessmentType
                              ? errorStyle
                              : {}
                          }
                          width={340}
                        />

                        {form?.assessmentType && (
                          <>
                            <SaveButton
                              // type="primary"
                              text="Save"
                              style={{ color: '#FFFFFF' }}
                              onClick={() => {
                                console.log(
                                  'Save button clicked for formId:',
                                  formId
                                )
                                console.log('Current form state:', form)
                                console.log('Assessment forms:', assessmentForms)
                                console.log('Upload summaries:', uploadSummaries)
                                console.log('Uploaded students:', uploadedStudents)
                                handleSave(formId)
                              }}
                            />
                          </>
                        )}

                        {/* {index === assessments.length - 1 && (
                          <AddAnotherButton
                            onClick={addNewAssessment}
                            text="Add another assessment"
                            isActive={!!form && form.isSaved}
                          />
                        )} */}
                      </SelectionColumn>
                    </SelectionRow>

                    {form?.assessmentType && (
                      <>
                        {renderAssessmentDescription(
                          getAssessmentDescription(form.assessmentType),
                          form.assessmentType, // Add this parameter
                          formId // Add this parameter
                        )}
                        {renderAssessmentOptions(form.assessmentType, formId)}
                        {renderNegativeMarkingOption(formId)}

                        {/* Add separator after DifficultyContainer */}
                        <Separator />

                        <StyledSearchSection style={{ marginTop: '32px' }}>
                          <Label>Assessment Name</Label>
                          <StyledSearchInput
                            placeholder="Name"
                            value={form?.name || ''}
                            style={validationErrors[formId]?.name ? errorStyle : {}}
                            onChange={e =>
                              setAssessmentForms(prev => ({
                                ...prev,
                                forms: {
                                  ...prev.forms,
                                  [formId]: {
                                    ...prev.forms[formId],
                                    name: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                        </StyledSearchSection>

                        {entityType !== 'corporate' && (
                          <div style={{ marginTop: '24px' }}>
                            <SectionHeading>Scheduled Distribution of Assmt. *</SectionHeading>
                            <Radio.Group
                              onChange={(e) => {
                                const distributionType = e.target.value;

                                let updates = { distributionType };

                                if (distributionType === 'scheduled') {
                                  if (!['Communication', 'Aptitude', 'Hinglish'].includes(form.assessmentType)) {
                                    message.warning('Not allowed for selected assessment type');
                                    return;
                                  }
                                  const tomorrow = moment().add(1, 'day').startOf('day');
                                  const dayAfterTomorrow = moment().add(2, 'days').startOf('day');
                                  updates = { ...updates, startDate: tomorrow, endDate: dayAfterTomorrow, isBroadcast: false };
                                } else if (distributionType === 'broadcast') {
                                  if (form.assessmentType !== 'Role_Based') {
                                    message.warning('Broadcast is only available for Role-Based assessments');
                                    return;
                                  }
                                  // For broadcasts: start at 00:00 today (always available immediately, no TZ issues)
                                  // and end at 10 years out (no real end). Pickers are hidden in broadcast mode.
                                  const today = moment().startOf('day');
                                  const tenYearsLater = moment().add(10, 'years').startOf('day');
                                  updates = {
                                    ...updates,
                                    startDate: today,
                                    startTime: moment('00:00', 'HH:mm'),
                                    endDate: tenYearsLater,
                                    endTime: moment('23:59', 'HH:mm'),
                                    isBroadcast: true,
                                  };
                                } else if (distributionType === 'one-time') {
                                  const today = moment().startOf('day');
                                  const tomorrow = moment().add(1, 'day').startOf('day');
                                  updates = { ...updates, startDate: today, endDate: tomorrow, isBroadcast: false };
                                }

                                setAssessmentForms(prev => ({
                                  ...prev,
                                  forms: {
                                    ...prev.forms,
                                    [formId]: {
                                      ...prev.forms[formId],
                                      ...updates
                                    }
                                  }
                                }));
                              }}
                              value={form.distributionType}
                              defaultValue="one-time"
                            >
                              <Radio value="scheduled" style={{ border: '1px solid #D0D5DD', borderRadius: '8px', padding: '8px 24px', marginRight: '16px' }}>Schedule Assmts.</Radio>
                              <Radio value="one-time" style={{ border: '1px solid #D0D5DD', borderRadius: '8px', padding: '8px 24px', marginRight: '16px' }}>One-Time Assmt.</Radio>
                              {form.assessmentType === 'Role_Based' && (
                                <Radio value="broadcast" style={{ border: `1px solid ${form.distributionType === 'broadcast' ? '#3249D7' : '#D0D5DD'}`, borderRadius: '8px', padding: '8px 24px', background: form.distributionType === 'broadcast' ? '#EAEDFB' : 'transparent' }}>Broadcast</Radio>
                              )}
                            </Radio.Group>

                            {form.distributionType === 'broadcast' && (
                              <InlineBroadcastScopePicker
                                form={form}
                                formId={formId}
                                degrees={(form.qualificationData && form.qualificationData.length > 0) ? form.qualificationData : broadcastDegrees}
                                degreesLoading={broadcastDegreesLoading}
                                setAssessmentForms={setAssessmentForms}
                                campusId={broadcastCampusId}
                              />
                            )}

                            {form.distributionType === 'scheduled' && (
                              <div style={{ marginTop: '24px' }}>
                                <Grid style={{ gap: '30px', marginTop: '24px', marginBottom: '24px', maxWidth: '900px' }}>
                                  {/* Start Date & Time */}
                                  <FormItem $width="220px">
                                    <DatePicker
                                      label="Start Date *"
                                      value={form.startDate}
                                      onChange={date => {
                                        setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], startDate: date } } }));
                                      }}
                                      style={{
                                        ...validationErrors[formId]?.startDate ? errorStyle : {},
                                        minWidth: '200px',
                                        fontSize: '16px'
                                      }}
                                      name="startDate"
                                      width="100%"
                                      // ✅ FIX: Disable today's date - only allow from tomorrow onwards
                                      disabledDate={current => current && current.isBefore(moment().add(1, 'day').startOf('day'))}
                                      showToday={false}
                                      // ✅ NEW FIX: Set default value to tomorrow for scheduled assessments
                                      defaultValue={moment().add(1, 'day').startOf('day')}
                                      placeholder="Select date (from tomorrow)"
                                    />
                                    {/* Start Time under Start Date */}
                                    {form.distributionType !== 'scheduled' && (
                                      <div style={{ marginTop: '8px' }}>
                                        <Label>Start Time</Label>
                                        <TimeStyles
                                          style={{
                                            ...validationErrors[formId]?.startTime ? errorStyle : {},
                                            minWidth: '120px',
                                            fontSize: '16px'
                                          }}
                                          format="HH:mm"
                                          showSecond={false}
                                          allowClear={false}
                                          suffixIcon={<Clock />}
                                          value={form.startTime}
                                          placeholder="00:00"
                                          onChange={time => {
                                            setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], startTime: time } } }));
                                          }}
                                          getPopupContainer={() => document.getElementById(`start_time_${formId}`)}
                                        />
                                      </div>
                                    )}
                                  </FormItem>

                                  {/* End Date & Time — hidden for broadcasts */}
                                  {!form.isBroadcast && (
                                  <FormItem $width="220px">
                                    <DatePicker
                                      label="End Date *"
                                      value={form.endDate}
                                      onChange={date => {
                                        setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], endDate: date } } }));
                                      }}
                                      style={{
                                        ...validationErrors[formId]?.endDate ? errorStyle : {},
                                        minWidth: '200px',
                                        fontSize: '16px'
                                      }}
                                      name="endDate"
                                      width="100%"
                                      disabledDate={current => {
                                        // ✅ FIX: For scheduled assessments, start date should be at least tomorrow
                                        const startDate = form.startDate || moment().add(1, 'day').startOf('day');
                                        return current && (current.isBefore(moment().add(1, 'day').startOf('day')) || (startDate && current.isBefore(startDate)));
                                      }}
                                      showToday={false}
                                      // ✅ NEW FIX: Set default value to tomorrow + 1 day for end date
                                      defaultValue={moment().add(2, 'days').startOf('day')}
                                      placeholder="Select end date"
                                    />
                                    {/* End Time under End Date */}
                                    {form.distributionType !== 'scheduled' && (
                                      <div style={{ marginTop: '8px' }}>
                                        <Label>End Time *</Label>
                                        <TimeStyles
                                          style={{
                                            ...validationErrors[formId]?.endTime ? errorStyle : {},
                                            minWidth: '120px',
                                            fontSize: '16px'
                                          }}
                                          format="HH:mm"
                                          showSecond={false}
                                          allowClear={false}
                                          suffixIcon={<Clock />}
                                          value={form.endTime}
                                          placeholder="00:00"
                                          onChange={time => {
                                            setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], endTime: time } } }));
                                          }}
                                          getPopupContainer={() => document.getElementById(`end_time_${formId}`)}
                                        />
                                      </div>
                                    )}
                                  </FormItem>
                                  )}
                                </Grid>
                                <Grid>
                                  <FormItem $width="268px">
                                    <Label>Frequency of the assessment</Label>
                                    <Select
                                      placeholder="Select Frequency Type"
                                      style={{ width: '75%' }}
                                      onChange={(value) => {
                                        setAssessmentForms(prev => ({
                                          ...prev,
                                          forms: {
                                            ...prev.forms,
                                            [formId]: {
                                              ...prev.forms[formId],
                                              frequencyType: value,
                                              frequencyValue: null, // Reset frequencyValue on type change
                                            }
                                          }
                                        }));
                                      }}
                                      value={form.frequencyType}
                                    >
                                      <Option value="DAILY">Every Day</Option>
                                      <Option value="WEEKLY">Every Week</Option>
                                      <Option value="MONTHLY">Every Month</Option>
                                      <Option value="CUSTOM">Custom Dates</Option> {/* Add this option */}

                                    </Select>
                                  </FormItem>
                                  <FormItem $width="200px" $marginLeft="-20px">
                                    <Label>&nbsp;</Label>
                                    {/* Show Select for all except CUSTOM, show multi-date picker for CUSTOM */}
                                    {form.frequencyType !== 'CUSTOM' ? (
                                      <Select
                                        placeholder="Select Frequency"
                                        style={{ width: '100%' }}
                                        disabled={!form.frequencyType}
                                        onChange={(value) => {
                                          setAssessmentForms(prev => ({
                                            ...prev,
                                            forms: {
                                              ...prev.forms,
                                              [formId]: {
                                                ...prev.forms[formId],
                                                frequencyValue: value, // Store only the primitive value
                                              }
                                            }
                                          }));
                                        }}
                                        value={form.frequencyValue}
                                      >
                                        {(form.frequencyType && frequencyOptions[form.frequencyType] || []).map(opt => (
                                          <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                        ))}
                                      </Select>
                                    ) : (
                                      <div>
                                        <Button
                                          type="default"
                                          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                                          onClick={() => setShowCustomCalendar(true)}
                                          disabled={!form.startDate || !form.endDate}
                                        >
                                          {Array.isArray(form.frequencyValue) && form.frequencyValue.length > 0
                                            ? `${form.frequencyValue.length} of ${form.frequencyValue.length} selected`
                                            : 'Pick Dates Here'
                                          }
                                          <span style={{ marginLeft: '8px' }}>
                                            <svg width="20" height="20" fill="none"><rect width="20" height="20" rx="4" fill="#F3F4F6" /><path d="M6 8h8M6 12h4" stroke="#444CE7" strokeWidth="1.5" strokeLinecap="round" /><rect x="3" y="5" width="14" height="12" rx="2" stroke="#444CE7" strokeWidth="1.5" /></svg>
                                          </span>
                                        </Button>
                                        {/* Remove the actual dates display below the button */}
                                        {(!form.startDate || !form.endDate) && (
                                          <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
                                            Please select start and end dates first
                                          </Text>
                                        )}

                                      </div>
                                    )}


                                  </FormItem>
                                </Grid>
                                <FormItem $width="450px">
                                  <Label>Per Assessment Validity (Days) *</Label>
                                  <InputNumber
                                    placeholder="Enter number of days"
                                    min={1}
                                    precision={0}
                                    style={{
                                      width: '100%',
                                      ...(validationErrors[formId]?.assessmentValidityDays ? errorStyle : {})
                                    }}
                                    onChange={(value) => {
                                      setAssessmentForms(prev => ({
                                        ...prev,
                                        forms: {
                                          ...prev.forms,
                                          [formId]: {
                                            ...prev.forms[formId],
                                            assessmentValidityDays: value
                                          }
                                        }
                                      }));
                                      if (validationErrors[formId]?.assessmentValidityDays) {
                                        setValidationErrors(prev => ({
                                          ...prev,
                                          [formId]: {
                                            ...prev[formId],
                                            assessmentValidityDays: false,
                                          },
                                        }))
                                      }
                                    }}
                                    value={form.assessmentValidityDays}
                                    addonAfter="days"
                                  />
                                </FormItem>

                              </div>
                            )}
                          </div>
                        )}
                        {form.distributionType !== 'scheduled' && (
                          <Grid style={{ gap: '32px', marginTop: '24px', marginBottom: '24px', maxWidth: '900px' }}>
                            {/* Start Date & Time */}
                            <FormItem $width="220px">
                              <DatePicker
                                label="Start Date *"
                                value={form.startDate}
                                onChange={date => {
                                  setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], startDate: date } } }));
                                }}
                                style={{
                                  ...validationErrors[formId]?.startDate ? errorStyle : {},
                                  minWidth: '200px',
                                  fontSize: '16px'
                                }}
                                name="startDate"
                                width="100%"
                                // ✅ NEW FIX: For one-time assessments, allow today's date
                                disabledDate={current => current && current.isBefore(moment().startOf('day'))}
                                showToday={true}  // ✅ Show today option for one-time
                                placeholder="Select date (from today)"
                              />

                              {/* Start Time under Start Date */}
                              <div style={{ marginTop: '8px' }}>
                                <Label>Start Time</Label>
                                <TimeStyles
                                  style={{
                                    ...validationErrors[formId]?.startTime ? errorStyle : {},
                                    minWidth: '120px',
                                    fontSize: '16px'
                                  }}
                                  format="HH:mm"
                                  showSecond={false}
                                  allowClear={false}
                                  suffixIcon={<Clock />}
                                  value={form.startTime}
                                  placeholder="00:00"
                                  onChange={time => {
                                    setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], startTime: time } } }));
                                  }}
                                  getPopupContainer={() => document.getElementById(`start_time_${formId}`)}
                                />
                              </div>
                            </FormItem>

                            {/* End Date & Time — hidden for broadcasts */}
                            {!form.isBroadcast && (
                            <FormItem $width="220px">
                              <DatePicker
                                label="End Date *"
                                value={form.endDate}
                                onChange={date => {
                                  setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], endDate: date } } }));
                                }}
                                style={{
                                  ...validationErrors[formId]?.endDate ? errorStyle : {},
                                  minWidth: '200px',
                                  fontSize: '16px'
                                }}
                                name="endDate"
                                width="100%"
                                disabledDate={current => {
                                  const startDate = form.startDate || moment().startOf('day');
                                  return current && (current.isBefore(moment().startOf('day')) || (startDate && current.isBefore(startDate)));
                                }}
                                showToday={true}
                                placeholder="Select end date"
                              />

                              {/* End Time under End Date */}
                              <div style={{ marginTop: '8px' }}>
                                <Label>End Time *</Label>
                                <TimeStyles
                                  style={{
                                    ...validationErrors[formId]?.endTime ? errorStyle : {},
                                    minWidth: '120px',
                                    fontSize: '16px'
                                  }}
                                  format="HH:mm"
                                  showSecond={false}
                                  allowClear={false}
                                  suffixIcon={<Clock />}
                                  value={form.endTime}
                                  placeholder="00:00"
                                  onChange={time => {
                                    setAssessmentForms(prev => ({ ...prev, forms: { ...prev.forms, [formId]: { ...prev.forms[formId], endTime: time } } }));
                                  }}
                                  getPopupContainer={() => document.getElementById(`end_time_${formId}`)}
                                />
                              </div>
                            </FormItem>
                            )}
                          </Grid>
                        )}

                        {/* Add separator after Grid */}
                        <Separator />

                        <FormItem $marginBottom="0px" $marginTop="16px">
                          {/* Conditionally render bulk upload or view candidates button */}
                          {!preservedCandidatesData[formId] ||
                            preservedCandidatesData[formId].length === 0 ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                flexWrap: 'wrap',
                              }}
                            >
                              <InfoBadge>
                                {entityType === 'college'
                                  ? 'To continue, please provide the candidate data.'
                                  : entityType === 'corporate'
                                    ? 'To continue, please provide the candidate data'
                                    : 'To continue, please provide the candidate data'}
                              </InfoBadge>
                              <UploadButtons
                                uploadText={
                                  entityType === 'college'
                                    ? ' Add Candidates'
                                    : entityType === 'corporate'
                                      ? ' Add Candidates'
                                      : ' Add Candidates'
                                }
                                onUploadClick={() => {
                                  setDrawerInitialScreen('main_options')
                                  setShowBulkUploadDrawer(true)
                                }}
                                style={{
                                  marginTop: '0px',
                                  fontSize: '16px',
                                  padding: '10px 171px',
                                }}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                flexWrap: 'wrap',
                              }}
                            >
                              {uploadSummaries.filter(
                                summary => summary.formId === formId
                              ).length > 0 && (
                                  <div style={{ flexShrink: 0 }}>
                                    {(() => {
                                      const totalCount = uploadSummaries
                                        .filter(summary => summary.formId === formId)
                                        .reduce(
                                          (sum, summary) => sum + summary.count,
                                          0
                                        )

                                      return (
                                        // Replace count badge sections
                                        <InfoBadge>
                                          <CountBadge>{totalCount}</CountBadge>
                                          {entityType === 'corporate'
                                            ? `candidate${totalCount !== 1 ? 's' : ''
                                            } ${totalCount === 1 ? 'is' : 'are'
                                            } selected for assessment`
                                            : `candidate${totalCount !== 1 ? 's' : ''
                                            } ${totalCount === 1 ? 'is' : 'are'
                                            } selected for assessment`}
                                        </InfoBadge>
                                      )
                                    })()}
                                  </div>
                                )}
                              <Button
                                type="default"
                                // icon={<TeamOutlined />}
                                onClick={() => {
                                  setDrawerInitialScreen('summary')
                                  setShowBulkUploadDrawer(true)
                                }}
                                style={{
                                  marginTop: '0px',
                                  fontSize: '14px',
                                  padding: '10px 10px',
                                  borderRadius: '8px',
                                  fontWeight: '600',
                                  height: '40px',
                                  minWidth: '100px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  color: '#FFFFFF',
                                  backgroundColor: '#444CE7',
                                }}
                              >
                                View Candidates
                              </Button>
                            </div>
                          )}
                        </FormItem>
                      </>
                    )}
                  </>
                ) : (
                  <SavedAssessmentContainer>
                    <ConfirmationIcon />
                    <AssessmentName>{`${form?.name} Assessment`}</AssessmentName>
                    <ButtonGroup>
                      <EditButton text="Edit" onClick={() => handleEdit(formId)} />
                      <DeleteButton
                        text="Delete"
                        onClick={() => {
                          setDeleteIndex(formId)
                          setIsDeleteDialogOpen(true)
                        }}
                      />
                    </ButtonGroup>
                  </SavedAssessmentContainer>
                )}
              </div>
            )
          })}
          <InstructionsDrawer
            visible={showInstructionsDrawer}
            onClose={handleDrawerClose}
            onEdit={() => setIsEditMode(true)}
            closeEdit={() => setIsEditMode(false)}
            onSave={handleInstructionsSave}
            isEditMode={isEditMode}
            initialAllowProctoring={
              assessmentForms.forms[currentEditingIndex]?.allowProctoring ?? true
            }
            initialAllowVerification={
              assessmentForms.forms[currentEditingIndex]?.allowVerification ?? true
            }
            assessmentForms={assessmentForms}
            currentEditingIndex={currentEditingIndex}
            entityType={entityType}
            assessmentType={currentEditingIndex !== null ? assessmentForms.forms[currentEditingIndex]?.assessmentType : assessmentTypeData}
          />{' '}
          <ConfirmationDialog
            isOpen={isDeleteDialogOpen}
            onClose={() => setIsDeleteDialogOpen(false)}
            onConfirm={() => handleConfirmDelete(deleteIndex)}
            icon={<DeleteConfirmation />}
            title="Are you sure to delete the Assessment?"
            confirmText="Delete"
            cancelText="Back"
          />{' '}
          <EnhancedBulkUploadDrawer
            visible={showBulkUploadDrawer}
            onClose={handleBulkUploadClose}
            initialScreen={drawerInitialScreen}
            assessmentData={{
              assessmentType: assessmentForms.forms[assessmentForms.activeFormId]?.assessmentType,
              isBroadcast: assessmentForms.forms[assessmentForms.activeFormId]?.isBroadcast || false,
              qualificationData:
                assessmentForms.forms[assessmentForms.activeFormId]
                  ?.qualificationData || [],
              instituteCampusId: instituteCampusId,
              instituteId: selectedEntityID,
              // ✅ FIXED: Find the form ID with actual data
              preservedCandidates: (() => {
                const activeId = assessmentForms.activeFormId

                // First try the active form
                let candidates = preservedCandidatesData[activeId] || []

                // If no candidates in active form, look for form with uploaded students
                if (candidates.length === 0 && uploadedStudents.length > 0) {
                  const formWithStudents = uploadedStudents[0]?.formId
                  if (formWithStudents && formWithStudents !== activeId) {
                    console.log(
                      `No candidates in active form ${activeId}, checking form with students: ${formWithStudents}`
                    )
                    candidates = preservedCandidatesData[formWithStudents] || []

                    // If still no preserved candidates, convert uploaded students
                    if (candidates.length === 0) {
                      const studentsForForm = uploadedStudents.filter(
                        s => s.formId === formWithStudents
                      )
                      candidates = studentsForForm.map(student => ({
                        first_name: student.firstName,
                        last_name: student.lastName,
                        email: student.email,
                        phone: student.phone || '',
                        country_code: student.countryCode || student.country_code || '',
                        ...(entityType === 'college' && {
                          degreeObj: student.degree || student.degreeObj,
                          departmentObj:
                            student.department || student.departmentObj,
                          specializationObj:
                            student.specialization || student.specializationObj,
                          passingYear: student.passingYear,
                        }),
                      }))
                      console.log(
                        `Converted ${candidates.length} uploaded students to candidates`
                      )
                    }
                  }
                }

                console.log(`Passing ${candidates.length} candidates to drawer`)
                return candidates
              })(),

              // ✅ FIXED: Same logic for summaries
              preservedUploadSummaries: (() => {
                const activeId = assessmentForms.activeFormId

                let summaries = preservedUploadSummaries[activeId] || []

                // If no summaries in active form, look for form with upload summaries
                if (summaries.length === 0 && uploadSummaries.length > 0) {
                  const formWithSummaries = uploadSummaries.find(
                    s => s.formId
                  )?.formId
                  if (formWithSummaries && formWithSummaries !== activeId) {
                    console.log(
                      `No summaries in active form ${activeId}, checking form: ${formWithSummaries}`
                    )
                    summaries = uploadSummaries.filter(
                      s => s.formId === formWithSummaries
                    )
                  }
                }

                console.log(`Passing ${summaries.length} summaries to drawer`)
                return summaries
              })(),

              timestamp: Date.now(),
            }}
            entityType={entityType}
            key={`drawer-${assessmentForms.activeFormId}-${Date.now()}`}
            onDataSubmit={(candidates, options = {}) => {
              try {
                const activeId = assessmentForms.activeFormId
                if (!activeId) {
                  message.error('No active form found')
                  return
                }

                // Handle broadcast scope submission
                if (options.isBroadcast) {
                  console.log('[Broadcast] Scope confirmed:', options.broadcastScope, 'Labels:', options.broadcastLabelSpecialisations)
                  setAssessmentForms(prev => ({
                    ...prev,
                    forms: {
                      ...prev.forms,
                      [activeId]: {
                        ...prev.forms[activeId],
                        isBroadcast: true,
                        broadcastScope: options.broadcastScope,
                        broadcastLabelSpecialisations: options.broadcastLabelSpecialisations || [],
                      },
                    },
                  }))
                  message.success('Broadcast scope confirmed')
                  return
                }

                console.log('=== ONDATASUBMIT DEBUG ===')
                console.log('Active Form ID:', activeId)
                console.log('Candidates received:', candidates.length)
                console.log('Candidates data:', candidates)
                console.log(
                  'Current preserved data before update:',
                  preservedCandidatesData[activeId]
                )
                console.log('========================')

                // ✅ CRITICAL: Set preserved data IMMEDIATELY and synchronously
                setPreservedCandidatesData(prev => {
                  const updated = {
                    ...prev,
                    [activeId]: [...candidates], // Create new array to ensure reference change
                  }
                  console.log(
                    '✅ PRESERVED DATA UPDATED:',
                    updated[activeId]?.length,
                    'candidates for form',
                    activeId
                  )
                  return updated
                })

                const currentForm = assessmentForms.forms[activeId]

                // Convert candidates to the format expected by the backend
                const studentsWithFormId = candidates.map(candidate => ({
                  first_name: candidate.firstName,
                  last_name: candidate.lastName,
                  email: candidate.email,
                  primary_email: candidate.email,
                  phone: candidate.phone || '',
                  // Country code as its own field — see utils/candidateMobile.
                  country_code: candidate.countryCode || candidate.country_code || '',
                  formId: activeId,
                  ...(entityType === 'college' &&
                    (candidate.degreeObj || candidate.degree) && {
                    degree:
                      candidate.degreeObj ||
                      (typeof candidate.degree === 'object'
                        ? candidate.degree
                        : { degreeName: candidate.degree }),
                    department:
                      candidate.departmentObj ||
                      (typeof candidate.department === 'object'
                        ? candidate.department
                        : { streamName: candidate.department }),
                    specialization:
                      candidate.specializationObj ||
                      (candidate.specialization &&
                        typeof candidate.specialization === 'object'
                        ? candidate.specialization
                        : candidate.specialization
                          ? { specialisationName: candidate.specialization }
                          : {}),
                    passingYear: candidate.passingYear,
                    qualification: {
                      degree:
                        candidate.degreeObj ||
                        (typeof candidate.degree === 'object'
                          ? candidate.degree
                          : { degreeName: candidate.degree }),
                      department:
                        candidate.departmentObj ||
                        (typeof candidate.department === 'object'
                          ? candidate.department
                          : { streamName: candidate.department }),
                      specialization:
                        candidate.specializationObj ||
                        (candidate.specialization &&
                          typeof candidate.specialization === 'object'
                          ? candidate.specialization
                          : candidate.specialization
                            ? { specialisationName: candidate.specialization }
                            : {}),
                      ...(currentForm?.assessmentType === 'Aptitude' && {
                        aptitudeScore: candidate.aptitudeScore || null,
                        aptitudeResults: candidate.aptitudeResults || null,
                      }),
                    },
                  }),
                }))

                console.log(
                  'Processed students with formId:',
                  studentsWithFormId.length
                )

                setUploadedStudents(prev => [
                  ...prev.filter(student => student.formId !== activeId),
                  ...studentsWithFormId,
                ])

                dispatch(addBulkUploadData(activeId, studentsWithFormId))

                // Create upload summaries for display
                const groupedStudents = {}

                if (entityType === 'corporate') {
                  const key = `corporate-${activeId}`
                  groupedStudents[key] = {
                    students: studentsWithFormId,
                    count: studentsWithFormId.length,
                  }
                } else {
                  studentsWithFormId.forEach(student => {
                    let key
                    if (student.degree && student.department) {
                      key = `${student.degree.degreeId || 'unknown'}-${student.department.streamId || 'unknown'
                        }-${student.specialization?.specialisationId || 'none'}`
                    } else {
                      key = `uploaded-${activeId}`
                    }

                    if (!groupedStudents[key]) {
                      groupedStudents[key] = {
                        students: [],
                        degree: student.degree || {
                          degreeName: 'Various',
                          degreeShortForm: '',
                        },
                        department: student.department || {
                          streamName: 'Multiple Departments',
                        },
                        specialization: student.specialization || null,
                      }
                    }
                    groupedStudents[key].students.push(student)
                  })
                }

                const newSummaries = Object.values(groupedStudents).map(group => ({
                  id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                  formId: activeId,
                  count: group.students.length,
                  ...(entityType === 'college' && {
                    degree: group.degree,
                    department: group.department,
                    specialization: group.specialization,
                  }),
                }))

                console.log(
                  'Generated summaries:',
                  newSummaries.length,
                  'for activeId:',
                  activeId
                )

                // Update summaries for this specific form
                setUploadSummaries(prev => [
                  ...prev.filter(summary => summary.formId !== activeId),
                  ...newSummaries,
                ])

                // ✅ Also preserve upload summaries IMMEDIATELY
                setPreservedUploadSummaries(prev => {
                  const updated = {
                    ...prev,
                    [activeId]: [...newSummaries], // Create new array to ensure reference change
                  }
                  console.log(
                    '✅ PRESERVED SUMMARIES UPDATED:',
                    updated[activeId]?.length,
                    'summaries for form',
                    activeId
                  )
                  return updated
                })

                // Only show success message if not in silent mode
                if (!options.silent) {
                  console.log(
                    `Successfully processed ${candidates.length} ${entityType === 'college' ? 'students' : 'candidates'
                    }`
                  )
                }

                // ✅ Force a re-render by updating the assessment forms to trigger useEffect in drawer
                setAssessmentForms(prev => ({
                  ...prev,
                  forms: {
                    ...prev.forms,
                    [activeId]: {
                      ...prev.forms[activeId],
                      lastUpdated: Date.now(), // Add timestamp to trigger re-render
                      candidatesPreserved: true, // Add flag to indicate data is preserved
                    },
                  },
                }))

                console.log('=== ONDATASUBMIT COMPLETE ===')
              } catch (error) {
                console.error('Error processing uploaded students:', error)
                message.error('Failed to process uploaded data')
              }
            }}
          />
        </AssessmentContainer>
      </LeftContent>


      <RightSidebar>
        <InstituteInfoCard
          instituteData={selectedEntityData || {
            name: "Select an Entity",
            location: "Location will appear here"
          }}
          assessmentDetails={{}}
          formData={assessmentForms.forms}
          onViewCalendar={handleViewCalendar}
        />

      </RightSidebar>

      <CustomDateCalendarDrawer
        visible={showCustomCalendar}
        onClose={() => setShowCustomCalendar(false)}
        startDate={assessmentForms.forms[assessmentForms.activeFormId]?.startDate}
        endDate={assessmentForms.forms[assessmentForms.activeFormId]?.endDate}
        selectedDates={Array.isArray(assessmentForms.forms[assessmentForms.activeFormId]?.frequencyValue) ? assessmentForms.forms[assessmentForms.activeFormId].frequencyValue : []}
        onDatesChange={(selectedDates) => {
          console.log('Custom dates selected:', selectedDates);
          const activeFormId = assessmentForms.activeFormId;
          setAssessmentForms(prev => ({
            ...prev,
            forms: {
              ...prev.forms,
              [activeFormId]: {
                ...prev.forms[activeFormId],
                frequencyValue: selectedDates,
              }
            }
          }));
        }}
        minDates={1}
        isViewOnly={false}
        title="Select Custom Assessment Dates"
        frequencyType="CUSTOM"
      />

      {/* Add the View Calendar Drawer */}
      <CustomDateCalendarDrawer
        visible={showViewCalendar}
        onClose={() => setShowViewCalendar(false)}
        startDate={viewCalendarData?.startDate}
        endDate={viewCalendarData?.endDate}
        selectedDates={viewCalendarData?.scheduledDates || []}
        onDatesChange={() => {
          // This is view-only, so no changes allowed
        }}
        minDates={0}
        isViewOnly={true}
        title="Assessment Calendar View"
        frequencyType={viewCalendarData?.frequencyType}
        scheduledDates={viewCalendarData?.scheduledDates || []}
        isEmpty={viewCalendarData?.isEmpty}
      />
    </MainContainer>
  )

}

export { expandSectionsForBackend }
export default AssessmentSelect
